// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/animate.css/animate.compat.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/react-photo-view/dist/react-photo-view.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/bootstrap-daterangepicker/daterangepicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/sweetalert2/dist/sweetalert2.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/img/bg-main-1-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/img/bg-main-2-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/img/bg-main-3-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/img/bg-main-4-parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/img/img-part-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/img/about-us-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/img/about-us-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/img/about-us-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/img/bg-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/img/image11.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/img/bg-thanks.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fade-in-text {
  animation: fadeIn 1s;
}

.hover-zoom {
  transition: transform 0.25s, visibility 0.25s ease-in;
}
.hover-zoom:hover {
  transform: scale(1.07);
}

.hover-zoom-big {
  transition: transform 0.25s, visibility 0.25s ease-in;
}
.hover-zoom-big:hover {
  transform: scale(1.3);
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.hover-rotate:hover {
  animation: rotation 7s infinite linear;
}

/* GLITCH */
.glitch {
  transform: translate(4.5em, 3em);
  animation: glitch-animate 3s infinite;
}

@keyframes glitch-animate {
  0%, 26%, 30%, 72%, 76%, 100% {
    transform: translate(0em, 0em) skew(0deg);
    box-shadow: none;
  }
  30%, 70% {
    transform: translate(0em, 0em) skew(30deg);
  }
  29%, 31%, 69%, 71% {
    transform: translate(0em, 0em) skew(0deg);
  }
  28%, 74% {
    box-shadow: -0.2em 0.1em 0 0 cyan, 0.2em -0.1em 0 0 magenta;
  }
}
.glitch:after {
  animation: glitch-animate-after 3s infinite;
}

@keyframes glitch-animate-after {
  0%, 34%, 38%, 46%, 50%, 100% {
    transform: translate(0, 1em);
    box-shadow: none;
  }
  36%, 48% {
    transform: translate(0.4em, 0em);
    box-shadow: -1em 0 0 0 cyan, 1em 0 0 0 magenta, 0.5em 1em 0 -0.8em cyan;
  }
}
.glitch:before {
  transform: translate(0em, 3em);
  animation: glitch-animate-before 3s infinite;
}

@keyframes glitch-animate-before {
  0%, 30%, 34%, 50%, 54%, 100% {
    transform: translate(0, 0);
    box-shadow: none;
  }
  32%, 52% {
    transform: translate(-0.4em, 1em);
    box-shadow: -0.3em 0 0 0 red, 0.3em 0 0 0 yellow;
  }
}
/* END GLITCH */
/* PERSPECTIVE */
.perspec-back {
  animation: perspec-back 3s linear infinite;
}

@keyframes perspec-back {
  0%, 100% {
    transform: translate(4em, 0);
  }
  25% {
    transform: translate(3.4em, 0);
  }
  50% {
    transform: translate(1em, 0.6em);
  }
  75% {
    transform: translate(3em, 0.6em);
  }
}
.perspec-middle {
  animation: perspec-middle 3s linear infinite;
}

@keyframes perspec-middle {
  0%, 100% {
    transform: translate(-1em, 0.4em);
  }
  25% {
    transform: translate(1em, 0.4em);
  }
  50% {
    transform: translate(0em, 1.2em);
  }
  75% {
    transform: translate(1em, 1.2em);
  }
}
.perspec-front {
  animation: perspec-front 3s linear infinite;
}

@keyframes perspec-front {
  0%, 100% {
    transform: translate(6.5em, 1em);
  }
  25% {
    transform: translate(7.5em, 1em);
  }
  50% {
    transform: translate(7.5em, 2em);
  }
  75% {
    transform: translate(6.5em, 2em);
  }
}
/* END PERSPECTIVE */
* {
  font-family: "Red Hat Display", sans-serif;
}

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(49, 53, 59, 0.8117647059);
  overscroll-behavior: none;
  width: 100vw;
  overflow-x: hidden;
}

ul {
  padding-left: 1rem;
}

.main-layout-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main-layout-container--interview {
  min-height: 100vh;
  overflow: hidden;
  background: #0a0c12;
}

.text-brand {
  color: #12b7ad;
}

.text-brand2 {
  color: #F7C154;
}

.text-right {
  text-align: right;
}

.form-check-input:checked {
  background-color: #12b7ad;
  border-color: #12b7ad;
}

.form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(18, 183, 173, 0.25);
}

.header {
  font-weight: 900;
  font-size: 2rem;
  line-height: 2.7rem;
}

.subheader {
  font-weight: 600;
  font-size: 1.6rem;
}

.title {
  font-weight: 400;
  font-size: 1.2rem;
}

.text-inactive {
  color: #a0a9b1 !important;
}

.css-t3ipsp-control {
  box-shadow: none !important;
  border-color: #12b7ad !important;
}

.css-t3ipsp-control:hover {
  border-color: #12b7ad !important;
}

.pointer {
  cursor: pointer;
}

.btn-brand {
  background-color: #12b7ad !important;
  color: white !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.btn-outline-brand {
  border-color: #12b7ad !important;
  color: #12b7ad !important;
  padding-left: 25px !important;
  padding-right: 25px !important;
}

.btn-scroll-wrap {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 2;
  width: auto;
  height: auto;
}
.btn-scroll-wrap .btn-scroll {
  cursor: pointer;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  text-align: center;
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  -webkit-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  -moz-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.4);
  margin: auto;
  margin-bottom: 5px;
  position: relative;
}
.btn-scroll-wrap .btn-scroll svg {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #12b7ad;
}
.btn-scroll-wrap .txt {
  font-size: 0.7rem;
  color: #5C5C5C;
  text-align: center;
}

.outlet-wrapper {
  padding-top: 106px;
  flex: 1 1 auto;
}
.outlet-wrapper--interview {
  padding-top: 0;
  min-height: 100vh;
}
.outlet-wrapper--interview-fullscreen {
  overflow: hidden;
  background: #0a0c12;
}

@keyframes logoNav {
  0% {
    height: 80px;
  }
  100% {
    height: 40px;
  }
}
@keyframes logoNavIddle {
  0% {
    height: 40px;
  }
  100% {
    height: 80px;
  }
}
.navbar {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(9.7px);
  -webkit-backdrop-filter: blur(9.7px);
}
.navbar .logo {
  height: 80px;
}
.navbar .nav-link {
  font-weight: 600;
  font-weight: bold;
  color: rgba(52, 58, 64, 0.9019607843);
}
.navbar .nav-link:hover {
  color: #12b7ad;
}
.navbar .nav-link.active {
  color: #12b7ad;
}
.navbar .btn-login {
  background-color: #12b7ad !important;
  color: #fff !important;
  padding: 6px 18px !important;
  border-radius: 8px;
  font-weight: 600;
  margin-left: 10px;
}
.navbar .btn-login:hover {
  background-color: #0e928a !important;
  color: #fff !important;
}
.navbar .navbar-toggler {
  padding: 10px;
}

.naviddle .navbar .logo {
  animation-duration: 0.5s;
  animation-name: logoNavIddle;
  animation-timing-function: ease-out;
  height: 80px;
}

.navresize .navbar {
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.navresize .navbar .logo {
  animation-duration: 0.5s;
  animation-name: logoNav;
  animation-timing-function: ease-out;
  height: 40px;
}

.profile-menu-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.profile-menu-wrapper .profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #12b7ad;
  transition: all 0.3s ease;
}
.profile-menu-wrapper .profile-picture:hover {
  box-shadow: 0 2px 8px rgba(18, 183, 173, 0.3);
  transform: scale(1.05);
}
.profile-menu-wrapper .profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  margin-top: 8px;
  z-index: 1000;
  animation: slideDown 0.3s ease-out;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  color: #333;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px 8px 0 0;
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item:hover {
  background-color: #f0fffe;
  color: #12b7ad;
}
.profile-menu-wrapper .profile-dropdown .profile-dropdown__item svg {
  width: 18px;
  height: 18px;
}
.profile-menu-wrapper .profile-dropdown .logout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  color: #ff6b6b;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}
.profile-menu-wrapper .profile-dropdown .logout-btn:hover {
  background-color: #fff5f5;
  color: #ff5252;
}
.profile-menu-wrapper .profile-dropdown .logout-btn svg {
  width: 18px;
  height: 18px;
}

.main-content, .talent-content {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.main-content .main-parallax-1, .talent-content .main-parallax-1 {
  position: absolute;
  bottom: -30px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 0;
}
.main-content .main-parallax-2, .talent-content .main-parallax-2 {
  position: absolute;
  bottom: 30px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}
.main-content .main-parallax-3, .talent-content .main-parallax-3 {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
}
.main-content .content-wrapper, .talent-content .content-wrapper {
  max-width: 550px;
  z-index: 2;
}
.main-content .content-wrapper .subtitle, .talent-content .content-wrapper .subtitle {
  font-weight: 900;
  color: #F7C154;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.main-content .content-wrapper .title, .talent-content .content-wrapper .title {
  font-weight: 900;
  color: #12b7ad;
  font-size: 2.6rem;
  margin-top: 15px;
  line-height: 2.8rem;
}
.main-content .content-wrapper .desc, .talent-content .content-wrapper .desc {
  margin-top: 15px;
  font-size: 1rem;
  font-weight: 600;
}

.talent-content {
  height: 70vh;
}
.talent-content .main-parallax-4 {
  position: absolute;
  bottom: -100px;
  right: 0px;
  width: 550px;
  height: 550px;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
}
.talent-content .main-parallax-2 {
  bottom: -100px;
}

.bg-brand-opacity {
  background-color: #f1faf9;
}

.bg-brand {
  background-color: #12b7ad;
}

.text-wrap {
  text-wrap: wrap !important;
}

.flex-1 {
  min-width: 0;
  flex: 1 1 !important;
}

.card {
  border: 1px solid #eee;
}
.card.no-border {
  border-width: 0px !important;
}

.shadow {
  box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
  -webkit-box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
  -moz-box-shadow: -3px 3px 28px -4px rgba(148, 148, 148, 0.4) !important;
}

.slick-track,
.slick-list {
  width: 100%;
  min-width: 100%;
}

.slick-dots li button::before {
  font-size: 18px;
}

.slick-dots li.slick-active button::before {
  color: #12b7ad;
}

.about-us {
  position: relative;
  z-index: 2;
}
.about-us::after {
  content: "";
  width: 200px;
  height: 140px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
}
.about-us .about-us-image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
.about-us .about-us-parallax-1 {
  position: absolute;
  top: 0;
  left: -30px;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 0;
}
.about-us .about-us-parallax-2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
}
.about-us .about-us-parallax-3 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
}

.talent-list-wrapper {
  position: relative;
  z-index: 2;
  background-color: #f1faf9;
}

.talent-list img {
  width: 30%;
  height: 30%;
  border-radius: 10px;
  object-fit: cover;
}

input:focus, textarea:focus {
  border-color: #12b7ad !important;
  box-shadow: none !important;
  outline: none !important;
}

.daterangepicker td.in-range {
  background-color: #cce8e6 !important;
}

.daterangepicker td.available {
  color: #0f172a;
  font-weight: 600;
  transition: background-color 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.daterangepicker td.available:hover {
  background-color: rgba(46, 196, 182, 0.14) !important;
  color: #12b7ad !important;
  box-shadow: inset 0 0 0 1px rgba(46, 196, 182, 0.28);
}

.daterangepicker td.off.disabled,
.daterangepicker td.disabled,
.daterangepicker option.disabled {
  color: #c3cdd8 !important;
  background-color: #fff !important;
  text-decoration: none !important;
  opacity: 1;
  cursor: not-allowed;
}

.daterangepicker .drp-buttons .btn-primary {
  background-color: #12b7ad;
  border-color: #12b7ad;
}

.daterangepicker td.active {
  background-color: #12b7ad !important;
  color: #fff !important;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(46, 196, 182, 0.24);
}

.image-uploader-container {
  width: 100%;
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}
.image-uploader-container .image-uploader-bg {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  background: #cce8e6;
}
.image-uploader-container .image-uploader-bg.singleback {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(34px);
  background: #cce8e6;
}
.image-uploader-container img {
  position: absolute;
  height: 100%;
  width: auto;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.input-tag-wrapper .ReactTags__tags {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.input-tag-wrapper .ReactTags__tagInput {
  flex: 1 1;
}
.input-tag-wrapper .ReactTags__tagInput input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  display: block;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input-tag-wrapper .ReactTags__tagInput input:focus {
  border-color: #12b7ad !important;
  box-shadow: none !important;
  outline: none !important;
}
.input-tag-wrapper .ReactTags__selected {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
.input-tag-wrapper .ReactTags__selected span.ReactTags__tag {
  background: #12b7ad;
  color: white;
  font-size: 12px;
  display: flex;
  padding: 5px;
  border-radius: 3px;
}
.input-tag-wrapper .ReactTags__selected a.ReactTags__remove {
  color: #aaa;
  margin-left: 5px;
  cursor: pointer;
}
.input-tag-wrapper .ReactTags__remove {
  border: none;
  cursor: pointer;
  background: none;
  color: white;
  margin-right: -5px;
}
.input-tag-wrapper .ReactTags__remove svg {
  width: 9px;
  height: 9px;
  margin-top: -3px;
}

.css-1p3m7a8-multiValue {
  background-color: #12b7ad !important;
  color: #fff !important;
}
.css-1p3m7a8-multiValue .css-9jq23d {
  color: #fff !important;
}

.service-list .list {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}
.service-list .list svg {
  width: 1.8rem;
  height: 1.8rem;
  color: #F7C154;
}
.service-list .list .desc {
  font-weight: bold;
  font-size: 1.3rem;
}

.arrow-service {
  width: 40px;
  height: 40px;
  background-color: #12b7ad;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.arrow-service.disabled {
  background-color: #fff;
  border: 2px solid rgba(18, 183, 173, 0.4);
  cursor: default;
}
.arrow-service.disabled svg {
  color: rgba(18, 183, 173, 0.4);
}
.arrow-service svg {
  color: #fff;
  width: 20px;
  height: 20px;
}

.service .bg-service {
  width: 100%;
  position: relative;
}
.service .bg-service::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: -25px;
  height: 150px;
  background-color: #F7C154;
  z-index: -1;
  border-radius: 10px;
}

.product {
  background-color: rgba(247, 193, 84, 0.2);
  border-radius: 20px;
  position: relative;
}
.product .video-parallax-2 {
  position: absolute;
  bottom: 300px;
  right: -100px;
  width: 350px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}
.product .video-parallax-3 {
  position: absolute;
  bottom: 150px;
  left: -180px;
  width: 350px;
  height: 350px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
  z-index: -1;
}

.video-wrapper {
  border-radius: 20px;
  overflow: hidden;
  margin: auto;
}
.video-wrapper video {
  width: 80%;
  border-radius: 20px;
  height: auto;
  overflow: hidden;
}

.partner-list img {
  width: 60%;
  height: 80px;
  object-fit: contain;
  margin: auto;
}

.partner-logo-wrapper {
  height: 80px;
  display: flex;
  justify-content: center;
}
.partner-logo-wrapper img {
  height: 100%;
  width: 60%;
  object-fit: contain;
}

.bg-call-us {
  width: 100%;
  height: 250px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.company-detail {
  margin-top: -150px;
}

.form-detail {
  margin-top: -70px;
}

.for-talent-wrapper {
  background-color: #12b7ad;
  color: #fff;
  overflow: hidden;
}
.for-talent-wrapper hr {
  height: 2px;
  background: #fff !important;
}

.img-for-talent {
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  background-position: center;
}

.footer {
  background-color: #12b7ad;
  border-top: 1px solid #fff;
}
.footer .hr {
  width: 100%;
  height: 1px;
  background-color: #fff;
}
.footer a {
  color: #fff;
}

.thank-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: 50% center;
  background-repeat: no-repeat;
  min-height: 100vh;
  height: auto;
  margin-top: -106px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: clamp(132px, 16vh, 180px) 0 clamp(42px, 7vh, 72px);
}
.thank-container .container {
  width: min(100%, clamp(600px, 42vw, 700px));
  max-width: none;
}

.thank-shell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(16px, 1.8vh, 20px);
  width: 100%;
  max-width: min(100%, 680px);
  margin: 0 auto;
  transform: translateX(clamp(-20px, -1.15vw, -10px));
}
.thank-shell__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(18, 184, 134, 0.12);
  color: #12b7ad;
  font-size: 0.92rem;
  font-weight: 700;
}
.thank-shell__eyebrow svg {
  width: 16px;
  height: 16px;
}
.thank-shell__heading {
  font-size: clamp(2.35rem, 3.4vw, 4rem);
  font-weight: 900;
  line-height: 1.08;
  margin: 0;
  max-width: 100%;
  text-wrap: balance;
}
.thank-shell__subtitle {
  font-size: clamp(1rem, 1.15vw, 1.1rem);
  line-height: 1.65;
  color: #495057;
  max-width: 34rem;
  margin: 0;
  text-wrap: balance;
}
.thank-shell__secondary-cta {
  margin-top: 4px;
  min-width: 220px;
  border-width: 1.5px !important;
  background: rgba(255, 255, 255, 0.82) !important;
}

.thank-next-step-card {
  width: 100%;
  margin-top: 8px;
  padding: clamp(24px, 2.4vw, 30px) clamp(22px, 2.6vw, 30px) clamp(22px, 2.1vw, 26px);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(18, 184, 134, 0.16);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  text-align: left;
}
.thank-next-step-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.12);
  color: #0f9b6c;
  font-size: 0.84rem;
  font-weight: 800;
  margin-bottom: 18px;
}
.thank-next-step-card__header {
  display: flex;
  align-items: flex-start;
  gap: clamp(14px, 1.4vw, 18px);
}
.thank-next-step-card__icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(18, 184, 134, 0.16), rgba(255, 196, 62, 0.18));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #12b7ad;
  flex-shrink: 0;
}
.thank-next-step-card__icon svg {
  width: 24px;
  height: 24px;
}
.thank-next-step-card__copy {
  flex: 1 1;
  min-width: 0;
}
.thank-next-step-card__title {
  font-size: clamp(1.34rem, 1.45vw, 1.52rem);
  font-weight: 800;
  color: #102a43;
  margin-bottom: 8px;
  line-height: 1.22;
}
.thank-next-step-card__description {
  font-size: clamp(0.98rem, 1vw, 1.02rem);
  line-height: 1.65;
  color: #52606d;
  margin: 0;
}
.thank-next-step-card__meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(148px, 1fr));
  gap: 10px;
  margin-top: 22px;
  margin-bottom: 22px;
}
.thank-next-step-card__meta-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 12px 14px;
  border-radius: 16px;
  background: #f8fbfc;
  border: 1px solid rgba(148, 163, 184, 0.18);
  color: #334e68;
  font-size: 0.92rem;
  line-height: 1.45;
}
.thank-next-step-card__meta-item svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #12b7ad;
}
.thank-next-step-card__cta {
  width: 100%;
  min-height: 54px;
  border-radius: 16px !important;
  font-size: 1rem !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 12px 30px rgba(25, 135, 84, 0.2);
}
.thank-next-step-card__cta svg {
  width: 18px;
  height: 18px;
}

.desktop-only {
  display: block;
}

.equal-height-slider .slick-track {
  display: flex;
  align-items: stretch;
}

.equal-height-slider .slick-slide {
  height: inherit;
}

.problemsolve-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch; /* Key property */
  border-radius: 15px;
  overflow: hidden;
}
.problemsolve-wrapper ul {
  font-size: 1.3rem;
}
.problemsolve-wrapper .problem {
  flex: 1 1;
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px 20px;
  line-height: 2.5rem;
}
.problemsolve-wrapper .solve {
  flex: 1.4 1;
  background-color: #d4edda;
  color: #155724;
  padding: 10px 20px 10px 70px;
  line-height: 2.5rem;
}

.bot-wa {
  position: fixed;
  z-index: 9;
  bottom: 6px;
  right: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.bot-wa .img-bot {
  width: 100px;
}
.bot-wa .wa-bubble {
  position: relative;
  background-color: #ffffff;
  padding: 8px 14px;
  border-radius: 30px;
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  -webkit-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  -moz-box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.6);
  font-weight: 800;
  font-size: 15px;
  max-width: 170px;
  line-height: 1.4;
  display: flex;
  flex-direction: row;
  margin-top: -10px;
  align-items: center;
}
.bot-wa .wa-bubble::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -5px;
  width: 12px;
  height: 12px;
  background-color: #ffffff;
  transform: translateY(-50%) rotate(45deg);
  box-shadow: -1px 12px 25px -5px rgba(153, 153, 153, 0.18);
}
.bot-wa .wa-bubble .wa-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}

@media (max-width: 820px) {
  body {
    width: 100%;
  }
  .headerMain .navbar .container {
    width: 100%;
    max-width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }
  .headerMain .navbar .navbar-brand {
    flex: 0 0 auto;
    margin-right: 12px;
  }
  .headerMain .navbar .navbar-toggler {
    flex: 0 0 auto;
    margin-left: auto;
  }
  .bot-wa {
    right: 4px;
    bottom: 4px;
  }
  .bot-wa .wa-bubble {
    display: none;
  }
  .bot-wa .img-bot {
    width: 58px;
    height: auto;
  }
}
@media (max-width: 360px) {
  .headerMain .navbar .container {
    padding-left: 10px;
    padding-right: 10px;
  }
}
/* ==== START MEDIA QUERY ====*/
@media only screen and (min-width: 991px) and (max-width: 1400px) {
  .main-parallax-1 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .main-parallax-2 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .main-parallax-3 {
    width: 39vw !important;
    height: 39vw !important;
  }
  .content-wrapper {
    max-width: 40vw !important;
  }
  .app-talent.container {
    max-width: 100%;
    margin-left: 3rem;
  }
}
@media only screen and (max-width: 991px) {
  .navbar .logo {
    height: 50px !important;
  }
  .desktop-only {
    display: none !important;
  }
  .main-parallax-1 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .main-parallax-2 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .main-parallax-3 {
    width: 500px !important;
    height: 500px !important;
    right: -220px !important;
  }
  .content-wrapper {
    max-width: 50vw !important;
  }
  .video-wrapper video {
    width: 100%;
    height: auto;
  }
  .video-parallax-2 {
    right: -180px !important;
    width: 300px !important;
    height: 300px !important;
  }
  .video-parallax-3 {
    left: -280px !important;
    width: 350px !important;
    height: 350px !important;
  }
}
@media (max-height: 860px) and (min-width: 1024px) {
  .thank-container {
    padding-top: 116px;
    padding-bottom: 36px;
  }
  .thank-shell {
    gap: 14px;
  }
  .thank-shell__heading {
    font-size: clamp(2.15rem, 3vw, 3.2rem);
  }
  .thank-shell__subtitle {
    line-height: 1.58;
  }
  .thank-next-step-card {
    padding: 22px 22px 20px;
  }
  .thank-next-step-card__meta {
    margin-top: 18px;
    margin-bottom: 18px;
  }
}
@media only screen and (max-width: 768px) {
  .thank-container {
    min-height: 100vh;
    height: auto;
    padding: 120px 0 32px;
    background-position: center top;
  }
  .thank-container .container {
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
  .thank-shell {
    gap: 14px;
    transform: none;
  }
  .thank-shell__heading {
    font-size: 1.95rem;
    line-height: 1.18;
  }
  .thank-shell__subtitle {
    font-size: 1rem;
    line-height: 1.6;
  }
  .thank-shell__secondary-cta {
    width: 100%;
    min-height: 48px;
  }
  .thank-next-step-card {
    padding: 22px 18px 18px;
    border-radius: 20px;
  }
  .thank-next-step-card__header {
    gap: 14px;
  }
  .thank-next-step-card__icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
  }
  .thank-next-step-card__title {
    font-size: 1.22rem;
  }
  .thank-next-step-card__description {
    font-size: 0.96rem;
    line-height: 1.62;
  }
  .thank-next-step-card__meta {
    grid-template-columns: 1fr;
    gap: 8px;
    margin-top: 18px;
    margin-bottom: 18px;
  }
  .thank-next-step-card__meta-item {
    min-height: 0;
  }
  .thank-next-step-card__cta {
    min-height: 50px;
  }
  .text-center-mobile {
    text-align: center;
  }
  .desktop-only {
    display: none !important;
  }
  .main-content .title {
    font-size: 1.5rem !important;
    line-height: 1.8rem !important;
  }
  .main-parallax-1 {
    right: -250px !important;
    transform: scaleX(-1) !important;
  }
  .main-parallax-2, .main-parallax-3 {
    right: -350px !important;
    transform: scaleX(-1) !important;
  }
  .talent-content .content-wrapper {
    max-width: 70vw !important;
  }
  .talent-content .main-parallax-4 {
    right: -220px !important;
    transform: scaleX(-1) !important;
  }
  .video-wrapper video {
    width: 100%;
    height: auto;
  }
  .for-talent-wrapper .ms-5 {
    margin-left: 0px !important;
  }
  .form-detail {
    margin-top: 40px;
  }
}
/* ── Interview Feature Styles ──────────────────────────────── */
/* Shared button utilities */
.iv-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
  font-size: 0.95rem;
}
.iv-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.iv-btn--primary {
  background: #059669;
  color: #fff;
}
.iv-btn--success {
  background: #059669;
  color: #fff;
}
.iv-btn--outline {
  background: transparent;
  color: #059669;
  border: 2px solid #059669;
}
.iv-btn--ghost {
  background: transparent;
  color: #6B7280;
}
.iv-btn--sm {
  padding: 8px 18px;
  font-size: 0.85rem;
}
.iv-btn--lg {
  padding: 14px 32px;
  font-size: 1.05rem;
}

/* ── ProgressBar ── */
.iv-progress {
  margin: 12px 0;
}
.iv-progress__labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #6B7280;
  margin-bottom: 4px;
}
.iv-progress__track {
  height: 8px;
  background: #E5E7EB;
  border-radius: 99px;
  overflow: hidden;
}
.iv-progress__fill {
  height: 100%;
  background: linear-gradient(90deg, #7C3AED, #5B21B6);
  border-radius: 99px;
  transition: width 0.4s ease;
}

/* ── QuestionCard ── */
.iv-question-card {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 20px;
}
.iv-question-card__meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.iv-question-card__counter {
  font-size: 0.8rem;
  font-weight: 600;
  background: #EDE9FE;
  color: #5B21B6;
  padding: 2px 10px;
  border-radius: 99px;
}
.iv-question-card__followup-label {
  font-size: 0.8rem;
  font-weight: 600;
  background: #FEF3C7;
  color: #92400E;
  padding: 2px 10px;
  border-radius: 99px;
}
.iv-question-card__category {
  font-size: 0.8rem;
  padding: 2px 10px;
  border-radius: 99px;
  font-weight: 500;
}
.iv-question-card__category--technical {
  background: #DBEAFE;
  color: #1E40AF;
}
.iv-question-card__category--communication {
  background: #D1FAE5;
  color: #065F46;
}
.iv-question-card__category--problem_solving {
  background: #FCE7F3;
  color: #9D174D;
}
.iv-question-card__text {
  font-size: 1.05rem;
  font-weight: 500;
  color: #111827;
  line-height: 1.6;
  margin: 0;
}

/* ── CameraPlaceholder ── */
.iv-camera {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #1a1f2e;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
.iv-camera__video-wrap {
  position: relative;
  width: 100%;
}
.iv-camera__video {
  width: 100%;
  display: block;
  object-fit: cover;
  border-radius: 12px;
  transform: scaleX(-1); /* mirror like selfie cam */
}
.iv-camera__live-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 99px;
  letter-spacing: 0.05em;
}
.iv-camera__placeholder {
  text-align: center;
  color: #9CA3AF;
  padding: 24px;
}
.iv-camera__placeholder p {
  margin: 0;
  font-size: 0.9rem;
}
.iv-camera__icon {
  font-size: 2.5rem;
  margin-bottom: 8px;
}
.iv-camera__error {
  padding: 16px;
  text-align: center;
  color: #FCA5A5;
  font-size: 0.85rem;
}

/* ── ScoreCard ── */
.iv-score-card {
  padding: 18px 18px 16px;
  border-radius: 20px;
  border: 1px solid #e5edf5;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbfe 100%);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}
.iv-score-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 12px;
}
.iv-score-card__copy {
  display: grid;
  gap: 4px;
}
.iv-score-card__label {
  font-size: 0.95rem;
  color: #0f172a;
  font-weight: 700;
  line-height: 1.4;
}
.iv-score-card__tone {
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.2;
}
.iv-score-card__value {
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1;
}
.iv-score-card__track {
  height: 10px;
  background: #e2e8f0;
  border-radius: 99px;
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.08);
}
.iv-score-card__fill {
  height: 100%;
  border-radius: 99px;
  transition: width 0.5s ease;
}
.iv-score-card--brand .iv-score-card__tone {
  color: #0f766e;
}
.iv-score-card--brand .iv-score-card__value {
  color: #0f766e;
}
.iv-score-card--brand .iv-score-card__fill {
  background: #12b7ad;
}
.iv-score-card--brand.iv-score-card--average .iv-score-card__tone {
  color: #b45309;
}
.iv-score-card--brand.iv-score-card--average .iv-score-card__fill {
  background: #F7C154;
}
.iv-score-card--brand.iv-score-card--weak .iv-score-card__tone,
.iv-score-card--brand.iv-score-card--weak .iv-score-card__value {
  color: #64748b;
}
.iv-score-card--brand.iv-score-card--weak .iv-score-card__fill {
  background: linear-gradient(90deg, rgba(18, 183, 173, 0.42) 0%, rgba(18, 183, 173, 0.72) 100%);
}
.iv-score-card__footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 700;
}

/* ── StatusBadge ── */
.iv-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 99px;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}
.iv-badge__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
}
.iv-badge--strong {
  background: rgba(18, 183, 173, 0.1);
  color: #0f766e;
  border-color: rgba(18, 183, 173, 0.26);
}
.iv-badge--average {
  background: rgba(247, 193, 84, 0.2);
  color: #9a6a10;
  border-color: rgba(247, 193, 84, 0.5);
}
.iv-badge--weak {
  background: #fff7ed;
  color: #9a3412;
  border-color: #fed7aa;
}

/* ── InterviewEntry page ── */
.iv-entry {
  min-height: calc(100vh - 96px);
  padding: 30px 28px 42px;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  transition: background 360ms ease, padding 360ms ease;
}
.iv-entry::before, .iv-entry::after {
  display: none;
}
.iv-entry::before {
  width: min(64vw, 940px);
  height: 300px;
  top: -110px;
  left: -14%;
  border-radius: 0 0 56% 44%/0 0 78% 64%;
  background: linear-gradient(180deg, rgba(250, 205, 95, 0.24), rgba(250, 205, 95, 0.06));
  transform: rotate(-6deg);
  filter: blur(6px);
  opacity: 0.95;
}
.iv-entry::after {
  width: min(60vw, 860px);
  height: 320px;
  right: -18%;
  bottom: -150px;
  border-radius: 52% 48% 0 0/70% 62% 0 0;
  background: linear-gradient(180deg, rgba(31, 180, 181, 0.06), rgba(31, 180, 181, 0.22));
  transform: rotate(7deg);
  filter: blur(8px);
  opacity: 0.96;
}
.iv-entry__shell {
  position: relative;
  z-index: 1;
  width: min(100%, 1680px);
  min-height: calc(100vh - 168px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.iv-entry__shell::before, .iv-entry__shell::after {
  display: none;
}
.iv-entry__shell::before {
  inset: 12% 10% auto;
  height: 220px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(208, 220, 234, 0.22), rgba(208, 220, 234, 0) 72%);
  filter: blur(26px);
}
.iv-entry__shell::after {
  inset: 18% 8% 14%;
  border-radius: 36px;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.48), rgba(255, 255, 255, 0) 70%);
  filter: blur(18px);
  opacity: 0.8;
}
.iv-entry__panel {
  width: 100%;
  position: relative;
  border-radius: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  -webkit-backdrop-filter: none;
          backdrop-filter: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.iv-entry__panel--error {
  max-width: 520px;
  margin: 0 auto;
  min-height: auto;
  text-align: center;
  align-items: center;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #e5edf4;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);
  padding: 32px;
}
.iv-entry__panel--error h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1.75rem;
  font-weight: 800;
}
.iv-entry__panel--error p {
  margin: 0;
  color: #475569;
  line-height: 1.6;
}
.iv-entry__brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  min-width: 0;
}
.iv-entry__brand-link {
  appearance: none;
  border: 0;
  background: transparent;
  border-radius: 10px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease;
}
.iv-entry__brand-link:hover {
  transform: translateY(-1px);
}
.iv-entry__brand-link:focus-visible {
  outline: 2px solid rgba(20, 184, 166, 0.5);
  outline-offset: 4px;
}
.iv-entry__brand-logo {
  width: 38px;
  height: 42px;
  display: block;
  object-fit: contain;
}
.iv-entry__brand-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.iv-entry__brand-copy span {
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.15;
  text-transform: uppercase;
}
.iv-entry__brand-copy strong {
  max-width: min(56vw, 620px);
  color: #0f172a;
  display: block;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iv-entry__layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 430px);
  align-items: center;
  gap: clamp(32px, 5vw, 86px);
}
.iv-entry__preview-card {
  min-width: 0;
}
.iv-entry__video-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: 28px;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(30, 41, 59, 0.86)), linear-gradient(180deg, #111827, #020617);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.14);
}
.iv-entry__video-frame--ready {
  background: #020617;
}
.iv-entry__video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  transform: scaleX(-1);
}
.iv-entry__video-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.96rem;
  font-weight: 700;
}
.iv-entry__video-placeholder svg {
  font-size: 2.2rem;
}
.iv-entry__video-name, .iv-entry__video-live {
  position: absolute;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 0.86rem;
  font-weight: 700;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
}
.iv-entry__video-name {
  left: 20px;
  bottom: 18px;
  padding: 8px 12px;
  background: rgba(15, 23, 42, 0.46);
}
.iv-entry__sound-wave {
  width: 26px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.iv-entry__sound-wave i {
  display: block;
  width: 3px;
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.52);
  transition: background 160ms ease, height 160ms ease;
}
.iv-entry__sound-wave--active i {
  background: #86efac;
  animation: iv-entry-wave 0.9s ease-in-out infinite;
}
.iv-entry__sound-wave--active i:nth-child(1) {
  height: 7px;
  animation-delay: 0s;
}
.iv-entry__sound-wave--active i:nth-child(2) {
  height: 14px;
  animation-delay: 0.12s;
}
.iv-entry__sound-wave--active i:nth-child(3) {
  height: 10px;
  animation-delay: 0.24s;
}
.iv-entry__sound-wave--active i:nth-child(4) {
  height: 16px;
  animation-delay: 0.36s;
}
.iv-entry__video-live {
  right: 18px;
  top: 18px;
  padding: 7px 12px;
  background: rgba(15, 23, 42, 0.5);
}
.iv-entry__video-live::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #f59e0b;
}
.iv-entry__video-live--on {
  background: rgba(5, 150, 105, 0.82);
}
.iv-entry__video-live--on::before {
  background: #ffffff;
}
.iv-entry__device-bar {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 10px;
}
.iv-entry__device-pill {
  min-height: 38px;
  border-radius: 12px;
  border: 1px solid #d7dee8;
  background: #ffffff;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 11px;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.035);
  position: relative;
}
.iv-entry__device-pill select {
  appearance: none;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  flex: 1 1;
  font: inherit;
  min-width: 0;
  overflow: hidden;
  padding: 0 18px 0 0;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iv-entry__device-pill select:disabled {
  cursor: default;
  opacity: 1;
}
.iv-entry__device-pill select:focus {
  outline: none;
}
.iv-entry__device-pill svg {
  flex-shrink: 0;
  color: #64748b;
  font-size: 0.98rem;
}
.iv-entry__device-pill--ready {
  color: #334155;
  border-color: #cbd5e1;
  background: #ffffff;
}
.iv-entry__device-pill:focus-within {
  border-color: rgba(20, 184, 166, 0.52);
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.12);
}
.iv-entry__device-chevron {
  position: absolute;
  right: 11px;
  pointer-events: none;
}
.iv-entry__join-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.iv-entry__panel-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 13px;
}
.iv-entry__eyebrow {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(12, 148, 136, 0.08);
  border: 1px solid rgba(12, 148, 136, 0.14);
  color: #0f766e;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.iv-entry__eyebrow--panel {
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}
.iv-entry__title {
  margin: 0;
  color: #0f172a;
  font-size: clamp(2.05rem, 3vw, 3rem);
  font-weight: 800;
  line-height: 1.04;
  letter-spacing: 0;
}
.iv-entry__subtitle {
  margin: 0;
  max-width: 60ch;
  color: #475569;
  font-size: 1rem;
  line-height: 1.72;
}
.iv-entry__subtitle strong {
  color: #0f172a;
  font-weight: 700;
}
.iv-entry__summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}
.iv-entry__summary-item {
  padding: 12px 13px;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbfd 100%);
  border: 1px solid #e5edf5;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.iv-entry__summary-item strong {
  color: #0f172a;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.4;
}
.iv-entry__summary-label {
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.iv-entry__tips {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
.iv-entry__status-list {
  display: grid;
  gap: 10px;
}
.iv-entry__status-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 13px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e5edf4;
  color: #64748b;
  font-size: 0.93rem;
  font-weight: 700;
}
.iv-entry__status-row svg {
  flex-shrink: 0;
}
.iv-entry__status-row--ready {
  color: #047857;
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.iv-entry__tip {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 15px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f8fbfd 100%);
  border: 1px solid #e6edf5;
  color: #334155;
  font-size: 0.96rem;
  line-height: 1.5;
}
.iv-entry__tip-icon {
  width: 44px;
  height: 44px;
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.1), rgba(31, 180, 181, 0.12));
  color: #6d28d9;
  font-size: 1.1rem;
}
.iv-entry__module {
  border-radius: 16px;
  padding: 18px;
  border: 1px solid #e5edf4;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.035);
}
.iv-entry__module--info {
  background: linear-gradient(180deg, rgba(237, 251, 250, 0.78), #ffffff 62%);
}
.iv-entry__module--checking {
  background: linear-gradient(180deg, rgba(241, 245, 249, 0.94), #ffffff 76%);
}
.iv-entry__module--error {
  border-color: #fecaca;
  background: linear-gradient(180deg, rgba(254, 242, 242, 0.92), #ffffff 70%);
}
.iv-entry__module--ready {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.iv-entry__module-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}
.iv-entry__module-icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(31, 180, 181, 0.1);
  color: #0f766e;
  font-size: 1.2rem;
}
.iv-entry__module-icon--error {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}
.iv-entry__module-title {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.iv-entry__module-copy {
  margin: 0;
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.6;
}
.iv-entry__checking {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #475569;
  font-size: 0.96rem;
  font-weight: 600;
}
.iv-entry__ready {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.iv-entry__ready-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 8px 14px;
  border-radius: 999px;
  background: #d1fae5;
  color: #065f46;
  font-size: 0.88rem;
  font-weight: 700;
}
.iv-entry__mic-precheck {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  border-radius: 18px;
  background: #f8fbfd;
  border: 1px solid #e5edf4;
}
.iv-entry__mic-precheck-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #0f172a;
  font-size: 0.96rem;
}
.iv-entry__mic-precheck-head strong {
  font-weight: 700;
}
.iv-entry__mic-precheck-running {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #64748b;
  font-size: 0.84rem;
  font-weight: 600;
}
.iv-entry__mic-precheck-status {
  display: inline-flex;
  width: fit-content;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 700;
}
.iv-entry__mic-precheck-status--good {
  background: #d1fae5;
  color: #065f46;
}
.iv-entry__mic-precheck-status--warning {
  background: #fef3c7;
  color: #92400e;
}
.iv-entry__mic-precheck-status--critical {
  background: #fee2e2;
  color: #991b1b;
}
.iv-entry__mic-precheck-tip, .iv-entry__mic-precheck-error, .iv-entry__start-error {
  margin: 0;
  line-height: 1.55;
}
.iv-entry__mic-precheck-tip {
  color: #475569;
  font-size: 0.9rem;
}
.iv-entry__mic-precheck-details summary {
  cursor: pointer;
  color: #475569;
  font-size: 0.86rem;
  font-weight: 600;
}
.iv-entry__mic-precheck-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  color: #64748b;
  font-size: 0.78rem;
}
.iv-entry__mic-precheck-metrics span {
  background: #ffffff;
  border: 1px solid #dde7f0;
  border-radius: 999px;
  padding: 5px 9px;
}
.iv-entry__mic-precheck-error {
  color: #92400e;
  font-size: 0.88rem;
}
.iv-entry__consent-box {
  background: #f8fafc;
  border: 1px solid #e5edf4;
  border-radius: 18px;
  padding: 16px;
}
.iv-entry__consent-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  cursor: pointer;
}
.iv-entry__consent-input {
  margin-top: 4px;
  accent-color: #059669;
  flex-shrink: 0;
}
.iv-entry__consent-text {
  color: #334155;
  font-size: 0.93rem;
  line-height: 1.6;
}
.iv-entry__start-error {
  color: #b91c1c;
  font-size: 0.9rem;
}
.iv-entry__cta {
  width: 100%;
  justify-content: center;
  gap: 10px;
}
.iv-entry__cta:disabled {
  cursor: not-allowed;
  opacity: 0.58;
  filter: grayscale(0.14);
}
.iv-entry .iv-btn {
  box-shadow: none;
}
.iv-entry .iv-btn--primary,
.iv-entry .iv-btn--success {
  box-shadow: 0 16px 28px rgba(91, 33, 182, 0.16);
}
.iv-entry .iv-btn--outline {
  background: #ffffff;
}

@keyframes iv-entry-wave {
  0%, 100% {
    transform: scaleY(0.55);
  }
  50% {
    transform: scaleY(1);
  }
}
@media (max-width: 840px) {
  .iv-entry {
    padding: 24px 18px 38px;
  }
  .iv-entry__shell {
    min-height: auto;
  }
  .iv-entry__panel {
    padding: 0;
    border-radius: 0;
    gap: 22px;
  }
  .iv-entry__layout {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .iv-entry__join-card {
    max-width: 640px;
    margin: 0 auto;
  }
  .iv-entry__video-frame {
    border-radius: 24px;
  }
  .iv-entry__summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .iv-entry {
    min-height: auto;
    padding: 16px 14px 30px;
  }
  .iv-entry__panel {
    padding: 0;
    border-radius: 0;
    gap: 18px;
  }
  .iv-entry__brand {
    line-height: 1;
  }
  .iv-entry__brand-logo {
    width: 34px;
    height: 38px;
  }
  .iv-entry__brand-copy strong {
    max-width: calc(100vw - 96px);
    font-size: 0.92rem;
  }
  .iv-entry__video-frame {
    border-radius: 18px;
  }
  .iv-entry__video-name, .iv-entry__video-live {
    font-size: 0.78rem;
  }
  .iv-entry__video-name {
    left: 12px;
    bottom: 12px;
  }
  .iv-entry__video-live {
    right: 12px;
    top: 12px;
  }
  .iv-entry__device-bar {
    grid-template-columns: 1fr;
  }
  .iv-entry__device-pill {
    min-height: 38px;
  }
  .iv-entry__title {
    font-size: 1.95rem;
  }
  .iv-entry__subtitle, .iv-entry__module-copy, .iv-entry__consent-text {
    font-size: 0.92rem;
  }
  .iv-entry__tip, .iv-entry__summary-item, .iv-entry__module, .iv-entry__consent-box, .iv-entry__mic-precheck {
    border-radius: 16px;
  }
  .iv-entry__summary {
    grid-template-columns: 1fr;
  }
  .iv-entry__tip {
    padding: 13px 14px;
  }
  .iv-entry__tip-icon, .iv-entry__module-icon {
    width: 40px;
    height: 40px;
    border-radius: 14px;
  }
  .iv-entry__mic-precheck-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .iv-entry__checking {
    font-size: 0.9rem;
  }
  .iv-entry__shell {
    min-height: auto;
  }
}
/* ── InterviewSession — Full-screen video call layout ── */
.iv-fullscreen {
  position: relative;
  --iv-edge: 20px;
  --iv-panel-width: clamp(318px, 24vw, 380px);
  --iv-panel-gap: 12px;
  --iv-bottom-clearance: 72px;
  width: 100%;
  min-height: 100vh;
  background: #3f3f3f;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Mirrored camera as full background */
  /* Camera status badge */
  /* ── Top progress bar ── */
  /* ── Question card (glassmorphism) ── */
  /* AI speaking wave */
  /* ── Bottom controls ── */
  /* Transcript preview bubble */
  /* Text fallback input */
  /* Status hint */
  /* Controls row */
  /* ── Done panel ── */
}
.iv-fullscreen--loading {
  gap: 16px;
  color: #9CA3AF;
}
.iv-fullscreen--loading p {
  margin: 0;
  font-size: 0.95rem;
}
.iv-fullscreen--done .iv-fullscreen__temi-stage {
  box-sizing: border-box;
  padding: 0;
}
.iv-fullscreen--done .avatar-controller {
  width: 104%;
  height: 104%;
}
.iv-fullscreen--done .iv-fullscreen__temi-status {
  bottom: clamp(270px, 34vh, 360px);
}
.iv-fullscreen--done .iv-fullscreen__done-panel {
  position: absolute;
  left: 50%;
  bottom: clamp(34px, 7vh, 74px);
  transform: translateX(-50%);
}
.iv-fullscreen__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
  z-index: 0;
}
.iv-fullscreen__temi-stage {
  position: absolute;
  right: calc(var(--iv-edge) + var(--iv-panel-width) + var(--iv-panel-gap) + 30px);
  bottom: 92px;
  width: clamp(160px, 8.2vw, 128px);
  height: clamp(160px, 8.2vw, 128px);
  z-index: 13;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 20px;
  background: rgba(36, 40, 48, 0.86);
  border: 1px solid rgba(248, 137, 137, 0.18);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.iv-fullscreen__temi-stage::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1), transparent 58%);
  pointer-events: none;
}
.iv-fullscreen__temi-stage .avatar-controller,
.iv-fullscreen__temi-stage .iv-temi {
  width: 80%;
  height: 80%;
  transform: translateY(-6px);
}
.iv-fullscreen__temi-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.055) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: radial-gradient(circle at center, #000 0%, transparent 70%);
  opacity: 0;
}
.iv-fullscreen__temi-orbit {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  animation: iv-temi-orbit 18s linear infinite;
  opacity: 0;
}
.iv-fullscreen__temi-orbit--outer {
  width: min(64vw, 680px);
  height: min(64vw, 680px);
}
.iv-fullscreen__temi-orbit--inner {
  width: min(42vw, 450px);
  height: min(42vw, 450px);
  animation-duration: 12s;
  animation-direction: reverse;
  border-color: rgba(45, 212, 191, 0.18);
}
.iv-fullscreen__temi-status {
  position: absolute;
  left: 50%;
  bottom: 118px;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(4, 13, 22, 0.58);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.86rem;
  font-weight: 650;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.28);
}
.iv-fullscreen__temi-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #2dd4bf;
  box-shadow: 0 0 0 6px rgba(45, 212, 191, 0.14);
  animation: iv-temi-pulse 1.6s ease-in-out infinite;
}
.iv-fullscreen__candidate-pip {
  position: absolute;
  top: var(--iv-edge);
  left: var(--iv-edge);
  right: calc(var(--iv-edge) + var(--iv-panel-width) + var(--iv-panel-gap));
  bottom: var(--iv-bottom-clearance);
  z-index: 1;
  width: auto;
  aspect-ratio: auto;
  border-radius: 16px;
  overflow: hidden;
  background: #111827;
  border: 4px solid rgba(255, 255, 255, 0.88);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4);
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
}
.iv-fullscreen__candidate-pip--recording {
  border-color: rgba(255, 255, 255, 0.96);
  box-shadow: 0 0 0 5px rgba(45, 212, 191, 0.18), 0 24px 70px rgba(0, 0, 0, 0.42);
}
.iv-fullscreen__candidate-pip--speaking {
  border-color: rgba(110, 231, 183, 0.96);
  box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.2), 0 24px 70px rgba(0, 0, 0, 0.42);
}
.iv-fullscreen__candidate-pip--error {
  border-color: rgba(252, 165, 165, 0.8);
}
.iv-fullscreen__conversation-panel {
  position: absolute;
  top: var(--iv-edge);
  right: var(--iv-edge);
  bottom: var(--iv-bottom-clearance);
  z-index: 13;
  width: var(--iv-panel-width);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid rgba(15, 23, 42, 0.12);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.34);
}
.iv-fullscreen__conversation-head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 14px 12px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
}
.iv-fullscreen__conversation-head > div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.iv-fullscreen__conversation-head strong {
  color: #0f172a;
  font-size: 0.98rem;
  line-height: 1.25;
}
.iv-fullscreen__conversation-head span {
  color: #64748b;
  font-size: 0.78rem;
  line-height: 1.35;
}
.iv-fullscreen__conversation-close {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(100, 116, 139, 0.18);
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.iv-fullscreen__conversation-close svg {
  width: 18px;
  height: 18px;
}
.iv-fullscreen__conversation-close:hover {
  background: #f8fafc;
  border-color: rgba(100, 116, 139, 0.32);
  color: #0f172a;
}
.iv-fullscreen__conversation-count {
  flex: 0 0 auto;
  align-self: flex-start;
  padding: 5px 9px;
  border-radius: 999px;
  background: #e0f2fe;
  border: 1px solid #bae6fd;
  color: #0369a1 !important;
  font-size: 0.74rem !important;
  font-weight: 750;
  white-space: nowrap;
}
.iv-fullscreen__conversation-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.4) transparent;
}
.iv-fullscreen__conversation-empty {
  margin: auto 0;
  padding: 18px 14px;
  border-radius: 14px;
  border: 1px dashed rgba(100, 116, 139, 0.28);
  color: #64748b;
  font-size: 0.84rem;
  line-height: 1.55;
  text-align: center;
}
.iv-fullscreen__conversation-turn {
  max-width: 92%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  color: #0f172a;
  background: #eef2f7;
}
.iv-fullscreen__conversation-turn p {
  margin: 0;
  color: #1e293b;
  font-size: 0.86rem;
  line-height: 1.52;
  overflow-wrap: anywhere;
}
.iv-fullscreen__conversation-turn--temi {
  align-self: flex-start;
  border-color: rgba(148, 163, 184, 0.2);
  background: #f1f5f9;
}
.iv-fullscreen__conversation-turn--candidate {
  align-self: flex-end;
  border-color: rgba(18, 183, 173, 0.34);
  background: #12b7ad;
  color: #ffffff;
}
.iv-fullscreen__conversation-turn--candidate p,
.iv-fullscreen__conversation-turn--candidate .iv-fullscreen__conversation-speaker span,
.iv-fullscreen__conversation-turn--candidate .iv-fullscreen__conversation-speaker small {
  color: rgba(255, 255, 255, 0.94);
}
.iv-fullscreen__conversation-turn--system {
  align-self: center;
  max-width: 100%;
  border-color: rgba(124, 58, 237, 0.14);
  background: #f5f3ff;
}
.iv-fullscreen__conversation-turn--processing, .iv-fullscreen__conversation-turn--live {
  border-style: dashed;
}
.iv-fullscreen__conversation-turn--error {
  border-color: rgba(248, 113, 113, 0.38);
  background: #fee2e2;
}
.iv-fullscreen__conversation-speaker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.iv-fullscreen__conversation-speaker span {
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.iv-fullscreen__conversation-speaker small {
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 700;
  white-space: nowrap;
}
.iv-fullscreen .iv-typing-dots {
  min-width: 34px;
  min-height: 20px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.iv-fullscreen .iv-typing-dots i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  opacity: 0.34;
  animation: iv-typing-dot 1s ease-in-out infinite;
}
.iv-fullscreen .iv-typing-dots i:nth-child(2) {
  animation-delay: 0.14s;
}
.iv-fullscreen .iv-typing-dots i:nth-child(3) {
  animation-delay: 0.28s;
}
.iv-fullscreen__self-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
  display: block;
}
.iv-fullscreen__candidate-label {
  position: absolute;
  left: 22px;
  bottom: 22px;
  min-height: 34px;
  padding: 7px 12px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(15, 23, 42, 0.58);
  color: #fff;
  font-size: 0.84rem;
  font-weight: 750;
  letter-spacing: 0.01em;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.iv-fullscreen__job-caption {
  position: absolute;
  left: var(--iv-edge);
  bottom: 30px;
  z-index: 32;
  max-width: min(46vw, 620px);
  display: inline-flex;
  align-items: center;
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 800;
  line-height: 1.25;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.58);
  overflow: hidden;
}
.iv-fullscreen__job-caption span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iv-fullscreen__temi-card-label {
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 12px;
  z-index: 3;
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: rgba(15, 23, 42, 0.66);
  color: #ffffff;
  font-size: 0.84rem;
  font-weight: 800;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}
.iv-fullscreen__cam-status {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #9CA3AF;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}
.iv-fullscreen__cam-status--error {
  color: #FCA5A5;
}
.iv-fullscreen--media-blocked .iv-fullscreen__question-wrap,
.iv-fullscreen--media-blocked .iv-fullscreen__bottom-bar,
.iv-fullscreen--media-blocked .iv-fullscreen__candidate-pip,
.iv-fullscreen--media-blocked .iv-fullscreen__conversation-panel,
.iv-fullscreen--media-blocked .iv-fullscreen__temi-status,
.iv-fullscreen--media-blocked .iv-fullscreen__top-bar {
  opacity: 0.22;
  filter: saturate(0.72);
  transition: opacity 0.2s ease, filter 0.2s ease;
}
.iv-fullscreen--transcript-closed .iv-fullscreen__candidate-pip {
  right: var(--iv-edge);
}
.iv-fullscreen--transcript-closed .iv-fullscreen__temi-stage {
  right: calc(var(--iv-edge) + 8px);
}
.iv-fullscreen--transcript-closed .iv-fullscreen__job-caption {
  max-width: min(62vw, 720px);
}
.iv-fullscreen__media-recovery {
  position: absolute;
  inset: 0;
  z-index: 24;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at center, rgba(15, 23, 42, 0.24), rgba(2, 6, 23, 0.72) 72%), linear-gradient(180deg, rgba(8, 13, 24, 0.18), rgba(8, 13, 24, 0.54));
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  font-size: 0;
  line-height: 0;
  color: transparent;
}
.iv-fullscreen__media-card {
  width: min(92vw, 560px);
  padding: 28px 26px;
  border-radius: 24px;
  background: rgba(8, 13, 24, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.42), 0 0 0 1px rgba(45, 212, 191, 0.06);
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #f8fafc;
  font-size: 1rem;
  line-height: 1.6;
  pointer-events: auto;
}
.iv-fullscreen__media-badge {
  align-self: flex-start;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(45, 212, 191, 0.14);
  border: 1px solid rgba(45, 212, 191, 0.24);
  color: #ccfbf1;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1;
}
.iv-fullscreen__media-title {
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.5rem, 2.8vw, 2rem);
  font-weight: 750;
  line-height: 1.18;
}
.iv-fullscreen__media-copy {
  margin: 0;
  color: rgba(226, 232, 240, 0.86);
  font-size: 0.98rem;
  line-height: 1.7;
}
.iv-fullscreen__media-steps {
  display: grid;
  gap: 12px;
}
.iv-fullscreen__media-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(241, 245, 249, 0.92);
  font-size: 0.94rem;
  line-height: 1.6;
}
.iv-fullscreen__media-step-index {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(124, 58, 237, 0.18);
  border: 1px solid rgba(167, 139, 250, 0.24);
  color: #ddd6fe;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1;
}
.iv-fullscreen__media-error {
  margin: 0;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(127, 29, 29, 0.32);
  border: 1px solid rgba(248, 113, 113, 0.22);
  color: #fecaca;
  font-size: 0.92rem;
  line-height: 1.6;
}
.iv-fullscreen__top-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 0 0 6px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, transparent 100%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px 20px;
}
.iv-fullscreen__progress-track {
  flex: 1 1;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 99px;
  overflow: hidden;
}
.iv-fullscreen__progress-fill {
  height: 100%;
  background: #7C3AED;
  border-radius: 99px;
  transition: width 0.5s ease;
}
.iv-fullscreen__progress-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
}
.iv-fullscreen__question-wrap {
  position: absolute;
  top: clamp(46px, 7vh, 60px);
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, clamp(560px, 47vw, 680px));
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
@media (min-width: 1080px) {
  .iv-fullscreen__temi-stage {
    box-sizing: border-box;
    padding: 0;
  }
  .iv-fullscreen__temi-status {
    left: calc(50% - clamp(175px, 14vw, 225px));
  }
  .iv-fullscreen__question-wrap {
    left: calc(50% - clamp(175px, 14vw, 225px));
    width: min(58vw, 690px);
  }
  .iv-fullscreen__top-bar, .iv-fullscreen__bottom-bar {
    right: calc(var(--iv-panel-width) + var(--iv-edge) + var(--iv-panel-gap));
  }
  .iv-fullscreen--transcript-closed .iv-fullscreen__top-bar,
  .iv-fullscreen--transcript-closed .iv-fullscreen__bottom-bar {
    right: 0;
  }
}
.iv-fullscreen__resume-notice {
  width: 100%;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(8, 13, 24, 0.64);
  border: 1px solid rgba(45, 212, 191, 0.28);
  color: #ccfbf1;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 10px 22px rgba(8, 13, 24, 0.18);
}
.iv-fullscreen__question-card {
  width: 100%;
  background: rgba(15, 15, 25, 0.72);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: clamp(16px, 1.4vw, 18px);
  padding: clamp(16px, 1.8vw, 22px) clamp(18px, 2.2vw, 28px);
  color: #fff;
}
.iv-fullscreen__question-card--compact {
  width: auto;
  align-self: center;
  padding: 10px 13px;
  border-radius: 999px;
  background: rgba(8, 13, 24, 0.58);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.22);
}
.iv-fullscreen__question-card--compact .iv-fullscreen__question-meta {
  margin-bottom: 0;
}
.iv-fullscreen__question-card--compact .iv-fullscreen__ai-speaking {
  margin-top: 8px;
  padding-top: 8px;
}
.iv-fullscreen__question-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: clamp(10px, 1vw, 12px);
}
.iv-fullscreen__q-index {
  font-size: 0.78rem;
  font-weight: 700;
  background: rgba(124, 58, 237, 0.35);
  border: 1px solid rgba(124, 58, 237, 0.5);
  color: #DDD6FE;
  padding: 3px 11px;
  border-radius: 99px;
}
.iv-fullscreen__q-cat {
  font-size: 0.78rem;
  font-weight: 600;
  padding: 3px 11px;
  border-radius: 99px;
}
.iv-fullscreen__q-cat--technical {
  background: rgba(30, 64, 175, 0.4);
  color: #BFDBFE;
  border: 1px solid rgba(147, 197, 253, 0.3);
}
.iv-fullscreen__q-cat--communication {
  background: rgba(6, 78, 59, 0.4);
  color: #A7F3D0;
  border: 1px solid rgba(110, 231, 183, 0.3);
}
.iv-fullscreen__q-cat--problem_solving {
  background: rgba(157, 23, 77, 0.4);
  color: #FBCFE8;
  border: 1px solid rgba(249, 168, 212, 0.3);
}
.iv-fullscreen__question-text {
  max-width: 62ch;
  font-size: clamp(1rem, 1.08vw, 1.1rem);
  font-weight: 500;
  line-height: 1.58;
  color: #F9FAFB;
  margin: 0;
}
.iv-fullscreen__ai-speaking {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: clamp(10px, 1vw, 14px);
  padding-top: clamp(10px, 0.9vw, 12px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #A78BFA;
  font-size: 0.82rem;
  font-weight: 600;
}
.iv-fullscreen__wave {
  display: inline-block;
  width: 3px;
  border-radius: 99px;
  background: #A78BFA;
  animation: iv-wave 1.2s ease-in-out infinite;
}
.iv-fullscreen__wave:nth-child(1) {
  height: 8px;
  animation-delay: 0s;
}
.iv-fullscreen__wave:nth-child(2) {
  height: 14px;
  animation-delay: 0.15s;
}
.iv-fullscreen__wave:nth-child(3) {
  height: 10px;
  animation-delay: 0.3s;
}
.iv-fullscreen__wave:nth-child(4) {
  height: 6px;
  animation-delay: 0.45s;
}
.iv-fullscreen__bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 32px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.iv-fullscreen__transcript {
  max-width: 660px;
  width: 100%;
  background: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 12px 18px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
  line-height: 1.55;
  text-align: center;
  font-style: italic;
}
.iv-fullscreen__transcript--live {
  border-color: rgba(239, 68, 68, 0.5);
  background: rgba(127, 29, 29, 0.4);
  color: #FEE2E2;
}
.iv-fullscreen__text-input {
  max-width: 660px;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  padding: 12px 16px;
  color: #fff;
  font-size: 0.95rem;
  resize: none;
}
.iv-fullscreen__text-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}
.iv-fullscreen__text-input:focus {
  outline: none;
  border-color: #7C3AED;
}
.iv-fullscreen__hint {
  color: #475569;
  font-size: 0.85rem;
  margin: 0;
  text-align: center;
}
.iv-fullscreen__error {
  color: #b91c1c;
  font-size: 0.85rem;
  margin: 0;
  text-align: center;
}
.iv-fullscreen__controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.iv-fullscreen--ending .iv-fullscreen__candidate-pip {
  border-color: rgba(255, 255, 255, 0.28);
  filter: grayscale(0.9) brightness(0.42);
  transform: scale(0.985);
  transition: filter 420ms ease, transform 420ms ease, border-color 420ms ease;
}
.iv-fullscreen--ending .iv-fullscreen__conversation-panel,
.iv-fullscreen--ending .iv-fullscreen__temi-stage {
  opacity: 0.42;
  filter: saturate(0.7);
  transition: opacity 420ms ease, filter 420ms ease;
}
.iv-fullscreen__ending-overlay {
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at center, rgba(15, 23, 42, 0.18), rgba(2, 6, 23, 0.68) 68%), rgba(2, 6, 23, 0.46);
  color: #ffffff;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: iv-meeting-end 420ms ease both;
}
.iv-fullscreen__ending-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  text-shadow: 0 10px 34px rgba(0, 0, 0, 0.42);
}
.iv-fullscreen__ending-status strong {
  font-size: clamp(1.45rem, 2.6vw, 2rem);
  font-weight: 850;
  line-height: 1.2;
}
.iv-fullscreen__ending-status span {
  color: rgba(226, 232, 240, 0.84);
  font-size: 0.96rem;
  font-weight: 650;
}
.iv-fullscreen__ending-status small {
  max-width: 42ch;
  color: #fecaca;
  font-size: 0.82rem;
  line-height: 1.45;
}
.iv-fullscreen__ending-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 10px rgba(34, 197, 94, 0.14);
  animation: iv-temi-pulse 1.2s ease-in-out infinite;
}
.iv-fullscreen__done-panel {
  position: relative;
  z-index: 10;
  text-align: center;
  background: rgba(15, 15, 25, 0.78);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px 38px;
  max-width: 500px;
  width: 90vw;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.34);
}
.iv-fullscreen__done-panel h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
}
.iv-fullscreen__done-panel p {
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.95rem;
  margin: 0;
}
.iv-fullscreen__done-icon {
  font-size: 2.75rem;
}
.iv-fullscreen--review .iv-fullscreen__temi-stage {
  box-sizing: border-box;
  padding: 0;
}
.iv-fullscreen--review .avatar-controller {
  transform: translateY(-8px);
}
.iv-fullscreen--review .iv-fullscreen__temi-status {
  bottom: clamp(156px, 19vh, 214px);
}
.iv-fullscreen--review .iv-fullscreen__candidate-pip {
  bottom: var(--iv-bottom-clearance);
}
.iv-fullscreen--review .iv-fullscreen__bottom-bar {
  padding: 18px 20px 16px;
  gap: 8px;
  background: linear-gradient(to top, rgba(229, 231, 235, 0.98) 0%, rgba(229, 231, 235, 0.78) 52%, transparent 100%);
}
.iv-fullscreen__quick-actions {
  position: absolute;
  right: var(--iv-edge);
  bottom: 20px;
  z-index: 32;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.iv-fullscreen__quick-btn {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(100, 116, 139, 0.24);
  background: rgba(255, 255, 255, 0.94);
  color: #334155;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.16);
  transition: transform 0.18s ease, border-color 0.18s ease, color 0.18s ease, background 0.18s ease;
}
.iv-fullscreen__quick-btn svg {
  width: 20px;
  height: 20px;
}
.iv-fullscreen__quick-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(18, 183, 173, 0.42);
  color: #0f766e;
  background: #ffffff;
}
.iv-fullscreen__quick-btn--active {
  border-color: rgba(18, 183, 173, 0.48);
  color: #0f766e;
  background: #ecfdf5;
}
.iv-fullscreen__info-modal {
  position: absolute;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.iv-fullscreen__info-card {
  width: min(92vw, 520px);
  max-height: min(78vh, 620px);
  overflow-y: auto;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(100, 116, 139, 0.18);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.28);
}
.iv-fullscreen__info-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 20px 14px;
  border-bottom: 1px solid rgba(100, 116, 139, 0.14);
}
.iv-fullscreen__info-head span {
  display: block;
  margin-bottom: 4px;
  color: #0f766e;
  font-size: 0.76rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.iv-fullscreen__info-head h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1.25rem;
  font-weight: 850;
  line-height: 1.25;
}
.iv-fullscreen__info-close {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(100, 116, 139, 0.18);
  border-radius: 10px;
  background: #f8fafc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.iv-fullscreen__info-close svg {
  width: 18px;
  height: 18px;
}
.iv-fullscreen__info-close:hover {
  color: #0f172a;
  background: #ffffff;
}
.iv-fullscreen__info-body {
  padding: 16px 20px 20px;
  display: grid;
  gap: 10px;
}
.iv-fullscreen__info-body p {
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid rgba(100, 116, 139, 0.12);
  color: #334155;
  font-size: 0.92rem;
  line-height: 1.55;
}
.iv-fullscreen__exit-modal {
  position: absolute;
  inset: 0;
  z-index: 72;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: radial-gradient(circle at center, rgba(15, 23, 42, 0.18), rgba(15, 23, 42, 0.52) 70%), rgba(15, 23, 42, 0.34);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
}
.iv-fullscreen__exit-card {
  width: min(92vw, 540px);
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.34);
  padding: 22px;
  display: grid;
  grid-template-columns: 52px 1fr;
  gap: 16px;
  animation: iv-exit-modal-in 180ms ease both;
}
.iv-fullscreen__exit-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #c2410c;
}
.iv-fullscreen__exit-icon svg {
  width: 24px;
  height: 24px;
}
.iv-fullscreen__exit-content {
  min-width: 0;
}
.iv-fullscreen__exit-content h2 {
  margin: 3px 0 8px;
  color: #0f172a;
  font-size: clamp(1.2rem, 2.4vw, 1.5rem);
  font-weight: 850;
  line-height: 1.2;
}
.iv-fullscreen__exit-content p {
  margin: 0;
  color: #475569;
  font-size: 0.94rem;
  line-height: 1.6;
}
.iv-fullscreen__exit-eyebrow {
  color: #0f766e;
  font-size: 0.75rem;
  font-weight: 850;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.iv-fullscreen__exit-note {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid rgba(100, 116, 139, 0.14);
  color: #334155;
  font-size: 0.84rem;
  line-height: 1.5;
}
.iv-fullscreen__exit-actions {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;
}
.iv-fullscreen__exit-btn {
  min-height: 42px;
  border-radius: 11px;
  padding: 10px 15px;
  border: 1px solid transparent;
  font-size: 0.9rem;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}
.iv-fullscreen__exit-btn:hover {
  transform: translateY(-1px);
}
.iv-fullscreen__exit-btn--stay {
  background: #12b7ad;
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(18, 183, 173, 0.22);
}
.iv-fullscreen__exit-btn--leave {
  background: #ffffff;
  color: #b91c1c;
  border-color: rgba(185, 28, 28, 0.22);
}
.iv-fullscreen__exit-btn--leave:hover {
  background: #fef2f2;
  border-color: rgba(185, 28, 28, 0.34);
}
@media (max-width: 768px) {
  .iv-fullscreen {
    --iv-edge: 12px;
    --iv-panel-width: calc(100vw - 24px);
    --iv-bottom-clearance: 44vh;
  }
  .iv-fullscreen--done .iv-fullscreen__temi-stage {
    padding-bottom: 230px;
  }
  .iv-fullscreen--done .iv-fullscreen__temi-status {
    bottom: 265px;
  }
  .iv-fullscreen--done .iv-fullscreen__done-panel {
    bottom: 24px;
  }
  .iv-fullscreen__done-panel {
    padding: 24px 22px;
    width: min(92vw, 420px);
  }
  .iv-fullscreen__media-recovery {
    padding: 18px;
    align-items: flex-end;
  }
  .iv-fullscreen__media-card {
    width: 100%;
    padding: 22px 18px;
    border-radius: 20px;
    gap: 14px;
  }
}

.iv-temi {
  position: relative;
  z-index: 2;
  width: clamp(260px, 31vw, 430px);
  height: clamp(320px, 39vw, 500px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: iv-temi-float 4.4s ease-in-out infinite;
}
.iv-temi__halo {
  position: absolute;
  width: 94%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%), radial-gradient(circle, rgba(250, 204, 21, 0.12), transparent 72%);
  filter: blur(6px);
  animation: iv-temi-breathe 2.8s ease-in-out infinite;
}
.iv-temi__focus-ring {
  position: absolute;
  width: 82%;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 1px solid rgba(250, 204, 21, 0.22);
  box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.12);
  animation: iv-temi-orbit 18s linear infinite;
}
.iv-temi__rig {
  position: relative;
  z-index: 2;
  width: min(100%, 420px);
  height: min(100%, 420px);
  filter: drop-shadow(0 28px 44px rgba(0, 0, 0, 0.34));
  transform-style: preserve-3d;
}
.iv-temi__fallback, .iv-temi__layer {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}
.iv-temi__fallback {
  opacity: 0;
}
.iv-temi__layer {
  will-change: transform;
}
.iv-temi__layer--left-arm {
  z-index: 1;
}
.iv-temi__layer--body {
  z-index: 2;
}
.iv-temi__layer--right-arm {
  z-index: 3;
}
.iv-temi__layer--head {
  z-index: 4;
}
.iv-temi__mouth-pulse {
  position: absolute;
  z-index: 6;
  left: 45%;
  top: 47%;
  width: 17%;
  height: 10%;
  border-radius: 999px;
  background: radial-gradient(ellipse at center, rgba(250, 204, 21, 0.78), rgba(250, 204, 21, 0.16) 60%, transparent 72%);
  filter: blur(4px);
  mix-blend-mode: screen;
}
.iv-temi__sound-bars {
  position: absolute;
  z-index: 7;
  right: 17%;
  top: 30%;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  padding: 7px 8px;
  border-radius: 999px;
  background: rgba(8, 13, 24, 0.46);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.iv-temi__sound-bars span {
  width: 5px;
  height: 12px;
  border-radius: 999px;
  background: #facc15;
  transform-origin: bottom;
}
.iv-temi__sound-bars span:nth-child(2) {
  height: 20px;
}
.iv-temi__sound-bars span:nth-child(3) {
  height: 15px;
}
.iv-temi__screen-scan {
  position: absolute;
  z-index: 7;
  left: 31%;
  top: 29%;
  width: 38%;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, rgba(167, 139, 250, 0.75), transparent);
  box-shadow: 0 0 16px rgba(167, 139, 250, 0.35);
  mix-blend-mode: screen;
}
.iv-temi__sparkles {
  position: absolute;
  inset: 0;
  z-index: 8;
  pointer-events: none;
}
.iv-temi__sparkles span {
  position: absolute;
  width: 18px;
  height: 18px;
}
.iv-temi__sparkles span::before, .iv-temi__sparkles span::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 18px;
  height: 3px;
  border-radius: 999px;
  background: #34d399;
  transform: translate(-50%, -50%);
}
.iv-temi__sparkles span::after {
  transform: translate(-50%, -50%) rotate(90deg);
}
.iv-temi__sparkles span:nth-child(1) {
  left: 22%;
  top: 24%;
}
.iv-temi__sparkles span:nth-child(2) {
  right: 20%;
  top: 22%;
}
.iv-temi__sparkles span:nth-child(3) {
  right: 16%;
  top: 50%;
}
.iv-temi__warning-mark {
  position: absolute;
  z-index: 8;
  right: 18%;
  top: 27%;
  width: 36px;
  height: 42px;
  border-radius: 16px;
  background: rgba(245, 158, 11, 0.95);
  color: #111827;
  font-size: 1.6rem;
  font-weight: 900;
  line-height: 42px;
  text-align: center;
  box-shadow: 0 0 24px rgba(245, 158, 11, 0.38);
}
.iv-temi__shadow {
  position: absolute;
  z-index: 1;
  bottom: 13%;
  width: 52%;
  height: 34px;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.36), transparent 70%);
  filter: blur(8px);
}
.iv-temi--speaking .iv-temi__halo {
  background: radial-gradient(circle, rgba(250, 204, 21, 0.2), transparent 58%), radial-gradient(circle, rgba(45, 212, 191, 0.14), transparent 72%);
}
.iv-temi--recording .iv-temi__halo {
  background: radial-gradient(circle, rgba(239, 68, 68, 0.2), transparent 62%);
}
.iv-temi--recording .iv-temi__focus-ring {
  border-color: rgba(239, 68, 68, 0.34);
  box-shadow: inset 0 0 44px rgba(239, 68, 68, 0.14);
}
.iv-temi--thinking .iv-temi__halo {
  background: radial-gradient(circle, rgba(124, 58, 237, 0.2), transparent 62%);
}
.iv-temi--success .iv-temi__halo {
  background: radial-gradient(circle, rgba(52, 211, 153, 0.22), transparent 62%);
}
.iv-temi--warning .iv-temi__halo {
  background: radial-gradient(circle, rgba(245, 158, 11, 0.24), transparent 62%);
}

/* ── Conversational turn status ── */
.iv-conversation-turn {
  min-width: 230px;
  min-height: 58px;
  padding: 12px 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #0f172a;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(100, 116, 139, 0.2);
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.iv-conversation-turn__pulse {
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #2dd4bf;
  box-shadow: 0 0 0 7px rgba(45, 212, 191, 0.16);
}
.iv-conversation-turn__pulse::after {
  content: "";
  position: absolute;
  inset: -9px;
  border-radius: inherit;
  border: 1px solid rgba(45, 212, 191, 0.42);
  animation: iv-rec-ring 1.45s ease-out infinite;
}

.iv-conversation-turn__label {
  font-size: 0.9rem;
  font-weight: 750;
  letter-spacing: 0.01em;
}

.iv-conversation-turn--asking {
  border-color: rgba(125, 211, 252, 0.3);
}
.iv-conversation-turn--asking .iv-conversation-turn__pulse {
  background: #38bdf8;
  box-shadow: 0 0 0 7px rgba(56, 189, 248, 0.16);
}

.iv-conversation-turn--speaking {
  border-color: rgba(52, 211, 153, 0.4);
  background: rgba(236, 253, 245, 0.94);
}
.iv-conversation-turn--speaking .iv-conversation-turn__pulse {
  background: #22c55e;
  box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.18);
}

.iv-conversation-turn--ready {
  opacity: 0.78;
}

.iv-soundwave {
  width: 26px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.iv-soundwave i {
  display: block;
  width: 3px;
  height: 5px;
  border-radius: 999px;
  background: #86efac;
}
.iv-soundwave--idle {
  opacity: 0.58;
  gap: 4px;
}
.iv-soundwave--idle i {
  width: 5px;
  height: 5px;
  animation: none;
  background: rgba(134, 239, 172, 0.72);
}
.iv-soundwave--active {
  opacity: 1;
}
.iv-soundwave--active i {
  animation: iv-entry-wave 0.9s ease-in-out infinite;
}
.iv-soundwave--active i:nth-child(1) {
  height: 7px;
  animation-delay: 0s;
}
.iv-soundwave--active i:nth-child(2) {
  height: 14px;
  animation-delay: 0.12s;
}
.iv-soundwave--active i:nth-child(3) {
  height: 10px;
  animation-delay: 0.24s;
}
.iv-soundwave--active i:nth-child(4) {
  height: 16px;
  animation-delay: 0.36s;
}
.iv-soundwave--candidate i {
  background: #67e8f9;
}
.iv-soundwave--candidate.iv-soundwave--idle i {
  background: rgba(103, 232, 249, 0.68);
}

/* ── Big mic button ── */
.iv-mic-big {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #7C3AED;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: transform 0.15s, background 0.2s;
}
.iv-mic-big:hover:not(:disabled) {
  transform: scale(1.08);
}
.iv-mic-big__icon {
  font-size: 1.9rem;
  line-height: 1;
}
.iv-mic-big--recording {
  background: #DC2626;
}
.iv-mic-big--recording::before {
  content: "";
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 2.5px solid rgba(220, 38, 38, 0.55);
  animation: iv-rec-ring 1.5s ease-out infinite;
}
.iv-mic-big__ring {
  position: absolute;
  inset: -12px;
  border-radius: 50%;
  border: 2px solid rgba(220, 38, 38, 0.4);
  animation: iv-rec-ring 1.5s ease-out infinite 0.4s;
}
.iv-mic-big--submitting {
  background: #374151;
  cursor: not-allowed;
}
.iv-mic-big--disabled {
  background: #374151;
  cursor: not-allowed;
  opacity: 0.6;
}
.iv-mic-big:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* ── Transcript review helpers ── */
.iv-fullscreen__transcript-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(620px, 100%);
}

.iv-fullscreen__review-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(15, 23, 42, 0.82);
  box-shadow: 0 18px 36px rgba(2, 6, 23, 0.22);
}
.iv-fullscreen__review-card--ready {
  border-color: rgba(45, 212, 191, 0.28);
  background: linear-gradient(180deg, rgba(11, 31, 42, 0.88) 0%, rgba(15, 23, 42, 0.78) 100%);
}
.iv-fullscreen__review-card--review {
  border-color: rgba(245, 158, 11, 0.38);
  background: linear-gradient(180deg, rgba(88, 52, 16, 0.34) 0%, rgba(15, 23, 42, 0.82) 100%);
}
.iv-fullscreen__review-card--upload {
  border-color: rgba(96, 165, 250, 0.35);
  background: linear-gradient(180deg, rgba(24, 55, 112, 0.34) 0%, rgba(15, 23, 42, 0.82) 100%);
}
.iv-fullscreen__review-card--critical {
  border-color: rgba(248, 113, 113, 0.4);
  background: linear-gradient(180deg, rgba(111, 29, 29, 0.36) 0%, rgba(15, 23, 42, 0.82) 100%);
}

.iv-fullscreen__review-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}
.iv-fullscreen__review-card-head > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.iv-fullscreen__review-card-head strong {
  color: #fff;
  font-size: 0.92rem;
  line-height: 1.35;
}
.iv-fullscreen__review-card-head span {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.8rem;
  line-height: 1.45;
}

.iv-fullscreen__review-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 9px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.14);
  border: 1px solid rgba(16, 185, 129, 0.32);
  color: #BBF7D0;
  font-size: 0.72rem;
  font-weight: 600;
  white-space: nowrap;
}

.iv-fullscreen__review-details {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 8px;
}
.iv-fullscreen__review-details summary {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.75rem;
  font-weight: 600;
  list-style: none;
}
.iv-fullscreen__review-details summary::-webkit-details-marker {
  display: none;
}

.iv-fullscreen__review-details-body {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.iv-fullscreen__review-details-body p {
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.74rem;
  line-height: 1.45;
}

.iv-fullscreen__transcript-warning {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(245, 158, 11, 0.16);
  border: 1px solid rgba(245, 158, 11, 0.35);
  color: #FDE68A;
  border-radius: 14px;
  padding: 12px 14px;
  line-height: 1.45;
}
.iv-fullscreen__transcript-warning strong {
  color: #FFF7ED;
  font-size: 0.92rem;
}
.iv-fullscreen__transcript-warning span {
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.86rem;
}
.iv-fullscreen__transcript-warning small {
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.75rem;
}

.iv-fullscreen__transcript-edit {
  width: min(620px, 100%);
  min-height: 88px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(15, 23, 42, 0.88);
  color: #fff;
  padding: 12px 14px;
  font-size: 0.93rem;
  line-height: 1.55;
  resize: vertical;
  outline: none;
  box-shadow: 0 12px 26px rgba(2, 6, 23, 0.18);
}
.iv-fullscreen__transcript-edit::placeholder {
  color: rgba(255, 255, 255, 0.45);
}
.iv-fullscreen__transcript-edit:focus {
  border-color: rgba(99, 102, 241, 0.7);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18);
}

.iv-fullscreen__transcript-confirm {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: min(620px, 100%);
  padding: 9px 11px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(15, 23, 42, 0.52);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.81rem;
  line-height: 1.5;
}
.iv-fullscreen__transcript-confirm input {
  margin-top: 3px;
  accent-color: #7C3AED;
}
.iv-fullscreen__transcript-confirm span {
  flex: 1 1;
}

.iv-fullscreen__review-helper {
  width: min(620px, 100%);
  margin: -2px 0 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.76rem;
  line-height: 1.45;
  text-align: left;
}

.iv-fullscreen__video-upload-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(620px, 100%);
  padding: 10px 12px;
  border: 1px solid rgba(96, 165, 250, 0.3);
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.78);
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.78rem;
  line-height: 1.45;
}

/* ── Animations ── */
@keyframes iv-wave {
  0%, 100% {
    transform: scaleY(0.5);
    opacity: 0.6;
  }
  50% {
    transform: scaleY(1.4);
    opacity: 1;
  }
}
@keyframes iv-rec-ring {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes iv-typing-dot {
  0%, 80%, 100% {
    opacity: 0.34;
    transform: translateY(0);
  }
  40% {
    opacity: 0.9;
    transform: translateY(-3px);
  }
}
@keyframes iv-temi-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
@keyframes iv-temi-breathe {
  0%, 100% {
    transform: scale(0.98);
    opacity: 0.72;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
}
@keyframes iv-temi-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.75;
  }
  50% {
    transform: scale(1.22);
    opacity: 1;
  }
}
@keyframes iv-temi-orbit {
  from {
    transform: rotate(0deg) scale(1);
  }
  to {
    transform: rotate(360deg) scale(1);
  }
}
@keyframes iv-meeting-end {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes iv-exit-modal-in {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/* ── InterviewResult page ── */
.iv-result {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 48px 24px 64px;
  background: radial-gradient(circle at 12% 12%, rgba(250, 204, 21, 0.12), transparent 24%), radial-gradient(circle at 88% 10%, rgba(45, 212, 191, 0.12), transparent 28%), linear-gradient(180deg, #f8fbff 0%, #f2f7fb 100%);
}
.iv-result--state {
  align-items: center;
  padding: clamp(24px, 6vw, 56px) clamp(14px, 4vw, 24px);
  background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);
}
.iv-result__shell, .iv-result__state-shell {
  width: 100%;
  max-width: 1120px;
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(226, 232, 240, 0.92);
  border-radius: 24px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08), 0 2px 0 rgba(255, 255, 255, 0.9) inset;
  -webkit-backdrop-filter: blur(14px);
          backdrop-filter: blur(14px);
  overflow: hidden;
}
.iv-result__shell {
  padding: 34px 34px 30px;
}
.iv-result__shell::before {
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #12b7ad 0%, #F7C154 100%);
}
.iv-result__state-shell {
  min-height: 320px;
  padding: clamp(28px, 4vw, 42px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
  color: #64748b;
}
.iv-result__state-shell p {
  margin: 0;
  max-width: 42ch;
  line-height: 1.65;
}
.iv-result--state .iv-result__state-shell {
  max-width: 680px;
}
.iv-result__state-shell--loading .spinner-border {
  width: 2.75rem;
  height: 2.75rem;
  color: #12b7ad;
  border-width: 0.22rem;
}
.iv-result__state-shell--processing {
  max-width: 720px;
  min-height: auto;
  align-items: stretch;
  text-align: left;
  padding: clamp(28px, 5vw, 48px);
  gap: 22px;
  border-color: rgba(18, 183, 173, 0.16);
  border-radius: 24px;
  box-shadow: 0 22px 58px rgba(15, 23, 42, 0.08), 0 1px 0 rgba(255, 255, 255, 0.9) inset;
}
.iv-result__processing-icon {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #12b7ad;
  background: linear-gradient(135deg, rgba(18, 183, 173, 0.12), rgba(247, 193, 84, 0.16));
  box-shadow: 0 14px 30px rgba(18, 183, 173, 0.16);
}
.iv-result__processing-icon svg {
  width: 30px;
  height: 30px;
}
.iv-result__processing-icon span {
  position: absolute;
  inset: -7px;
  border-radius: 26px;
  border: 2px solid rgba(18, 183, 173, 0.14);
  border-top-color: #12b7ad;
  animation: iv-result-processing-spin 0.9s linear infinite;
}
.iv-result__processing-copy {
  display: grid;
  gap: 10px;
}
.iv-result__processing-copy h1 {
  margin: 0;
  color: #102a43;
  font-size: clamp(1.55rem, 2.4vw, 2.05rem);
  font-weight: 800;
  line-height: 1.18;
}
.iv-result__processing-copy p {
  max-width: 58ch;
  color: #52606d;
  font-size: clamp(0.98rem, 1.2vw, 1.05rem);
  line-height: 1.65;
}
.iv-result__processing-progress {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #0f172a;
}
.iv-result__processing-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #334e68;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.35;
}
.iv-result__processing-meta strong {
  min-width: 44px;
  text-align: right;
  color: #12b7ad;
  font-size: 1.12rem;
  font-weight: 900;
}
.iv-result__processing-track {
  height: 14px;
  border-radius: 999px;
  overflow: hidden;
  background: #e8eef4;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);
}
.iv-result__processing-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #12b7ad;
  transition: width 260ms ease;
}
.iv-result__processing-status {
  width: 100%;
  max-width: none;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid rgba(18, 183, 173, 0.14);
  background: rgba(18, 183, 173, 0.06);
  color: #334e68;
  font-size: 0.96rem;
  font-weight: 700;
}
.iv-result__state-shell .iv-result__processing-status {
  max-width: none;
}
.iv-result__processing-retry {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  min-height: 42px;
  padding: 0 20px;
  border-radius: 12px;
  border: 1px solid rgba(18, 183, 173, 0.38);
  background: #ffffff;
  color: #12b7ad;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.iv-result__processing-retry svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.iv-result__processing-retry:hover:not(:disabled) {
  background: rgba(18, 183, 173, 0.06);
  border-color: #12b7ad;
  box-shadow: 0 14px 30px rgba(18, 183, 173, 0.16);
  transform: translateY(-1px);
}
.iv-result__processing-retry:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 8px 18px rgba(18, 183, 173, 0.12);
}
.iv-result__processing-retry:focus-visible {
  outline: 3px solid rgba(18, 183, 173, 0.22);
  outline-offset: 3px;
}
.iv-result__processing-retry:disabled {
  opacity: 0.62;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
.iv-result__header {
  margin-bottom: 24px;
}
.iv-result__header-copy {
  display: grid;
  gap: 12px;
}
.iv-result__eyebrow {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(13, 148, 136, 0.08);
  border: 1px solid rgba(13, 148, 136, 0.14);
  color: #0f766e;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.iv-result__header-main {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.iv-result__title {
  font-size: clamp(2rem, 3vw, 2.7rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  color: #0f172a;
  margin: 0;
  line-height: 1.02;
}
.iv-result__meta {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 0.92rem;
  line-height: 1.5;
}
.iv-result__meta strong {
  color: #0f172a;
}
.iv-result__notice {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 22px;
  margin-bottom: 22px;
  border: 1px solid #fed7aa;
  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);
}
.iv-result__notice h3 {
  margin: 0 0 6px;
  font-size: 1rem;
  font-weight: 700;
  color: #9a3412;
}
.iv-result__notice p {
  margin: 0;
  color: #7c2d12;
  line-height: 1.6;
  font-size: 0.92rem;
}
.iv-result__notice-icon {
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 115, 22, 0.12);
  color: #c2410c;
  font-size: 1.15rem;
}
.iv-result__hero {
  display: grid;
  grid-template-columns: minmax(230px, 280px) minmax(0, 1fr);
  gap: 24px;
  align-items: stretch;
  padding: 26px;
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(18, 183, 173, 0.06) 0%, rgba(247, 193, 84, 0.08) 100%), #ffffff;
  border: 1px solid rgba(18, 183, 173, 0.14);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
  margin-bottom: 24px;
}
.iv-result__score-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}
.iv-result__score-orb {
  width: 100%;
  min-height: 192px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(18, 183, 173, 0.1) 0%, rgba(18, 183, 173, 0.03) 100%), #ffffff;
  border: 1px solid rgba(18, 183, 173, 0.16);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
}
.iv-result__score-number {
  font-size: clamp(3.15rem, 5.4vw, 4.15rem);
  font-weight: 850;
  color: #0f766e;
  line-height: 1;
  letter-spacing: -0.05em;
}
.iv-result__score-label {
  margin-top: 8px;
  font-size: 0.82rem;
  color: #52606d;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 800;
}
.iv-result__hero-copy {
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: center;
}
.iv-result__hero-kicker {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #0f766e;
}
.iv-result__hero-title {
  font-size: clamp(1.4rem, 2.5vw, 2rem);
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}
.iv-result__hero-description {
  font-size: 0.98rem;
  color: #475569;
  line-height: 1.7;
  margin: 0;
  max-width: 64ch;
}
.iv-result__hero-meta {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
}
.iv-result__hero-meta-card {
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(18, 183, 173, 0.12);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 108px;
}
.iv-result__hero-meta-icon {
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(18, 183, 173, 0.1);
  color: #0f766e;
  font-size: 1rem;
}
.iv-result__hero-meta-label {
  display: block;
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.iv-result__hero-meta-card strong {
  display: block;
  color: #0f172a;
  font-size: 0.96rem;
  line-height: 1.45;
  margin-top: 2px;
  max-width: 16ch;
}
.iv-result__band {
  padding: 24px 0 0;
  margin-bottom: 26px;
}
.iv-result__band-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 18px;
}
.iv-result__band-header h3 {
  margin: 0 0 6px;
  color: #0f172a;
  font-size: 1.1rem;
  font-weight: 750;
}
.iv-result__band-header p {
  margin: 0;
  color: #64748b;
  font-size: 0.94rem;
  line-height: 1.6;
}
.iv-result__breakdown {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 8px;
}
.iv-result__section {
  padding: 24px 24px 22px;
  border-radius: 20px;
  border: 1px solid #e5edf5;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.04);
  margin-bottom: 22px;
}
.iv-result__section-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 12px;
}
.iv-result__section-head h3 {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 750;
  color: #0f172a;
}
.iv-result__section-head p {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.5;
}
.iv-result__section-icon {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(18, 183, 173, 0.1);
  color: #0f766e;
  font-size: 1rem;
}
.iv-result__section-body {
  font-size: 0.96rem;
  color: #334155;
  line-height: 1.75;
  margin: 0;
}
.iv-result__section--strength {
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);
  border-color: #bbf7d0;
}
.iv-result__section--strength .iv-result__section-icon {
  background: rgba(34, 197, 94, 0.1);
  color: #15803d;
}
.iv-result__section--weakness {
  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);
  border-color: #fed7aa;
}
.iv-result__section--weakness .iv-result__section-icon {
  background: rgba(249, 115, 22, 0.12);
  color: #c2410c;
}
.iv-result__insight-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 2px;
}
.iv-result__insight-grid > *:only-child {
  grid-column: 1/-1;
}
.iv-result__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 26px;
  padding-top: 24px;
  border-top: 1px solid #e5edf5;
}
.iv-result__actions .iv-btn {
  min-height: 44px;
  border-radius: 12px;
  transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}
.iv-result__actions .iv-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}
.iv-result__actions .iv-btn:focus-visible {
  outline: 3px solid rgba(18, 183, 173, 0.18);
  outline-offset: 3px;
}
.iv-result__actions .iv-btn--primary {
  background: #12b7ad;
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(18, 183, 173, 0.18);
}
.iv-result__actions .iv-btn--primary:hover:not(:disabled) {
  background: #0f766e;
  box-shadow: 0 14px 30px rgba(18, 183, 173, 0.2);
}
.iv-result__actions .iv-btn--outline {
  background: #ffffff;
  color: #0f766e;
  border-color: rgba(18, 183, 173, 0.42);
}
.iv-result__actions .iv-btn--outline:hover:not(:disabled) {
  background: rgba(18, 183, 173, 0.06);
  border-color: #12b7ad;
}
@media (max-width: 960px) {
  .iv-result {
    padding: 32px 16px 40px;
  }
  .iv-result--state {
    padding: 28px 16px;
  }
  .iv-result__shell, .iv-result__state-shell {
    max-width: 100%;
  }
  .iv-result__shell {
    padding: 28px 22px 24px;
  }
  .iv-result__hero {
    grid-template-columns: 1fr;
    gap: 22px;
    padding: 22px;
  }
  .iv-result__hero-meta, .iv-result__breakdown, .iv-result__insight-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 640px) {
  .iv-result {
    padding: 18px 12px 28px;
  }
  .iv-result__shell {
    padding: 22px 16px 18px;
    border-radius: 22px;
  }
  .iv-result__state-shell {
    min-height: 220px;
    padding: 22px 18px;
    border-radius: 22px;
  }
  .iv-result__state-shell--processing {
    padding: 24px 18px;
    gap: 18px;
    text-align: center;
    align-items: center;
  }
  .iv-result__processing-icon {
    width: 64px;
    height: 64px;
    border-radius: 20px;
  }
  .iv-result__processing-icon svg {
    width: 27px;
    height: 27px;
  }
  .iv-result__processing-icon span {
    border-radius: 24px;
  }
  .iv-result__processing-copy, .iv-result__processing-progress, .iv-result__processing-status {
    width: 100%;
  }
  .iv-result__processing-copy p {
    max-width: none;
  }
  .iv-result__processing-meta {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 6px 12px;
  }
  .iv-result__processing-meta strong {
    margin-left: auto;
  }
  .iv-result__processing-retry {
    width: 100%;
    min-height: 46px;
  }
  .iv-result__header-main, .iv-result__actions {
    flex-direction: column;
    align-items: stretch;
  }
  .iv-result__hero {
    padding: 18px;
    border-radius: 22px;
  }
  .iv-result__score-orb {
    min-height: 160px;
  }
  .iv-result__score-number {
    font-size: 2.85rem;
  }
  .iv-result__section,
  .iv-result .nsc {
    border-radius: 20px;
  }
  .iv-result__section {
    padding: 18px 16px;
  }
  .iv-result__hero-meta-card {
    padding: 12px 14px;
    min-height: 0;
  }
  .iv-result__actions .iv-btn {
    width: 100%;
  }
}

@keyframes iv-result-processing-spin {
  to {
    transform: rotate(360deg);
  }
}
/* ── InterviewDetail page ── */
.iv-detail {
  width: 100%;
  min-height: 100vh;
  padding: 40px 24px 56px;
  background: linear-gradient(180deg, #f7fbff 0%, #f4f7fb 100%);
  overflow-x: clip;
}
.iv-detail--loading, .iv-detail--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 16px;
  color: #6B7280;
  text-align: center;
}
.iv-detail--loading .spinner-border, .iv-detail--error .spinner-border {
  color: #12b7ad;
}
.iv-detail__page {
  max-width: 1180px;
  margin: 0 auto;
}
.iv-detail__header {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 28px;
}
.iv-detail__headline {
  display: grid;
  gap: 8px;
  min-width: 0;
}
.iv-detail__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
}
.iv-detail__title {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.18;
}
.iv-detail__job-badge {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: min(100%, 420px);
  padding: 7px 12px;
  border-radius: 999px;
  background: #eaf9f7;
  border: 1px solid rgba(18, 183, 173, 0.24);
  color: #0a635e;
  font-size: 0.84rem;
  font-weight: 800;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.iv-detail__timestamp {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  font-size: 0.84rem;
  color: #64748b;
}
.iv-detail__timestamp svg {
  flex: 0 0 auto;
  color: #12b7ad;
}
.iv-detail__timestamp span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.iv-detail__timestamp strong {
  color: #0f172a;
  font-weight: 700;
}
.iv-detail__back-btn, .iv-detail__state-btn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid rgba(18, 183, 173, 0.28);
  background: #ffffff;
  color: #0c7670;
  font-size: 0.94rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.iv-detail__back-btn svg, .iv-detail__state-btn svg {
  flex: 0 0 auto;
  font-size: 1rem;
}
.iv-detail__back-btn:hover, .iv-detail__state-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(18, 183, 173, 0.44);
  color: #095a55;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}
.iv-detail__back-btn:focus-visible, .iv-detail__state-btn:focus-visible {
  outline: none;
  border-color: #12b7ad;
  box-shadow: 0 0 0 4px rgba(18, 183, 173, 0.14);
}
.iv-detail__back-btn:active, .iv-detail__state-btn:active {
  transform: translateY(0);
}
.iv-detail__state-btn {
  min-height: 44px;
}
.iv-detail--error .iv-btn--outline {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 14px;
  border: 1px solid rgba(18, 183, 173, 0.32);
  background: #ffffff;
  color: #0c7670;
  font-weight: 800;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.iv-detail--error .iv-btn--outline:hover {
  transform: translateY(-1px);
  border-color: rgba(18, 183, 173, 0.44);
  color: #095a55;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}
.iv-detail--error .iv-btn--outline:focus-visible {
  outline: none;
  border-color: #12b7ad;
  box-shadow: 0 0 0 4px rgba(18, 183, 173, 0.14);
}
.iv-detail__layout {
  display: grid;
  grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}
.iv-detail__layout--single {
  grid-template-columns: minmax(0, 1fr);
}
.iv-detail__summary-rail {
  position: sticky;
  top: 28px;
  align-self: start;
}
.iv-detail__summary-card {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
  border: 1px solid #dce7ef;
  padding: 24px;
}
.iv-detail__summary-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(18, 183, 173, 0.1);
  border: 1px solid rgba(18, 183, 173, 0.22);
  color: #0b6d67;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 18px;
}
.iv-detail__summary-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}
.iv-detail__summary-score-block {
  display: grid;
  gap: 8px;
}
.iv-detail__final-score-label {
  font-size: 0.84rem;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.iv-detail__final-score {
  font-size: 3.5rem;
  font-weight: 800;
  color: #0d8981;
  line-height: 1;
}
.iv-detail__score-breakdown {
  display: grid;
  gap: 14px;
  padding-top: 18px;
  margin-bottom: 18px;
  border-top: 1px solid #e5e7eb;
}
.iv-detail__score-breakdown .iv-score-card {
  padding: 14px 14px 12px;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}
.iv-detail__score-breakdown .iv-score-card__header {
  margin-bottom: 10px;
}
.iv-detail__score-breakdown .iv-score-card__label {
  font-size: 0.88rem;
}
.iv-detail__score-breakdown .iv-score-card__tone {
  font-size: 0.76rem;
}
.iv-detail__score-breakdown .iv-score-card__value {
  font-size: 1.3rem;
}
.iv-detail__score-breakdown .iv-score-card__track {
  height: 8px;
}
.iv-detail__score-breakdown .iv-score-card__footer {
  margin-top: 10px;
  font-size: 0.72rem;
}
.iv-detail__summary-text {
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.7;
  margin: 0;
}
.iv-detail .iv-badge {
  background: #eaf9f7;
  color: #0a635e;
  border-color: rgba(18, 183, 173, 0.24);
  box-shadow: none;
}
.iv-detail .iv-badge--average {
  background: rgba(18, 183, 173, 0.08);
  color: #0d7f78;
  border-color: rgba(18, 183, 173, 0.18);
}
.iv-detail .iv-badge--weak {
  background: #f8fafc;
  color: #475569;
  border-color: #d9e2ec;
}
.iv-detail__content {
  min-width: 0;
}
.iv-detail__qa-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.iv-detail__qa-item {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border-radius: 18px;
  border: 1px solid #dce7ef;
  padding: 22px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}
.iv-detail__qa-item--open {
  border-color: rgba(18, 183, 173, 0.32);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);
}
.iv-detail__qa-meta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 14px;
}
.iv-detail__qa-type {
  font-size: 0.76rem;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 99px;
  background: #eef2f7;
  color: #475569;
}
.iv-detail__qa-type--main {
  background: #dff8f5;
  color: #0f766e;
}
.iv-detail__qa-type--followup {
  background: #fff4d6;
  color: #b45309;
}
.iv-detail__qa-category {
  font-size: 0.76rem;
  color: #0b6d67;
  background: #eaf9f7;
  border: 1px solid rgba(18, 183, 173, 0.16);
  padding: 5px 10px;
  border-radius: 99px;
  font-weight: 700;
}
.iv-detail__qa-score {
  display: inline-flex;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 700;
  margin-left: auto;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid #d9e2ec;
  background: #f8fafc;
  color: #475569;
}
.iv-detail__qa-score--strong {
  background: rgba(18, 183, 173, 0.12);
  border-color: rgba(18, 183, 173, 0.28);
  color: #0a635e;
}
.iv-detail__qa-score--average {
  background: rgba(18, 183, 173, 0.08);
  border-color: rgba(18, 183, 173, 0.2);
  color: #0d8981;
}
.iv-detail__qa-score--weak, .iv-detail__qa-score--neutral {
  background: #f8fafc;
  border-color: #d9e2ec;
  color: #64748b;
}
.iv-detail__question-text {
  font-size: 1.05rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.5;
  margin: 0 0 14px;
}
.iv-detail__answer-wrap {
  background: #f8fafc;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  padding: 16px;
}
.iv-detail__answer-preview {
  overflow: hidden;
}
.iv-detail__answer-preview:not(.is-open) .iv-detail__answer-text {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.iv-detail__answer-text {
  font-size: 0.95rem;
  color: #374151;
  line-height: 1.75;
  margin: 0;
  white-space: pre-line;
}
.iv-detail__expand-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0c7670;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
}
.iv-detail__expand-btn:hover {
  color: #095a55;
}
.iv-detail__expand-btn:focus-visible {
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 0 4px rgba(18, 183, 173, 0.14);
}
.iv-detail__expand-icon {
  width: 16px;
  height: 16px;
  transform: rotate(0deg);
  transition: transform 180ms ease;
  flex: 0 0 auto;
}
.iv-detail__expand-icon.is-open {
  transform: rotate(180deg);
}
.iv-detail__feedback {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #dde7f1;
  color: #475569;
}
.iv-detail__feedback strong {
  display: block;
  font-size: 0.82rem;
  font-weight: 800;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}
.iv-detail__feedback p {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.7;
}
.iv-detail__no-answer {
  font-size: 0.9rem;
  color: #94a3b8;
  font-style: italic;
  margin: 0;
}
@media (max-width: 1024px) {
  .iv-detail {
    padding: 32px 18px 48px;
  }
  .iv-detail__layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .iv-detail__summary-rail {
    position: static;
  }
}
@media (max-width: 640px) {
  .iv-detail {
    padding: 24px 14px 40px;
  }
  .iv-detail__header {
    gap: 16px;
    margin-bottom: 22px;
  }
  .iv-detail__back-btn {
    min-height: 46px;
    padding: 0 18px;
  }
  .iv-detail__title-row {
    align-items: flex-start;
    gap: 10px;
  }
  .iv-detail__title {
    font-size: 1.5rem;
  }
  .iv-detail__job-badge {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    text-overflow: clip;
  }
  .iv-detail__summary-card, .iv-detail__qa-item {
    padding: 18px;
    border-radius: 18px;
  }
  .iv-detail__summary-top {
    gap: 16px;
  }
  .iv-detail__final-score {
    font-size: 3rem;
  }
  .iv-detail__qa-score {
    margin-left: 0;
  }
  .iv-detail__expand-btn {
    width: 100%;
    justify-content: space-between;
  }
}

/* ── ThankYou interview banner ── */
.thank-interview-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #F5F3FF;
  border: 1.5px solid #C4B5FD;
  border-radius: 12px;
  padding: 16px 20px;
  text-align: left;
  max-width: 460px;
  margin: 0 auto;
}
.thank-interview-banner__icon {
  font-size: 2rem;
}
.thank-interview-banner strong {
  display: block;
  color: #5B21B6;
  margin-bottom: 4px;
}

/* ── NextStepsCard ──────────────────────────────────────────────── */
.nsc {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid #e5edf5;
  border-radius: 24px;
  padding: 26px 24px;
  margin-top: 24px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.04);
}
.nsc__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}
.nsc__eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(18, 183, 173, 0.08);
  border: 1px solid rgba(18, 183, 173, 0.16);
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}
.nsc__heading {
  font-size: 1.18rem;
  font-weight: 760;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.02em;
}
.nsc__panel {
  border-radius: 18px;
  padding: 20px 20px 18px;
  margin-bottom: 16px;
}
.nsc__panel--weak {
  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);
  border: 1px solid #fed7aa;
}
.nsc__panel--strong {
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);
  border: 1px solid #bbf7d0;
}
.nsc__panel-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.nsc__badge {
  font-size: 0.74rem;
  font-weight: 700;
  padding: 5px 11px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.nsc__badge--weak {
  background: #FED7AA;
  color: #9A3412;
}
.nsc__badge--strong {
  background: #BBF7D0;
  color: #14532D;
}
.nsc__category {
  font-size: 0.94rem;
  font-weight: 700;
  color: #334155;
  flex: 1 1;
}
.nsc__score {
  font-size: 1.2rem;
  font-weight: 800;
  color: #0f172a;
}
.nsc__bar-wrap {
  height: 8px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
  margin-bottom: 14px;
}
.nsc__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: #12b7ad;
  transition: width 0.6s ease;
}
.nsc__ai-text {
  font-size: 0.93rem;
  color: #475569;
  line-height: 1.7;
  margin-bottom: 14px;
}
.nsc__tips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.nsc__tip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.9rem;
  color: #334155;
  line-height: 1.6;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(226, 232, 240, 0.9);
}
.nsc__tip-icon {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(247, 193, 84, 0.22);
  color: #9a6a10;
  margin-top: 1px;
}
.nsc__recommendation {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  margin-bottom: 18px;
}
.nsc__recommendation p {
  margin: 0;
  color: #475569;
  font-size: 0.92rem;
  line-height: 1.65;
}
.nsc__recommendation-icon {
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 197, 94, 0.1);
  color: #15803d;
  font-size: 1rem;
  align-self: center;
}
.nsc__actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
.nsc__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 220px;
  padding: 12px 18px;
  border-radius: 14px;
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s, transform 0.1s, border-color 0.2s, background 0.2s;
}
.nsc__btn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}
.nsc__btn:active {
  transform: translateY(0);
}
.nsc__btn:focus-visible {
  outline: 3px solid rgba(18, 183, 173, 0.18);
  outline-offset: 3px;
}
.nsc__btn--retry {
  background: #12b7ad;
  color: #fff;
}
.nsc__btn--browse {
  background: #ffffff;
  color: #0f766e;
  border: 1px solid rgba(18, 183, 173, 0.32);
}

@media (max-width: 640px) {
  .nsc {
    padding: 20px 16px;
  }
  .nsc__panel {
    padding: 18px 16px;
  }
  .nsc__header, .nsc__actions {
    flex-direction: column;
    align-items: stretch;
  }
  .nsc__btn {
    width: 100%;
    min-width: 0;
  }
}
/* ── JobList AI Interview column ── */
.jl-status__th:last-child,
.jl-status__td:last-child {
  min-width: 140px;
}

.jl-iv-btn {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s;
}
.jl-iv-btn--start {
  background: #EDE9FE;
  color: #5B21B6;
}
.jl-iv-btn--resume {
  background: #FEF3C7;
  color: #92400E;
}
.jl-iv-btn--detail {
  background: #F3F4F6;
  color: #374151;
  margin-top: 4px;
}
.jl-iv-btn:hover {
  opacity: 0.8;
}

.jl-iv-result {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.jl-iv-result__score {
  font-size: 1rem;
  font-weight: 800;
  line-height: 1;
}
.jl-iv-result__badge {
  font-size: 0.78rem;
  font-weight: 600;
}

.jl-iv-na {
  color: #9CA3AF;
  font-size: 0.9rem;
}

/* ── AI TEMI Greeting Overlay ─────────────────────────────────────── */
.iv-fullscreen {
  /* small modifier for iv-btn */
}
.iv-fullscreen__greeting {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 12, 18, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.iv-fullscreen__greeting-card {
  background: rgba(15, 15, 28, 0.92);
  border: 1px solid rgba(124, 58, 237, 0.35);
  border-radius: 24px;
  padding: 44px 52px;
  width: min(480px, 90vw);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-shadow: 0 0 60px rgba(124, 58, 237, 0.2);
  animation: greeting-fade-in 0.5s ease;
}
@keyframes greeting-fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.iv-fullscreen__greeting-logo {
  font-size: 3.5rem;
  line-height: 1;
  margin-bottom: 4px;
  filter: drop-shadow(0 0 12px rgba(124, 58, 237, 0.6));
}
.iv-fullscreen__greeting-temi-avatar {
  width: 170px;
  height: 200px;
  position: relative;
  margin: -12px 0 0;
}
.iv-fullscreen__greeting-temi-avatar .avatar-controller {
  width: 100%;
  height: 100%;
}
.iv-fullscreen__greeting-title {
  font-size: 2rem;
  font-weight: 800;
  color: #fff;
  margin: 0;
  letter-spacing: -0.02em;
}
.iv-fullscreen__greeting-temi {
  color: #A78BFA;
  font-style: italic;
}
.iv-fullscreen__greeting-sub {
  font-size: 0.9rem;
  color: #9CA3AF;
  margin: 0 0 8px;
}
.iv-fullscreen__ai-speaking--center {
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: #A78BFA;
  font-size: 0.85rem;
  display: flex;
  margin: 4px 0;
}
.iv-fullscreen .iv-btn--sm {
  padding: 8px 18px;
  font-size: 0.85rem;
}
.iv-fullscreen__transcribing {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #A78BFA;
  font-size: 0.88rem;
  font-weight: 500;
  padding: 8px 0;
  animation: pulse 1.5s ease infinite;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

@media (max-width: 768px) {
  .iv-fullscreen--review .iv-fullscreen__temi-stage {
    padding: 0;
  }
  .iv-fullscreen--review .iv-fullscreen__temi-status {
    bottom: 134px;
  }
  .iv-fullscreen--review .iv-fullscreen__candidate-pip {
    left: 12px;
    right: 12px;
    top: 12px;
    bottom: 44vh;
  }
  .iv-fullscreen--review .iv-fullscreen__bottom-bar {
    padding: 16px 12px 14px;
    gap: 8px;
  }
  .iv-fullscreen__temi-stage {
    right: 18px;
    bottom: calc(44vh + 12px);
    width: 104px;
    height: 108px;
    padding: 0;
    border-radius: 16px;
  }
  .iv-fullscreen__temi-stage .avatar-controller,
  .iv-fullscreen__temi-stage .iv-temi {
    width: 74%;
    height: 74%;
    transform: translateY(-14px);
  }
  .iv-fullscreen__temi-status {
    bottom: 152px;
    max-width: calc(100vw - 32px);
    font-size: 0.78rem;
  }
  .iv-fullscreen__candidate-pip {
    left: 12px;
    right: 12px;
    top: 12px;
    bottom: 44vh;
    width: auto;
    border-radius: 14px;
    border-width: 3px;
  }
  .iv-fullscreen__candidate-label {
    left: 16px;
    bottom: 10px;
    max-width: calc(100% - 146px);
    min-height: 32px;
    padding: 6px 10px;
    gap: 8px;
    font-size: 0.78rem;
  }
  .iv-fullscreen__candidate-label > span:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .iv-fullscreen__candidate-label .iv-soundwave {
    flex: 0 0 auto;
    transform: scale(0.86);
    transform-origin: right center;
  }
  .iv-fullscreen__temi-card-label {
    left: 8px;
    right: 8px;
    bottom: 8px;
    min-height: 28px;
    padding: 5px 8px;
    gap: 6px;
    font-size: 0.74rem;
  }
  .iv-fullscreen__temi-card-label > span:first-child {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .iv-fullscreen__temi-card-label .iv-soundwave {
    flex: 0 0 auto;
    transform: scale(0.78);
    transform-origin: right center;
  }
  .iv-fullscreen__job-caption {
    left: 12px;
    bottom: 28px;
    max-width: calc(100vw - 116px);
    font-size: 0.82rem;
  }
  .iv-fullscreen__conversation-panel {
    left: 12px;
    right: 12px;
    top: auto;
    bottom: 92px;
    width: auto;
    height: 34vh;
    max-height: none;
    border-radius: 14px;
  }
  .iv-fullscreen--transcript-closed .iv-fullscreen__candidate-pip {
    right: 12px;
  }
  .iv-fullscreen--transcript-closed .iv-fullscreen__temi-stage {
    right: 18px;
  }
  .iv-fullscreen__conversation-head {
    padding: 12px 13px 10px;
  }
  .iv-fullscreen__conversation-body {
    padding: 10px;
    gap: 9px;
  }
  .iv-fullscreen__conversation-turn {
    padding: 9px 10px;
  }
  .iv-fullscreen__conversation-turn p {
    font-size: 0.8rem;
    line-height: 1.48;
  }
  .iv-fullscreen__question-wrap {
    top: 50px;
    width: calc(100vw - 24px);
  }
  .iv-fullscreen__question-card {
    padding: 16px 18px;
    border-radius: 16px;
  }
  .iv-fullscreen__question-text {
    font-size: 0.98rem;
    line-height: 1.55;
  }
  .iv-fullscreen__bottom-bar {
    padding: 24px 14px 20px;
  }
  .iv-fullscreen__quick-actions {
    right: 12px;
    bottom: 18px;
    gap: 8px;
  }
  .iv-fullscreen__quick-btn {
    width: 40px;
    height: 40px;
    border-radius: 11px;
  }
  .iv-fullscreen__exit-card {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 18px;
  }
  .iv-fullscreen__exit-icon {
    width: 46px;
    height: 46px;
    border-radius: 13px;
  }
  .iv-fullscreen__exit-actions {
    flex-direction: column;
  }
  .iv-fullscreen__exit-btn {
    width: 100%;
    justify-content: center;
  }
  .avatar-controller {
    width: min(72vw, 300px);
    height: min(92vw, 390px);
  }
  .iv-fullscreen__transcript-wrap,
  .iv-fullscreen__transcript-edit,
  .iv-fullscreen__transcript-confirm,
  .iv-fullscreen__review-helper {
    width: 100%;
  }
}
@media (max-height: 860px) and (min-width: 769px) {
  .iv-fullscreen__question-wrap {
    top: 42px;
    width: min(90vw, 620px);
  }
  .iv-fullscreen__question-card {
    padding: 16px 20px;
  }
  .iv-fullscreen__question-text {
    max-width: 58ch;
    font-size: 1rem;
    line-height: 1.52;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/_transitions.scss","webpack://./src/scss/_theme.scss","webpack://./src/scss/_variables.scss","webpack://./src/scss/interview.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI;IAAK,UAAA;EDWP;ECVE;IAAO,UAAA;EDaT;AACF;ACXE;EACE,oBAAA;ADaJ;;ACVE;EACE,qDAAA;ADaJ;ACXI;EACE,sBAAA;ADaN;;ACTE;EACE,qDAAA;ADYJ;ACVI;EACE,qBAAA;ADYN;;ACRE;EACE;IACE,uBAAA;EDWJ;ECTE;IACE,yBAAA;EDWJ;AACF;ACPI;EACE,sCAAA;ADSN;;ACLE,WAAA;AACA;EACE,gCAAA;EACA,qCAAA;ADQJ;;ACNE;EACE;IAA0B,yCAAA;IAA2C,gBAAA;EDWvE;ECVE;IAAS,0CAAA;EDaX;ECZE;IAAiB,yCAAA;EDenB;ECdE;IAAU,2DACR;EDgBJ;AACF;ACbE;EACE,2CAAA;ADeJ;;ACbE;EACE;IAA0B,4BAAA;IAA6B,gBAAA;EDkBzD;ECjBE;IAAU,gCAAA;IACV,uEACE;EDmBJ;AACF;ACfE;EACE,8BAAA;EACA,4CAAA;ADiBJ;;ACfE;EACE;IAA0B,0BAAA;IAA2B,gBAAA;EDoBvD;ECnBE;IAAU,iCAAA;IACV,gDACE;EDqBJ;AACF;AClBE,eAAA;AAEA,gBAAA;AACA;EACE,0CAAA;ADmBJ;;ACjBE;EACE;IAAU,4BAAA;EDqBZ;ECpBE;IAAM,8BAAA;EDuBR;ECtBE;IAAM,gCAAA;EDyBR;ECxBE;IAAM,gCAAA;ED2BR;AACF;AC1BE;EACE,4CAAA;AD4BJ;;AC1BE;EACE;IAAU,iCAAA;ED8BZ;EC7BE;IAAM,gCAAA;EDgCR;EC/BE;IAAM,gCAAA;EDkCR;ECjCE;IAAM,gCAAA;EDoCR;AACF;ACnCE;EACE,2CAAA;ADqCJ;;ACnCE;EACE;IAAU,gCAAA;EDuCZ;ECtCE;IAAM,gCAAA;EDyCR;ECxCE;IAAM,gCAAA;ED2CR;EC1CE;IAAM,gCAAA;ED6CR;AACF;AC5CE,oBAAA;AC1GF;EACI,0CAAA;AFyJJ;;AEtJA;EACI,SAAA;EACA,mCAAA;EACA,kCAAA;EACA,qCCPS;EDQT,yBAAA;EACA,YAAA;EACA,kBAAA;AFyJJ;;AEtJA;EACI,kBAAA;AFyJJ;;AEtJA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AFyJJ;AEvJI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AFyJR;;AErJA;EACI,cClCU;AH0Ld;;AErJA;EACI,cCrCW;AH6Lf;;AErJA;EACI,iBAAA;AFwJJ;;AEnJA;EACI,yBChDU;EDiDV,qBCjDU;AHuMd;;AEnJA;EACI,kDAAA;AFsJJ;;AEnJA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AFsJJ;;AEnJA;EACI,gBAAA;EACA,iBAAA;AFsJJ;;AEnJA;EACI,gBAAA;EACA,iBAAA;AFsJJ;;AEnJA;EACI,yBAAA;AFsJJ;;AEnJA;EACI,2BAAA;EACA,gCAAA;AFsJJ;;AEnJA;EACI,gCAAA;AFsJJ;;AEnJA;EACI,eAAA;AFsJJ;;AEnJA;EACI,oCAAA;EACA,uBAAA;EACA,6BAAA;EACA,8BAAA;AFsJJ;;AEnJA;EACI,gCAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;AFsJJ;;AEnJA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AFsJJ;AEpJI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wDAAA;EACA,gEAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AFsJR;AEpJQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,cCpIE;AH0Rd;AElJI;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;AFoJR;;AEhJA;EACI,kBAAA;EACA,cAAA;AFmJJ;AEjJI;EACI,cAAA;EACA,iBAAA;AFmJR;AEhJI;EACI,gBAAA;EACA,mBAAA;AFkJR;;AE7IA;EACI;IACI,YAAA;EFgJN;EE9IE;IACI,YAAA;EFgJN;AACF;AE7IA;EACI;IACI,YAAA;EF+IN;EE7IE;IACI,YAAA;EF+IN;AACF;AE5IA;EACI,oCAAA;EACA,4BAAA;EACA,oCAAA;AF8IJ;AE5II;EACI,YAAA;AF8IR;AE3II;EACI,gBAAA;EACA,iBAAA;EACA,qCAAA;AF6IR;AE3IQ;EACI,cChME;AH6Ud;AE1IQ;EACI,cCpME;AHgVd;AExII;EACI,oCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AF0IR;AExIQ;EACI,oCAAA;EACA,sBAAA;AF0IZ;AEtII;EACI,aAAA;AFwIR;;AElIQ;EACI,wBAAA;EACA,4BAAA;EACA,mCAAA;EACA,YAAA;AFqIZ;;AE/HI;EACI,yCAAA;EACA,0CAAA;AFkIR;AEhIQ;EACI,wBAAA;EACA,uBAAA;EACA,mCAAA;EACA,YAAA;AFkIZ;;AE5HA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AF+HJ;AE7HI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AF+HR;AE7HQ;EACI,6CAAA;EACA,sBAAA;AF+HZ;AE3HI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;AF6HR;AE3HQ;EACI;IACI,UAAA;IACA,4BAAA;EF6Hd;EE3HU;IACI,UAAA;IACA,wBAAA;EF6Hd;AACF;AE1HQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;AF4HZ;AE1HY;EACI,yBAAA;EACA,cC/SF;AH2ad;AEzHY;EACI,WAAA;EACA,YAAA;AF2HhB;AEvHQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AFyHZ;AEvHY;EACI,yBAAA;EACA,cAAA;AFyHhB;AEtHY;EACI,WAAA;EACA,YAAA;AFwHhB;;AElHA;EACI,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AFqHJ;AEnHI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,UAAA;AFqHR;AElHI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AFoHR;AEjHI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AFmHR;AEhHI;EACI,gBAAA;EACA,UAAA;AFkHR;AEhHQ;EACI,gBAAA;EACA,cCrYG;EDsYH,iBAAA;EACA,yBAAA;AFkHZ;AE/GQ;EACI,gBAAA;EACA,cC7YE;ED8YF,iBAAA;EACA,gBAAA;EACA,mBAAA;AFiHZ;AE9GQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AFgHZ;;AE3GA;EACI,YAAA;AF8GJ;AE5GI;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AF8GR;AE3GI;EACI,cAAA;AF6GR;;AEzGA;EACI,yBAAA;AF4GJ;;AEzGA;EACI,yBCpbU;AHgiBd;;AEzGA;EACI,0BAAA;AF4GJ;;AEzGA;EACI,YAAA;EACA,oBAAA;AF4GJ;;AEzGA;EACI,sBAAA;AF4GJ;AE1GI;EACI,4BAAA;AF4GR;;AExGA;EACI,kEAAA;EACA,0EAAA;EACA,uEAAA;AF2GJ;;AExGA;;EAEI,WAAA;EACA,eAAA;AF2GJ;;AEtGI;EACI,eAAA;AFyGR;;AEnGI;EACI,cC9dM;AHokBd;;AElGA;EACI,kBAAA;EACA,UAAA;AFqGJ;AEnGI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AFqGR;AElGI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AFoGR;AEjGI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,UAAA;AFmGR;AEhGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AFkGR;AE/FI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;AFiGR;;AE7FA;EACI,kBAAA;EACA,UAAA;EACA,yBAAA;AFgGJ;;AE5FI;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AF+FR;;AE1FI;EACI,gCAAA;EACA,2BAAA;EACA,wBAAA;AF6FR;;AEzFA;EACI,oCAAA;AF4FJ;;AEzFA;EACI,cAAA;EACA,gBAAA;EACA,gFAAA;AF4FJ;;AEzFA;EACI,qDAAA;EACA,yBAAA;EACA,oDAAA;AF4FJ;;AEzFA;;;EAGI,yBAAA;EACA,iCAAA;EACA,gCAAA;EACA,UAAA;EACA,mBAAA;AF4FJ;;AEzFA;EACI,yBChlBU;EDilBV,qBCjlBU;AH6qBd;;AEzFA;EACI,oCAAA;EACA,sBAAA;EACA,gBAAA;EACA,+CAAA;AF4FJ;;AEzFA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AF4FJ;AE1FI;EACI,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBC1mBS;AHssBjB;AEzFQ;EACI,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBClnBK;AH6sBjB;AEvFI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;AFyFR;;AEpFI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFuFR;AEpFI;EACI,SAAA;AFsFR;AEpFQ;EACI,WAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mCAAA;EACA,4BAAA;EACA,2DAAA;EACA,sCAAA;EACA,wEAAA;AFsFZ;AEpFY;EACI,gCAAA;EACA,2BAAA;EACA,wBAAA;AFsFhB;AEhFI;EACI,aAAA;EACA,QAAA;EACA,eAAA;AFkFR;AE/EI;EACI,mBC7qBM;ED8qBN,YAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AFiFR;AE9EI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AFgFR;AE7EI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AF+ER;AE7EQ;EACI,UAAA;EACA,WAAA;EACA,gBAAA;AF+EZ;;AE1EA;EACI,oCAAA;EACA,sBAAA;AF6EJ;AE3EI;EACI,sBAAA;AF6ER;;AExEI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AF2ER;AEzEQ;EACI,aAAA;EACA,cAAA;EACA,cC7tBG;AHwyBf;AExEQ;EACI,iBAAA;EACA,iBAAA;AF0EZ;;AErEA;EACI,WAAA;EACA,YAAA;EACA,yBC3uBU;ED4uBV,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AFwEJ;AEtEI;EACI,sBAAA;EACA,yCAAA;EACA,eAAA;AFwER;AEtEQ;EACI,8BAAA;AFwEZ;AEpEI;EACI,WAAA;EACA,WAAA;EACA,YAAA;AFsER;;AEjEI;EACI,WAAA;EACA,kBAAA;AFoER;AElEQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,yBC9wBG;ED+wBH,WAAA;EACA,mBAAA;AFoEZ;;AE/DA;EACI,yCAAA;EACA,mBAAA;EACA,kBAAA;AFkEJ;AEhEI;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;AFkER;AE/DI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;AFiER;;AE7DA;EACI,mBAAA;EACA,gBAAA;EACA,YAAA;AFgEJ;AE9DI;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AFgER;;AE3DI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AF8DR;;AE1DA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;AF6DJ;AE3DI;EACI,YAAA;EACA,UAAA;EACA,mBAAA;AF6DR;;AEzDA;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AF4DJ;;AEzDA;EACI,kBAAA;AF4DJ;;AEzDA;EACI,iBAAA;AF4DJ;;AEzDA;EACI,yBCx2BU;EDy2BV,WAAA;EACA,gBAAA;AF4DJ;AE1DI;EACI,WAAA;EACA,2BAAA;AF4DR;;AExDA;EACI,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;AF2DJ;;AExDA;EACI,yBC33BU;ED43BV,0BAAA;AF2DJ;AEzDI;EACI,WAAA;EACA,WAAA;EACA,sBAAA;AF2DR;AExDI;EACI,WAAA;AF0DR;;AEtDA;EACI,0DAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,2DAAA;AFyDJ;AEvDI;EACI,2CAAA;EACA,eAAA;AFyDR;;AErDA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,mDAAA;AFwDJ;AEtDI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cC76BM;ED86BN,kBAAA;EACA,gBAAA;AFwDR;AEtDQ;EACI,WAAA;EACA,YAAA;AFwDZ;AEpDI;EACI,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AFsDR;AEnDI;EACI,sCAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AFqDR;AElDI;EACI,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,gDAAA;AFoDR;;AEhDA;EACI,WAAA;EACA,eAAA;EACA,mFAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;EACA,8CAAA;EACA,kCAAA;UAAA,0BAAA;EACA,gBAAA;AFmDJ;AEjDI;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AFmDR;AEhDI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;AFkDR;AE/CI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uFAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCv/BM;EDw/BN,cAAA;AFiDR;AE/CQ;EACI,WAAA;EACA,YAAA;AFiDZ;AE7CI;EACI,SAAA;EACA,YAAA;AF+CR;AE5CI;EACI,0CAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AF8CR;AE3CI;EACI,uCAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AF6CR;AE1CI;EACI,aAAA;EACA,oDAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AF4CR;AEzCI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AF2CR;AEzCQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,cC7iCE;AHwlCd;AEvCI;EACI,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,8CAAA;AFyCR;AEvCQ;EACI,WAAA;EACA,YAAA;AFyCZ;;AEpCA;EACI,cAAA;AFuCJ;;AEpCA;EACE,aAAA;EACA,oBAAA;AFuCF;;AEpCA;EACE,eAAA;AFuCF;;AEnCA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA,EAAA,iBAAA;EACA,mBAAA;EACA,gBAAA;AFsCJ;AEpCI;EACI,iBAAA;AFsCR;AEnCI;EACI,SAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AFqCR;AElCI;EACI,WAAA;EACA,yBAAA;EACA,cAAA;EACA,4BAAA;EACA,mBAAA;AFoCR;;AEhCA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AFmCF;AEjCE;EACE,YAAA;AFmCJ;AEhCE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;EACA,6DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AFkCJ;AEhCI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yCAAA;EACA,yDAAA;AFkCN;AE/BI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AFiCN;;AE5BA;EACE;IACE,WAAA;EF+BF;EE1BI;IACE,WAAA;IACA,eAAA;IACA,kBAAA;IACA,mBAAA;EF4BN;EEzBI;IACE,cAAA;IACA,kBAAA;EF2BN;EExBI;IACE,cAAA;IACA,iBAAA;EF0BN;EErBA;IACE,UAAA;IACA,WAAA;EFuBF;EErBE;IACE,aAAA;EFuBJ;EEpBE;IACE,WAAA;IACA,YAAA;EFsBJ;AACF;AElBA;EAGM;IACE,kBAAA;IACA,mBAAA;EFkBN;AACF;AEbA,+BAAA;AACA;EACI;IACI,sBAAA;IACA,uBAAA;EFeN;EEZE;IACI,sBAAA;IACA,uBAAA;EFcN;EEXE;IACI,sBAAA;IACA,uBAAA;EFaN;EEVE;IACI,0BAAA;EFYN;EETE;IACI,eAAA;IACA,iBAAA;EFWN;AACF;AERA;EAEQ;IACI,uBAAA;EFSV;EELE;IACI,wBAAA;EFON;EEJE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;EFMN;EEHE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;EFKN;EEFE;IACI,uBAAA;IACA,wBAAA;IACA,wBAAA;EFIN;EEDE;IACI,0BAAA;EFGN;EECM;IACI,WAAA;IACA,YAAA;EFCV;EEGE;IACI,wBAAA;IACA,uBAAA;IACA,wBAAA;EFDN;EEIE;IACI,uBAAA;IACA,uBAAA;IACA,wBAAA;EFFN;AACF;AEKA;EACI;IACI,kBAAA;IACA,oBAAA;EFHN;EEME;IACI,SAAA;EFJN;EEMM;IACI,sCAAA;EFJV;EEOM;IACI,iBAAA;EFLV;EESE;IACI,uBAAA;EFPN;EESM;IACI,gBAAA;IACA,mBAAA;EFPV;AACF;AEWA;EACI;IACI,iBAAA;IACA,YAAA;IACA,qBAAA;IACA,+BAAA;EFTN;EEWM;IACI,eAAA;IACA,kBAAA;IACA,mBAAA;EFTV;EEaE;IACI,SAAA;IACA,eAAA;EFXN;EEaM;IACI,kBAAA;IACA,iBAAA;EFXV;EEcM;IACI,eAAA;IACA,gBAAA;EFZV;EEeM;IACI,WAAA;IACA,gBAAA;EFbV;EEiBE;IACI,uBAAA;IACA,mBAAA;EFfN;EEiBM;IACI,SAAA;EFfV;EEkBM;IACI,WAAA;IACA,YAAA;IACA,mBAAA;EFhBV;EEmBM;IACI,kBAAA;EFjBV;EEoBM;IACI,kBAAA;IACA,iBAAA;EFlBV;EEqBM;IACI,0BAAA;IACA,QAAA;IACA,gBAAA;IACA,mBAAA;EFnBV;EEsBM;IACI,aAAA;EFpBV;EEuBM;IACI,gBAAA;EFrBV;EEyBE;IACI,kBAAA;EFvBN;EE0BE;IACI,wBAAA;EFxBN;EE4BM;IACI,4BAAA;IACA,8BAAA;EF1BV;EE6BE;IACI,wBAAA;IAEA,gCAAA;EF3BN;EE6BE;IAEI,wBAAA;IAEA,gCAAA;EF5BN;EEgCM;IACI,0BAAA;EF9BV;EEiCM;IACI,wBAAA;IAEA,gCAAA;EF/BV;EEoCM;IACI,WAAA;IACA,YAAA;EFlCV;EEuCM;IACI,2BAAA;EFrCV;EEyCE;IACI,gBAAA;EFvCN;AACF;AIv5CA,iEAAA;AAEA,4BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AJw5CF;AIt5CE;EAAa,YAAA;EAAc,mBAAA;AJ05C7B;AIx5CE;EAAc,mBAAA;EAAqB,WAAA;AJ45CrC;AI35CE;EAAc,mBAAA;EAAqB,WAAA;AJ+5CrC;AI95CE;EAAc,uBAAA;EAAyB,cAAA;EAAgB,yBAAA;AJm6CzD;AIl6CE;EAAc,uBAAA;EAAyB,cAAA;AJs6CzC;AIr6CE;EAAc,iBAAA;EAAmB,kBAAA;AJy6CnC;AIx6CE;EAAc,kBAAA;EAAoB,kBAAA;AJ46CpC;;AIz6CA,sBAAA;AACA;EACE,cAAA;AJ46CF;AI16CE;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AJ46CJ;AIz6CE;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AJ26CJ;AIx6CE;EACE,YAAA;EACA,oDAAA;EACA,mBAAA;EACA,2BAAA;AJ06CJ;;AIt6CA,uBAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AJy6CF;AIv6CE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AJy6CJ;AIt6CE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AJw6CJ;AIr6CE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AJu6CJ;AIp6CE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AJs6CJ;AIp6CI;EAAsB,mBAAA;EAAqB,cAAA;AJw6C/C;AIv6CI;EAAsB,mBAAA;EAAqB,cAAA;AJ26C/C;AI16CI;EAAsB,mBAAA;EAAqB,cAAA;AJ86C/C;AI36CE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AJ66CJ;;AIz6CA,4BAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AJ46CF;AI16CE;EACE,kBAAA;EACA,WAAA;AJ46CJ;AIz6CE;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA,EAAA,2BAAA;AJ26CJ;AIx6CE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AJ06CJ;AIv6CE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AJy6CJ;AIx6CI;EAAI,SAAA;EAAW,iBAAA;AJ46CnB;AIz6CE;EACE,iBAAA;EACA,kBAAA;AJ26CJ;AIx6CE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AJ06CJ;;AIt6CA,oBAAA;AACA;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6DAAA;EACA,8CAAA;AJy6CF;AIv6CE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AJy6CJ;AIt6CE;EACE,aAAA;EACA,QAAA;AJw6CJ;AIr6CE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AJu6CJ;AIp6CE;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AJs6CJ;AIn6CE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AJq6CJ;AIl6CE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kDAAA;AJo6CJ;AIj6CE;EACE,YAAA;EACA,mBAAA;EACA,2BAAA;AJm6CJ;AI/5CI;EACE,cAAA;AJi6CN;AI95CI;EACE,cAAA;AJg6CN;AI75CI;EACE,mBDjOQ;AHgoDd;AI35CM;EACE,cAAA;AJ65CR;AI15CM;EACE,mBDzOO;AHqoDf;AIv5CM;;EAEE,cAAA;AJy5CR;AIt5CM;EACE,8FAAA;AJw5CR;AIn5CE;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJq5CJ;;AIj5CA,sBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kDAAA;AJo5CF;AIl5CE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AJo5CJ;AIj5CE;EACE,mCAAA;EACA,cAAA;EACA,sCAAA;AJm5CJ;AIh5CE;EACE,mCAAA;EACA,cAAA;EACA,qCAAA;AJk5CJ;AI/4CE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AJi5CJ;;AI74CA,8BAAA;AACA;EACE,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qDAAA;AJg5CF;AI94CE;EAEE,aAAA;AJ+4CJ;AI54CE;EACE,uBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,sCAAA;EACA,uFACE;EACF,wBAAA;EACA,iBAAA;EACA,aAAA;AJ64CJ;AI14CE;EACE,uBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,sCAAA;EACA,uFACE;EACF,uBAAA;EACA,iBAAA;EACA,aAAA;AJ24CJ;AIx4CE;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJ04CJ;AIx4CI;EAEE,aAAA;AJy4CN;AIt4CI;EACE,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,0FAAA;EACA,kBAAA;AJw4CN;AIr4CI;EACE,iBAAA;EACA,mBAAA;EACA,oGAAA;EACA,kBAAA;EACA,YAAA;AJu4CN;AIn4CE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;UAAA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AJq4CJ;AIn4CI;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;EACA,aAAA;AJq4CN;AIn4CM;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJq4CR;AIl4CM;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AJo4CR;AI/3CE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AJi4CJ;AI93CE;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uDAAA;AJg4CJ;AI93CI;EACE,2BAAA;AJg4CN;AI73CI;EACE,0CAAA;EACA,mBAAA;AJ+3CN;AI33CE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AJ63CJ;AI13CE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AJ43CJ;AI13CI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;AJ43CN;AIz3CI;EACE,2BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AJ23CN;AIv3CE;EACE,aAAA;EACA,0DAAA;EACA,mBAAA;EACA,2BAAA;AJy3CJ;AIt3CE;EACE,YAAA;AJw3CJ;AIr3CE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,8HACE;EAEF,8CAAA;AJq3CJ;AIn3CI;EACE,mBAAA;AJq3CN;AIj3CE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;AJm3CJ;AIh3CE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AJk3CJ;AIh3CI;EACE,iBAAA;AJk3CN;AI92CE;EAEE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;UAAA,2BAAA;AJ+2CJ;AI52CE;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,kCAAA;AJ82CJ;AI32CE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AJ62CJ;AI32CI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,qCAAA;EACA,oDAAA;AJ62CN;AIz2CM;EACE,mBAAA;EACA,kDAAA;AJ22CR;AIz2CQ;EAAiB,WAAA;EAAa,mBAAA;AJ62CtC;AI52CQ;EAAiB,YAAA;EAAc,sBAAA;AJg3CvC;AI/2CQ;EAAiB,YAAA;EAAc,sBAAA;AJm3CvC;AIl3CQ;EAAiB,YAAA;EAAc,sBAAA;AJs3CvC;AIj3CE;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,iCAAA;AJm3CJ;AIj3CI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AJm3CN;AIh3CI;EACE,mCAAA;AJk3CN;AIh3CM;EACE,mBAAA;AJk3CR;AI72CE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;AJ+2CJ;AI52CE;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,kBAAA;AJ82CJ;AI52CI;EACE,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AJ82CN;AI52CM;EACE,eAAA;EACA,UAAA;AJ82CR;AI32CM;EACE,aAAA;AJ62CR;AIz2CI;EACE,cAAA;EACA,cAAA;EACA,kBAAA;AJ22CN;AIx2CI;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;AJ02CN;AIv2CI;EACE,sCAAA;EACA,8CAAA;AJy2CN;AIr2CE;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AJu2CJ;AIp2CE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AJs2CJ;AIn2CE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AJq2CJ;AIl2CE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AJo2CJ;AIl2CI;EACE,kDAAA;AJo2CN;AIh2CE;EACE,SAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AJk2CJ;AI/1CE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AJi2CJ;AI/1CI;EACE,cAAA;EACA,gBAAA;AJi2CN;AI71CE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AJ+1CJ;AI51CE;EACE,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AJ81CJ;AI51CI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AJ81CN;AI11CE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AJ41CJ;AIz1CE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AJ21CJ;AIx1CE;EACE,aAAA;EACA,SAAA;AJ01CJ;AIv1CE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJy1CJ;AIv1CI;EACE,cAAA;AJy1CN;AIt1CI;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AJw1CN;AIp1CE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJs1CJ;AIn1CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sFAAA;EACA,cAAA;EACA,iBAAA;AJq1CJ;AIl1CE;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,6DAAA;EACA,8CAAA;AJo1CJ;AIl1CI;EACE,2EAAA;AJo1CN;AIj1CI;EACE,2EAAA;AJm1CN;AIh1CI;EACE,qBAAA;EACA,2EAAA;AJk1CN;AI/0CI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AJi1CN;AI70CE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AJ+0CJ;AI50CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mCAAA;EACA,cAAA;EACA,iBAAA;AJ80CJ;AI50CI;EACE,mCAAA;EACA,cAAA;AJ80CN;AI10CE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AJ40CJ;AIz0CE;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJ20CJ;AIx0CE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJ00CJ;AIv0CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AJy0CJ;AIt0CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJw0CJ;AIr0CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AJu0CJ;AIp0CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AJs0CJ;AIp0CI;EACE,gBAAA;AJs0CN;AIl0CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJo0CJ;AIj0CE;EACE,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AJm0CJ;AIj0CI;EACE,mBAAA;EACA,cAAA;AJm0CN;AIh0CI;EACE,mBAAA;EACA,cAAA;AJk0CN;AI/zCI;EACE,mBAAA;EACA,cAAA;AJi0CN;AI7zCE;EAGE,SAAA;EACA,iBAAA;AJ6zCJ;AI1zCE;EACE,cAAA;EACA,iBAAA;AJ4zCJ;AIxzCI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJ0zCN;AItzCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AJwzCJ;AItzCI;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;AJwzCN;AIpzCE;EACE,cAAA;EACA,kBAAA;AJszCJ;AInzCE;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AJqzCJ;AIlzCE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;AJozCJ;AIjzCE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;AJmzCJ;AIhzCE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AJkzCJ;AI/yCE;EACE,cAAA;EACA,iBAAA;AJizCJ;AI9yCE;EACE,WAAA;EACA,uBAAA;EACA,SAAA;AJgzCJ;AI9yCI;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AJgzCN;AI5yCE;EACE,gBAAA;AJ8yCJ;AI3yCE;;EAEE,+CAAA;AJ6yCJ;AI1yCE;EACE,mBAAA;AJ4yCJ;;AIxyCA;EACE;IAEE,uBAAA;EJ0yCF;EIvyCA;IACE,oBAAA;EJyyCF;AACF;AItyCA;EACE;IACE,uBAAA;EJwyCF;EItyCE;IACE,gBAAA;EJwyCJ;EIryCE;IACE,UAAA;IACA,gBAAA;IACA,SAAA;EJuyCJ;EIpyCE;IACE,0BAAA;IACA,SAAA;EJsyCJ;EInyCE;IACE,gBAAA;IACA,cAAA;EJqyCJ;EIlyCE;IACE,mBAAA;EJoyCJ;EIjyCE;IACE,gDAAA;EJmyCJ;AACF;AI/xCA;EACE;IACE,gBAAA;IACA,uBAAA;EJiyCF;EI/xCE;IACE,UAAA;IACA,gBAAA;IACA,SAAA;EJiyCJ;EI9xCE;IACE,cAAA;EJgyCJ;EI7xCE;IACE,WAAA;IACA,YAAA;EJ+xCJ;EI3xCI;IACE,6BAAA;IACA,kBAAA;EJ6xCN;EIzxCE;IACE,mBAAA;EJ2xCJ;EIxxCE;IAEE,kBAAA;EJyxCJ;EItxCE;IACE,UAAA;IACA,YAAA;EJwxCJ;EIrxCE;IACE,WAAA;IACA,SAAA;EJuxCJ;EIpxCE;IACE,0BAAA;EJsxCJ;EInxCE;IACE,gBAAA;EJqxCJ;EIlxCE;IACE,kBAAA;EJoxCJ;EIjxCE;IAGE,kBAAA;EJixCJ;EI9wCE;IAKE,mBAAA;EJ4wCJ;EIzwCE;IACE,0BAAA;EJ2wCJ;EIxwCE;IACE,kBAAA;EJ0wCJ;EIvwCE;IAEE,WAAA;IACA,YAAA;IACA,mBAAA;EJwwCJ;EIrwCE;IACE,sBAAA;IACA,uBAAA;EJuwCJ;EIpwCE;IACE,iBAAA;EJswCJ;EInwCE;IACE,gBAAA;EJqwCJ;AACF;AIjwCA,2DAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,oBAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EA+BA,uCAAA;EAqaA,wBAAA;EAuJA,2BAAA;EAqCA,wCAAA;EA4HA,qBAAA;EA0BA,0BAAA;EAeA,8BAAA;EAsBA,wBAAA;EAgBA,gBAAA;EAeA,iBAAA;EAQA,qBAAA;AJ4aF;AI5wCE;EACE,SAAA;EACA,cAAA;AJ8wCJ;AI7wCI;EAAI,SAAA;EAAW,kBAAA;AJixCnB;AI7wCI;EACE,sBAAA;EACA,UAAA;AJ+wCN;AI5wCI;EACE,WAAA;EACA,YAAA;AJ8wCN;AI3wCI;EACE,iCAAA;AJ6wCN;AI1wCI;EACE,kBAAA;EACA,SAAA;EACA,8BAAA;EACA,2BAAA;AJ4wCN;AIvwCE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;AJywCJ;AItwCE;EACE,kBAAA;EACA,gFAAA;EACA,YAAA;EACA,iCAAA;EACA,kCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,2CAAA;EACA,2CAAA;EACA,2BAAA;EACA,mCAAA;AJwwCJ;AItwCI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,8EAAA;EACA,oBAAA;AJwwCN;AIrwCI;;EAEE,UAAA;EACA,WAAA;EACA,2BAAA;AJuwCN;AInwCE;EACE,kBAAA;EACA,QAAA;EACA,2JACE;EAEF,0BAAA;EACA,uEAAA;EACA,UAAA;AJmwCJ;AIhwCE;EACE,kBAAA;EACA,2CAAA;EACA,kBAAA;EACA,4CAAA;EACA,UAAA;AJkwCJ;AIhwCI;EACE,uBAAA;EACA,wBAAA;AJkwCN;AI/vCI;EACE,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,4BAAA;EACA,sCAAA;AJiwCN;AI7vCE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,2CAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,2CAAA;AJ+vCJ;AI5vCE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,kDAAA;AJ8vCJ;AI3vCE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yEAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,0CAAA;EACA,gFAAA;AJ6vCJ;AI3vCI;EACE,uCAAA;EACA,+EAAA;AJ6vCN;AI1vCI;EACE,uCAAA;EACA,6EAAA;AJ4vCN;AIzvCI;EACE,sCAAA;AJ2vCN;AIvvCE;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,2CAAA;AJyvCJ;AItvCE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,+CAAA;EACA,mBAAA;AJwvCJ;AItvCI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AJwvCN;AIrvCI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AJuvCN;AIpvCI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AJsvCN;AIlvCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,4EAAA;AJovCJ;AIlvCI;EACE,WAAA;EACA,YAAA;AJovCN;AIjvCI;EACE,mBAAA;EACA,uCAAA;EACA,cAAA;AJmvCN;AI/uCE;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;AJivCJ;AI9uCE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,qDAAA;AJgvCJ;AI7uCE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AJ+uCJ;AI5uCE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,wCAAA;EACA,cAAA;EACA,mBAAA;AJ8uCJ;AI5uCI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AJ8uCN;AI3uCI;EACE,sBAAA;EACA,sCAAA;EACA,mBAAA;AJ6uCN;AI1uCI;EACE,oBAAA;EACA,sCAAA;EACA,mBAAA;EACA,cAAA;AJ4uCN;AI1uCM;;;EAGE,gCAAA;AJ4uCR;AIxuCI;EACE,kBAAA;EACA,eAAA;EACA,sCAAA;EACA,mBAAA;AJ0uCN;AIvuCI;EAEE,oBAAA;AJwuCN;AIruCI;EACE,uCAAA;EACA,mBAAA;AJuuCN;AInuCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AJquCJ;AInuCI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AJquCN;AIluCI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AJouCN;AIhuCE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AJkuCJ;AIhuCI;EACE,UAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA;EACA,aAAA;EACA,gDAAA;AJkuCN;AIhuCM;EACE,sBAAA;AJkuCR;AI/tCM;EACE,sBAAA;AJiuCR;AI5tCE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AJ8tCJ;AI3tCE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2CAAA;EACA,2BAAA;EACA,mCAAA;AJ6tCJ;AI1tCE;EACE,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;AJ4tCJ;AI1tCI;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AJ4tCN;AIxtCE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,2BAAA;EACA,mCAAA;AJ0tCJ;AIttCE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AJwtCJ;AIttCI;EAAW,cAAA;AJytCf;AIrtCI;;;;;;EAME,aAAA;EACA,sBAAA;EACA,+CAAA;AJutCN;AIltCI;EACE,qBAAA;AJotCN;AIjtCI;EACE,iCAAA;AJmtCN;AIhtCI;EACE,2BAAA;AJktCN;AI9sCE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sKACE;EAEF,0BAAA;EACA,kCAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AJ8sCJ;AI3sCE;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,2CAAA;EACA,+EACE;EAEF,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AJ2sCJ;AIxsCE;EACE,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AJ0sCJ;AIvsCE;EACE,SAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;AJysCJ;AItsCE;EACE,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AJwsCJ;AIrsCE;EACE,aAAA;EACA,SAAA;AJusCJ;AIpsCE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AJssCJ;AInsCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AJqsCJ;AIlsCE;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJosCJ;AIhsCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,+EAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;AJksCJ;AI/rCE;EACE,SAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AJisCJ;AI9rCE;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AJgsCJ;AI7rCE;EACE,+BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AJ+rCJ;AI3rCE;EACE,kBAAA;EACA,2BAAA;EACA,SAAA;EACA,2BAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AJ6rCJ;AI1rCE;EACE;IACE,sBAAA;IACA,UAAA;EJ4rCJ;EIzrCE;IACE,2CAAA;EJ2rCJ;EIxrCE;IACE,2CAAA;IACA,uBAAA;EJ0rCJ;EIvrCE;IAEE,yEAAA;EJwrCJ;EIprCI;;IAEE,QAAA;EJsrCN;AACF;AIlrCE;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,iCAAA;EACA,0CAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mCAAA;EACA,6CAAA;AJorCJ;AIjrCE;EACE,WAAA;EACA,kCAAA;EACA,2BAAA;EACA,mCAAA;EACA,2CAAA;EACA,uCAAA;EACA,0DAAA;EACA,WAAA;AJmrCJ;AIjrCI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iCAAA;EACA,2CAAA;AJmrCN;AIjrCM;EACE,gBAAA;AJmrCR;AIhrCM;EACE,eAAA;EACA,gBAAA;AJkrCR;AI7qCE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;AJ+qCJ;AI5qCE;EACE,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AJ8qCJ;AI3qCE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AJ6qCJ;AI3qCI;EAAqB,kCAAA;EAAiC,cAAA;EAAgB,0CAAA;AJgrC1E;AI/qCI;EAAqB,gCAAA;EAAgC,cAAA;EAAgB,0CAAA;AJorCzE;AInrCI;EAAqB,kCAAA;EAAiC,cAAA;EAAgB,0CAAA;AJwrC1E;AIrrCE;EACE,eAAA;EACA,sCAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AJurCJ;AInrCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,qCAAA;EACA,8CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJqrCJ;AIlrCE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;AJorCJ;AIlrCI;EAAiB,WAAA;EAAc,mBAAA;AJsrCnC;AIrrCI;EAAiB,YAAA;EAAc,sBAAA;AJyrCnC;AIxrCI;EAAiB,YAAA;EAAc,qBAAA;AJ4rCnC;AI3rCI;EAAiB,WAAA;EAAc,sBAAA;AJ+rCnC;AI3rCE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AJ4rCJ;AIxrCE;EACE,gBAAA;EACA,WAAA;EACA,+BAAA;EACA,mCAAA;UAAA,2BAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AJ0rCJ;AIxrCI;EACE,oCAAA;EACA,kCAAA;EACA,cAAA;AJ0rCN;AIrrCE;EACE,gBAAA;EACA,WAAA;EACA,oCAAA;EACA,6CAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AJurCJ;AIrrCI;EAAiB,+BAAA;AJwrCrB;AIvrCI;EAAU,aAAA;EAAe,qBAAA;AJ2rC7B;AIvrCE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AJyrCJ;AItrCE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AJwrCJ;AIprCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AJsrCJ;AIjrCI;EACE,uCAAA;EACA,uCAAA;EACA,uBAAA;EACA,4EAAA;AJmrCN;AIhrCI;;EAEE,aAAA;EACA,qBAAA;EACA,iDAAA;AJkrCN;AI9qCE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,qHACE;EAEF,cAAA;EACA,0BAAA;EACA,kCAAA;EACA,yCAAA;AJ8qCJ;AI3qCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,4CAAA;AJ6qCJ;AI3qCI;EACE,sCAAA;EACA,gBAAA;EACA,gBAAA;AJ6qCN;AI1qCI;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;AJ4qCN;AIzqCI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AJ2qCN;AIvqCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;EACA,kDAAA;AJyqCJ;AItqCE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,2CAAA;AJwqCJ;AItqCI;EAAK,iBAAA;EAAmB,gBAAA;EAAkB,SAAA;AJ2qC9C;AI1qCI;EAAK,gCAAA;EAA+B,kBAAA;EAAoB,SAAA;AJ+qC5D;AI5qCE;EAAe,kBAAA;AJ+qCjB;AI5qCI;EACE,sBAAA;EACA,UAAA;AJ8qCN;AI3qCI;EACE,2BAAA;AJ6qCN;AI1qCI;EACE,iCAAA;AJ4qCN;AIzqCI;EACE,kCAAA;AJ2qCN;AIxqCI;EACE,uBAAA;EACA,QAAA;EACA,kHAAA;AJ0qCN;AItqCE;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AJwqCJ;AIrqCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,qCAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,8CAAA;EACA,kGAAA;AJuqCJ;AIrqCI;EACE,WAAA;EACA,YAAA;AJuqCN;AIpqCI;EACE,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,mBAAA;AJsqCN;AInqCI;EACE,sCAAA;EACA,cAAA;EACA,mBAAA;AJqqCN;AIjqCE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;AJmqCJ;AIhqCE;EACE,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,8CAAA;AJkqCJ;AI/pCE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,kDAAA;AJiqCJ;AI/pCI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AJiqCN;AI9pCI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJgqCN;AI5pCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AJ8pCJ;AI5pCI;EACE,WAAA;EACA,YAAA;AJ8pCN;AI3pCI;EACE,cAAA;EACA,mBAAA;AJ6pCN;AIzpCE;EACE,uBAAA;EACA,aAAA;EACA,SAAA;AJ2pCJ;AIzpCI;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AJ2pCN;AIvpCE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,yHACE;EAEF,0BAAA;EACA,kCAAA;AJupCJ;AIppCE;EACE,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,8CAAA;EACA,aAAA;EACA,aAAA;EACA,+BAAA;EACA,SAAA;EACA,2CAAA;AJspCJ;AInpCE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AJqpCJ;AInpCI;EACE,WAAA;EACA,YAAA;AJqpCN;AIjpCE;EACE,YAAA;AJmpCJ;AIjpCI;EACE,iBAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,gBAAA;AJmpCN;AIhpCI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJkpCN;AI9oCE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AJgpCJ;AI7oCE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJ+oCJ;AI5oCE;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AJ8oCJ;AI3oCE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uGAAA;AJ6oCJ;AI3oCI;EACE,2BAAA;AJ6oCN;AI1oCI;EACE,mBAAA;EACA,cAAA;EACA,gDAAA;AJ4oCN;AIzoCI;EACE,mBAAA;EACA,cAAA;EACA,qCAAA;AJ2oCN;AIzoCM;EACE,mBAAA;EACA,qCAAA;AJ2oCR;AItoCE;EAzuCF;IA0uCI,eAAA;IACA,oCAAA;IACA,2BAAA;EJyoCF;EItoCI;IACE,qBAAA;EJwoCN;EIroCI;IACE,aAAA;EJuoCN;EIpoCI;IACE,YAAA;EJsoCN;EIloCE;IACE,kBAAA;IACA,uBAAA;EJooCJ;EIjoCE;IACE,aAAA;IACA,qBAAA;EJmoCJ;EIhoCE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;EJkoCJ;AACF;;AI7nCA;EACE,kBAAA;EACA,UAAA;EACA,gCAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kDAAA;AJgoCF;AI9nCE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,iJACE;EAEF,iBAAA;EACA,oDAAA;AJ8nCJ;AI3nCE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;EACA,mDAAA;EACA,4CAAA;AJ6nCJ;AI1nCE;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;EACA,oDAAA;EACA,4BAAA;AJ4nCJ;AIznCE;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AJ0nCJ;AIvnCE;EACE,UAAA;AJynCJ;AItnCE;EACE,sBAAA;AJwnCJ;AIrnCE;EAAqB,UAAA;AJwnCvB;AIvnCE;EAAiB,UAAA;AJ0nCnB;AIznCE;EAAsB,UAAA;AJ4nCxB;AI3nCE;EAAiB,UAAA;AJ8nCnB;AI5nCE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,uHAAA;EACA,iBAAA;EACA,sBAAA;AJ8nCJ;AI3nCE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,iCAAA;EACA,2CAAA;EACA,0BAAA;EACA,kCAAA;AJ6nCJ;AI3nCI;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;AJ6nCN;AI3nCM;EAAiB,YAAA;AJ8nCvB;AI7nCM;EAAiB,YAAA;AJgoCvB;AI5nCE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,uFAAA;EACA,8CAAA;EACA,sBAAA;AJ8nCJ;AI3nCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AJ6nCJ;AI3nCI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AJ6nCN;AI3nCM;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AJ4nCR;AIznCM;EACE,8CAAA;AJ2nCR;AIxnCM;EAAiB,SAAA;EAAW,QAAA;AJ4nClC;AI3nCM;EAAiB,UAAA;EAAY,QAAA;AJ+nCnC;AI9nCM;EAAiB,UAAA;EAAY,QAAA;AJkoCnC;AI9nCE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6CAAA;AJgoCJ;AI7nCE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,oFAAA;EACA,iBAAA;AJ+nCJ;AI3nCI;EACE,iJACE;AJ4nCR;AItnCI;EACE,4EAAA;AJwnCN;AIrnCI;EACE,qCAAA;EACA,kDAAA;AJunCN;AIlnCI;EACE,6EAAA;AJonCN;AI/mCI;EACE,8EAAA;AJinCN;AI5mCI;EACE,8EAAA;AJ8mCN;;AIzmCA,qCAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,0CAAA;EACA,8CAAA;EACA,2BAAA;EACA,mCAAA;AJ4mCF;;AIzmCA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AJ4mCF;AI1mCE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,0CAAA;EACA,8CAAA;AJ4mCJ;;AIxmCA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;AJ2mCF;;AIxmCA;EACE,sCAAA;AJ2mCF;AIzmCE;EACE,mBAAA;EACA,8CAAA;AJ2mCJ;;AIvmCA;EACE,qCAAA;EACA,qCAAA;AJ0mCF;AIxmCE;EACE,mBAAA;EACA,6CAAA;AJ0mCJ;;AItmCA;EACE,aAAA;AJymCF;;AItmCA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AJymCF;AIvmCE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AJymCJ;AItmCE;EACE,aAAA;EACA,QAAA;AJwmCJ;AItmCI;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,qCAAA;AJwmCN;AIpmCE;EACE,UAAA;AJsmCJ;AIpmCI;EACE,kDAAA;AJsmCN;AIpmCM;EAAiB,WAAA;EAAa,mBAAA;AJwmCpC;AIvmCM;EAAiB,YAAA;EAAc,sBAAA;AJ2mCrC;AI1mCM;EAAiB,YAAA;EAAc,sBAAA;AJ8mCrC;AI7mCM;EAAiB,YAAA;EAAc,sBAAA;AJinCrC;AI5mCI;EACE,mBAAA;AJ8mCN;AI3mCI;EACE,qCAAA;AJ6mCN;;AIxmCA,yBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,4CAAA;AJ2mCF;AIzmCE;EAAyB,sBAAA;AJ4mC3B;AI1mCE;EAAU,iBAAA;EAAmB,cAAA;AJ8mC/B;AI5mCE;EACE,mBAAA;AJ8mCJ;AI5mCI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,6CAAA;AJ8mCN;AI1mCE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,kDAAA;AJ4mCJ;AIzmCE;EAAgB,mBAAA;EAAqB,mBAAA;AJ6mCvC;AI3mCE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AJ6mCJ;AI1mCE;EAAa,YAAA;EAAc,mBAAA;EAAqB,eAAA;AJ+mClD;;AI5mCA,oCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AJ+mCF;;AI5mCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kCAAA;EACA,4CAAA;AJ+mCF;AI7mCE;EACE,sCAAA;EACA,2FAAA;AJ+mCJ;AI5mCE;EACE,sCAAA;EACA,2FAAA;AJ8mCJ;AI3mCE;EACE,sCAAA;EACA,4FAAA;AJ6mCJ;AI1mCE;EACE,sCAAA;EACA,4FAAA;AJ4mCJ;;AIxmCA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AJ2mCF;AIzmCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AJ2mCJ;AIxmCE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AJ0mCJ;AIvmCE;EACE,gCAAA;EACA,iBAAA;EACA,iBAAA;AJymCJ;;AIrmCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AJwmCF;;AIrmCA;EACE,+CAAA;EACA,gBAAA;AJwmCF;AItmCE;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AJwmCJ;AIrmCE;EACE,aAAA;AJumCJ;;AInmCA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AJsmCF;AIpmCE;EACE,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AJsmCJ;;AIlmCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AJqmCF;AInmCE;EAAS,cAAA;EAAgB,kBAAA;AJumC3B;AItmCE;EAAO,gCAAA;EAAkC,kBAAA;AJ0mC3C;AIzmCE;EAAQ,gCAAA;EAAkC,kBAAA;AJ6mC5C;;AI1mCA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,4CAAA;AJ6mCF;AI3mCE;EAAiB,gCAAA;AJ8mCnB;AI7mCE;EAAU,qCAAA;EAAuC,8CAAA;AJinCnD;;AI9mCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kCAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AJinCF;AI/mCE;EACE,eAAA;EACA,qBAAA;AJinCJ;AI9mCE;EACE,SAAA;AJgnCJ;;AI5mCA;EACE,uBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AJ+mCF;;AI5mCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,kCAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;AJ+mCF;;AI5mCA,qBAAA;AACA;EACE;IAAW,sBAAA;IAAwB,YAAA;EJinCnC;EIhnCA;IAAY,sBAAA;IAAwB,UAAA;EJonCpC;AACF;AIlnCA;EACE;IAAO,mBAAA;IAAwB,YAAA;EJsnC/B;EIrnCA;IAAO,qBAAA;IAAwB,UAAA;EJynC/B;AACF;AIvnCA;EACE;IAAgB,aAAA;IAAe,wBAAA;EJ2nC/B;EI1nCA;IAAM,YAAA;IAAc,2BAAA;EJ8nCpB;AACF;AI5nCA;EACE;IAAW,wBAAA;EJ+nCX;EI9nCA;IAAM,4BAAA;EJioCN;AACF;AI/nCA;EACE;IAAW,sBAAA;IAAwB,aAAA;EJmoCnC;EIloCA;IAAM,sBAAA;IAAwB,UAAA;EJsoC9B;AACF;AIpoCA;EACE;IAAW,mBAAA;IAAqB,aAAA;EJwoChC;EIvoCA;IAAM,sBAAA;IAAwB,UAAA;EJ2oC9B;AACF;AIzoCA;EACE;IAAO,gCAAA;EJ4oCP;EI3oCA;IAAK,kCAAA;EJ8oCL;AACF;AI5oCA;EACE;IAAO,UAAA;EJ+oCP;EI9oCA;IAAK,UAAA;EJipCL;AACF;AI/oCA;EACE;IACE,UAAA;IACA,uCAAA;EJipCF;EI/oCA;IACE,UAAA;IACA,iCAAA;EJipCF;AACF;AI9oCA,+BAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2NACE;AJ+oCJ;AI3oCE;EACE,mBAAA;EACA,sDAAA;EACA,6DAAA;AJ6oCJ;AI1oCE;EAEE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,sFACE;EAEF,mCAAA;UAAA,2BAAA;EACA,gBAAA;AJyoCJ;AItoCE;EACE,uBAAA;AJwoCJ;AItoCI;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,4DAAA;AJwoCN;AIpoCE;EACE,iBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AJsoCJ;AIpoCI;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AJsoCN;AIloCE;EACE,gBAAA;AJooCJ;AIhoCI;EACE,cAAA;EACA,eAAA;EACA,cD7oGQ;EC8oGR,qBAAA;AJkoCN;AI9nCE;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,sCAAA;EACA,mBAAA;EACA,sFACE;AJ+nCN;AI3nCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cDxqGU;ECyqGV,uFAAA;EACA,gDAAA;AJ6nCJ;AI3nCI;EACE,WAAA;EACA,YAAA;AJ6nCN;AI1nCI;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,0CAAA;EACA,yBDtrGQ;ECurGR,yDAAA;AJ4nCN;AIxnCE;EACE,aAAA;EACA,SAAA;AJ0nCJ;AIxnCI;EACE,SAAA;EACA,cAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;AJ0nCN;AIvnCI;EACE,eAAA;EACA,cAAA;EACA,yCAAA;EACA,iBAAA;AJynCN;AIrnCE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AJunCJ;AIpnCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AJsnCJ;AIpnCI;EACE,eAAA;EACA,iBAAA;EACA,cDpuGQ;ECquGR,kBAAA;EACA,gBAAA;AJsnCN;AIlnCE;EACE,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;AJonCJ;AIjnCE;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,mBDtvGU;ECuvGV,4BAAA;AJmnCJ;AIhnCE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJknCJ;AI/mCE;EACE,eAAA;AJinCJ;AI9mCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,cDrxGU;ECsxGV,gBAAA;EACA,eAAA;EACA,8CAAA;EACA,uGAAA;AJgnCJ;AI9mCI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AJgnCN;AI7mCI;EACE,oCAAA;EACA,qBDnyGQ;ECoyGR,gDAAA;EACA,2BAAA;AJ+mCN;AI5mCI;EACE,wBAAA;EACA,+CAAA;AJ8mCN;AI3mCI;EACE,2CAAA;EACA,mBAAA;AJ6mCN;AI1mCI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AJ4mCN;AIxmCE;EACE,mBAAA;AJ0mCJ;AIvmCE;EACE,aAAA;EACA,SAAA;AJymCJ;AItmCE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AJwmCJ;AIrmCE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AJumCJ;AIpmCE;EACE,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AJsmCJ;AInmCE;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJqmCJ;AInmCI;EACE,cAAA;AJqmCN;AIjmCE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6DAAA;AJmmCJ;AIjmCI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AJmmCN;AIhmCI;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AJkmCN;AI9lCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;AJgmCJ;AI7lCE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,wGACE;EAEF,0CAAA;EACA,8CAAA;EACA,mBAAA;AJ6lCJ;AI1lCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AJ4lCJ;AIzlCE;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uGACE;EAEF,0CAAA;EACA,8CAAA;AJylCJ;AItlCE;EACE,yCAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;AJwlCJ;AIrlCE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AJulCJ;AIplCE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AJslCJ;AInlCE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AJqlCJ;AIllCE;EACE,qCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AJolCJ;AIjlCE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AJmlCJ;AIhlCE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;AJklCJ;AI/kCE;EACE,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;AJilCJ;AI9kCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;AJglCJ;AI7kCE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AJ+kCJ;AI5kCE;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AJ8kCJ;AI3kCE;EACE,iBAAA;EACA,mBAAA;AJ6kCJ;AI1kCE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;AJ4kCJ;AI1kCI;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AJ4kCN;AIzkCI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AJ2kCN;AIvkCE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AJykCJ;AItkCE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6DAAA;EACA,8CAAA;EACA,mBAAA;AJwkCJ;AIrkCE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AJukCJ;AIrkCI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AJukCN;AIpkCI;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AJskCN;AIlkCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;AJokCJ;AIjkCE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;AJmkCJ;AIhkCE;EACE,6DAAA;EACA,qBAAA;AJkkCJ;AI/jCE;EACE,kCAAA;EACA,cAAA;AJikCJ;AI9jCE;EACE,6DAAA;EACA,qBAAA;AJgkCJ;AI7jCE;EACE,oCAAA;EACA,cAAA;AJ+jCJ;AI5jCE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,kBAAA;AJ8jCJ;AI5jCI;EACE,iBAAA;AJ8jCN;AI1jCE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AJ4jCJ;AI1jCI;EACE,gBAAA;EACA,mBAAA;EACA,uGAAA;AJ4jCN;AI1jCM;EACE,2BAAA;AJ4jCR;AIzjCM;EACE,2CAAA;EACA,mBAAA;AJ2jCR;AIvjCI;EACE,mBD1qHQ;EC2qHR,cAAA;EACA,gDAAA;AJyjCN;AIvjCM;EACE,mBAAA;EACA,+CAAA;AJyjCR;AIrjCI;EACE,mBAAA;EACA,cAAA;EACA,sCAAA;AJujCN;AIrjCM;EACE,oCAAA;EACA,qBD3rHM;AHkvJd;AIljCE;EA5nBF;IA6nBI,uBAAA;EJqjCF;EInjCE;IACE,kBAAA;EJqjCJ;EIljCE;IAEE,eAAA;EJmjCJ;EIhjCE;IACE,uBAAA;EJkjCJ;EI/iCE;IACE,0BAAA;IACA,SAAA;IACA,aAAA;EJijCJ;EI9iCE;IAGE,0BAAA;EJ8iCJ;AACF;AI3iCE;EAzpBF;IA0pBI,uBAAA;EJ8iCF;EI5iCE;IACE,uBAAA;IACA,mBAAA;EJ8iCJ;EI3iCE;IACE,iBAAA;IACA,kBAAA;IACA,mBAAA;EJ6iCJ;EI1iCE;IACE,kBAAA;IACA,SAAA;IACA,kBAAA;IACA,mBAAA;EJ4iCJ;EIziCE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EJ2iCJ;EIziCI;IACE,WAAA;IACA,YAAA;EJ2iCN;EIxiCI;IACE,mBAAA;EJ0iCN;EItiCE;IAGE,WAAA;EJsiCJ;EIniCE;IACE,eAAA;EJqiCJ;EIliCE;IACE,uBAAA;IACA,eAAA;IACA,aAAA;EJoiCJ;EIliCI;IACE,iBAAA;EJoiCN;EIhiCE;IACE,WAAA;IACA,gBAAA;EJkiCJ;EI/hCE;IAEE,sBAAA;IACA,oBAAA;EJgiCJ;EI7hCE;IACE,aAAA;IACA,mBAAA;EJ+hCJ;EI5hCE;IACE,iBAAA;EJ8hCJ;EI3hCE;IACE,kBAAA;EJ6hCJ;EI1hCE;;IAEE,mBAAA;EJ4hCJ;EIzhCE;IACE,kBAAA;EJ2hCJ;EIxhCE;IACE,kBAAA;IACA,aAAA;EJ0hCJ;EIvhCE;IACE,WAAA;EJyhCJ;AACF;;AIrhCA;EACE;IACE,yBAAA;EJwhCF;AACF;AIrhCA,+BAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,6DAAA;EACA,gBAAA;AJuhCF;AIrhCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AJuhCJ;AIrhCI;EACE,cD11HQ;AHi3Jd;AInhCE;EACE,iBAAA;EACA,cAAA;AJqhCJ;AIlhCE;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AJohCJ;AIjhCE;EACE,aAAA;EACA,QAAA;EACA,YAAA;AJmhCJ;AIhhCE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AJkhCJ;AI/gCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AJihCJ;AI9gCE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AJghCJ;AI7gCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AJ+gCJ;AI7gCI;EACE,cAAA;EACA,cD75HQ;AH46Jd;AI5gCI;EACE,YAAA;EACA,uBAAA;AJ8gCN;AI3gCI;EACE,cAAA;EACA,gBAAA;AJ6gCN;AIzgCE;EAEE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,6CAAA;EACA,kGAAA;AJ0gCJ;AIxgCI;EACE,cAAA;EACA,eAAA;AJ0gCN;AIvgCI;EACE,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,8CAAA;AJygCN;AItgCI;EACE,aAAA;EACA,qBD78HQ;EC88HR,8CAAA;AJwgCN;AIrgCI;EACE,wBAAA;AJugCN;AIngCE;EACE,gBAAA;AJqgCJ;AIlgCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,6CAAA;EACA,kGAAA;AJogCJ;AIlgCI;EACE,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,8CAAA;AJogCN;AIjgCI;EACE,aAAA;EACA,qBDj/HQ;ECk/HR,8CAAA;AJmgCN;AI//BE;EACE,aAAA;EACA,0DAAA;EACA,SAAA;EACA,kBAAA;AJigCJ;AI9/BE;EACE,qCAAA;AJggCJ;AI7/BE;EACE,gBAAA;EACA,SAAA;EACA,iBAAA;AJ+/BJ;AI5/BE;EACE,6DAAA;EACA,mBAAA;EACA,8CAAA;EACA,yBAAA;EACA,aAAA;AJ8/BJ;AI3/BE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AJ6/BJ;AI1/BE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AJ4/BJ;AIz/BE;EACE,aAAA;EACA,QAAA;AJ2/BJ;AIx/BE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;AJ0/BJ;AIv/BE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AJy/BJ;AIt/BE;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;AJw/BJ;AIt/BI;EACE,uBAAA;EACA,mBAAA;EACA,6CAAA;AJw/BN;AIr/BI;EACE,mBAAA;AJu/BN;AIp/BI;EACE,kBAAA;AJs/BN;AIn/BI;EACE,kBAAA;AJq/BN;AIl/BI;EACE,iBAAA;AJo/BN;AIj/BI;EACE,WAAA;AJm/BN;AIh/BI;EACE,gBAAA;EACA,kBAAA;AJk/BN;AI9+BE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;AJg/BJ;AI7+BE;EACE,mBAAA;EACA,cAAA;EACA,sCAAA;EACA,gBAAA;AJ++BJ;AI5+BE;EACE,oCAAA;EACA,cAAA;EACA,sCAAA;AJ8+BJ;AI3+BE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AJ6+BJ;AI1+BE;EACE,YAAA;AJ4+BJ;AIz+BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AJ2+BJ;AIx+BE;EACE,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,8CAAA;EACA,gFAAA;AJ0+BJ;AIv+BE;EACE,sCAAA;EACA,8CAAA;AJy+BJ;AIt+BE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AJw+BJ;AIr+BE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AJu+BJ;AIr+BI;EAAc,mBAAA;EAAqB,cAAA;AJy+BvC;AIx+BI;EAAc,mBAAA;EAAqB,cAAA;AJ4+BvC;AIz+BE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AJ2+BJ;AIx+BE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AJ0+BJ;AIx+BI;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AJ0+BN;AIv+BI;EACE,oCAAA;EACA,qCAAA;EACA,cAAA;AJy+BN;AIt+BI;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AJu+BN;AIn+BE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AJq+BJ;AIl+BE;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AJo+BJ;AIj+BE;EACE,gBAAA;AJm+BJ;AIj+BI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AJm+BN;AI/9BE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;AJi+BJ;AI99BE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AJg+BJ;AI99BI;EACE,cAAA;AJg+BN;AI79BI;EACE,aAAA;EACA,kBAAA;EACA,8CAAA;AJ+9BN;AI39BE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;AJ69BJ;AI39BI;EACE,yBAAA;AJ69BN;AIz9BE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,cAAA;AJ29BJ;AIz9BI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AJ29BN;AIx9BI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AJ09BN;AIt9BE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AJw9BJ;AIr9BE;EA9eF;IA+eI,uBAAA;EJw9BF;EIt9BE;IACE,qCAAA;EJw9BJ;EIr9BE;IACE,gBAAA;EJu9BJ;AACF;AIp9BE;EA1fF;IA2fI,uBAAA;EJu9BF;EIr9BE;IACE,SAAA;IACA,mBAAA;EJu9BJ;EIp9BE;IACE,gBAAA;IACA,eAAA;EJs9BJ;EIn9BE;IACE,uBAAA;IACA,SAAA;EJq9BJ;EIl9BE;IACE,iBAAA;EJo9BJ;EIj9BE;IACE,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;EJm9BJ;EIh9BE;IAEE,aAAA;IACA,mBAAA;EJi9BJ;EI98BE;IACE,SAAA;EJg9BJ;EI78BE;IACE,eAAA;EJ+8BJ;EI58BE;IACE,cAAA;EJ88BJ;EI38BE;IACE,WAAA;IACA,8BAAA;EJ68BJ;AACF;;AIz8BA,oCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AJ48BF;AI18BE;EAAU,eAAA;AJ68BZ;AI38BE;EAAS,cAAA;EAAgB,cAAA;EAAgB,kBAAA;AJg9B3C;;AI78BA,sEAAA;AACA;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AJg9BF;AI98BE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AJg9BJ;AI78BE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AJ+8BJ;AI58BE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,uBAAA;AJ88BJ;AI38BE;EACE,mBAAA;EACA,uBAAA;EACA,mBAAA;AJ68BJ;AI38BI;EACE,6DAAA;EACA,yBAAA;AJ68BN;AI18BI;EACE,6DAAA;EACA,yBAAA;AJ48BN;AIx8BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AJ08BJ;AIv8BE;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AJy8BJ;AIv8BI;EAAY,mBAAA;EAAqB,cAAA;AJ28BrC;AI18BI;EAAY,mBAAA;EAAqB,cAAA;AJ88BrC;AI38BE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AJ68BJ;AI18BE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AJ48BJ;AIz8BE;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AJ28BJ;AIx8BE;EACE,YAAA;EACA,oBAAA;EACA,mBD7+IU;EC8+IV,2BAAA;AJ08BJ;AIv8BE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AJy8BJ;AIt8BE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AJw8BJ;AIr8BE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CAAA;AJu8BJ;AIp8BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;AJs8BJ;AIn8BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AJq8BJ;AIn8BI;EACE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AJq8BN;AIj8BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AJm8BJ;AIh8BE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;AJk8BJ;AI/7BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,4EAAA;AJi8BJ;AI/7BI;EAAY,aAAA;EAAe,2BAAA;AJm8B/B;AIl8BI;EAAY,wBAAA;AJq8BhB;AIp8BI;EACE,2CAAA;EACA,mBAAA;AJs8BN;AIn8BI;EAAY,mBDtlJF;ECslJ4B,WAAA;AJu8B1C;AIt8BI;EACE,mBAAA;EACA,cAAA;EACA,0CAAA;AJw8BN;;AIn8BA;EACE;IACE,kBAAA;EJs8BF;EIp8BE;IACE,kBAAA;EJs8BJ;EIn8BE;IAEE,sBAAA;IACA,oBAAA;EJo8BJ;EIj8BE;IACE,WAAA;IACA,YAAA;EJm8BJ;AACF;AI/7BA,sCAAA;AACA;;EAEE,gBAAA;AJi8BF;;AI97BA;EACE,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AJi8BF;AI/7BE;EAAY,mBAAA;EAAqB,cAAA;AJm8BnC;AIl8BE;EAAY,mBAAA;EAAqB,cAAA;AJs8BnC;AIr8BE;EAAY,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AJ08BnD;AIx8BE;EAAU,YAAA;AJ28BZ;;AIx8BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AJ28BF;AIz8BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AJ28BJ;AIx8BE;EACE,kBAAA;EACA,gBAAA;AJ08BJ;;AIt8BA;EACE,cAAA;EACA,iBAAA;AJy8BF;;AIt8BA,wEAAA;AACA;EAiFE,8BAAA;AJy3BF;AIz8BE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,0BAAA;EACA,kCAAA;AJ28BJ;AIx8BE;EACE,kCAAA;EACA,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,4CAAA;EACA,qCAAA;AJ08BJ;AIv8BE;EACE;IAAO,UAAA;IAAY,2BAAA;EJ28BrB;EI18BE;IAAO,UAAA;IAAY,wBAAA;EJ88BrB;AACF;AI58BE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,qDAAA;AJ88BJ;AI38BE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AJ68BJ;AI38BI;EACE,WAAA;EACA,YAAA;AJ68BN;AIz8BE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;AJ28BJ;AIx8BE;EACE,cAAA;EACA,kBAAA;AJ08BJ;AIv8BE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AJy8BJ;AIt8BE;EACE,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AJw8BJ;AIp8BE;EACE,iBAAA;EACA,kBAAA;AJs8BJ;AIn8BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AJq8BJ;AIl8BE;EACE;IAAW,UAAA;EJq8Bb;EIp8BE;IAAM,aAAA;EJu8BR;AACF;;AIp8BA;EAGM;IACE,UAAA;EJq8BN;EIl8BI;IACE,aAAA;EJo8BN;EIj8BI;IACE,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;EJm8BN;EIh8BI;IACE,uBAAA;IACA,QAAA;EJk8BN;EI97BE;IACE,WAAA;IACA,yBAAA;IACA,YAAA;IACA,aAAA;IACA,UAAA;IACA,mBAAA;EJg8BJ;EI97BI;;IAEE,UAAA;IACA,WAAA;IACA,4BAAA;EJg8BN;EI57BE;IACE,aAAA;IACA,6BAAA;IACA,kBAAA;EJ87BJ;EI37BE;IACE,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,iBAAA;EJ67BJ;EI17BE;IACE,UAAA;IACA,YAAA;IACA,6BAAA;IACA,gBAAA;IACA,iBAAA;IACA,QAAA;IACA,kBAAA;EJ47BJ;EI17BI;IACE,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EJ47BN;EIz7BI;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;EJ27BN;EIv7BE;IACE,SAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,QAAA;IACA,kBAAA;EJy7BJ;EIv7BI;IACE,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EJy7BN;EIt7BI;IACE,cAAA;IACA,sBAAA;IACA,8BAAA;EJw7BN;EIp7BE;IACE,UAAA;IACA,YAAA;IACA,8BAAA;IACA,kBAAA;EJs7BJ;EIn7BE;IACE,UAAA;IACA,WAAA;IACA,SAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,mBAAA;EJq7BJ;EIj7BI;IACE,WAAA;EJm7BN;EIh7BI;IACE,WAAA;EJk7BN;EI96BE;IACE,uBAAA;EJg7BJ;EI76BE;IACE,aAAA;IACA,QAAA;EJ+6BJ;EI56BE;IACE,iBAAA;EJ86BJ;EI56BI;IACE,iBAAA;IACA,iBAAA;EJ86BN;EI16BE;IACE,SAAA;IACA,yBAAA;EJ46BJ;EIz6BE;IACE,kBAAA;IACA,mBAAA;EJ26BJ;EIx6BE;IACE,kBAAA;IACA,iBAAA;EJ06BJ;EIv6BE;IACE,uBAAA;EJy6BJ;EIt6BE;IACE,WAAA;IACA,YAAA;IACA,QAAA;EJw6BJ;EIr6BE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EJu6BJ;EIp6BE;IACE,0BAAA;IACA,SAAA;IACA,aAAA;EJs6BJ;EIn6BE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EJq6BJ;EIl6BE;IACE,sBAAA;EJo6BJ;EIj6BE;IACE,WAAA;IACA,uBAAA;EJm6BJ;EI/5BA;IACE,uBAAA;IACA,wBAAA;EJi6BF;EI95BA;;;;IAIE,WAAA;EJg6BF;AACF;AI75BA;EAEI;IACE,SAAA;IACA,uBAAA;EJ85BJ;EI35BE;IACE,kBAAA;EJ65BJ;EI15BE;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EJ45BJ;AACF","sourcesContent":["// If you want to override variables do it here\n@import \"variables\";\n@import \"transitions\";\n\n$enable-ltr: true;\n$enable-rtl: true;\n\n// If you want to add custom CSS you can put it here.\n@import \"~bootstrap/dist/css/bootstrap.min.css\";\n@import \"~animate.css/animate.compat.css\";\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\n@import \"~react-photo-view/dist/react-photo-view.css\";\n@import \"~bootstrap-daterangepicker/daterangepicker.css\";\n@import \"~sweetalert2/dist/sweetalert2.min.css\";\n@import \"theme\";\n@import \"interview\";\n","@keyframes fadeIn {\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n  }\n  \n  .fade-in-text {\n    animation: fadeIn 1s;\n  }\n  \n  .hover-zoom{\n    transition: transform .25s, visibility .25s ease-in;\n  \n    &:hover{\n      transform: scale(1.07);\n    }\n  }\n  \n  .hover-zoom-big{\n    transition: transform .25s, visibility .25s ease-in;\n  \n    &:hover{\n      transform: scale(1.3);\n    }\n  }\n  \n  @keyframes rotation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(359deg);\n    }\n  }\n  \n  .hover-rotate{\n    &:hover{\n      animation: rotation 7s infinite linear;\n    }\n  }\n  \n  /* GLITCH */\n  .glitch {\n    transform: translate(4.5em,3em);\n    animation: glitch-animate 3s infinite;\n  }\n  @keyframes glitch-animate {\n    0%,26%,30%,72%,76%,100% { transform: translate(0em,0em) skew(0deg) ; box-shadow: none }\n    30%,70% {transform: translate(0em,0em) skew(30deg);}\n    29%,31%,69%,71% {transform: translate(0em,0em) skew(0deg);}\n    28%,74% { box-shadow: \n      -0.2em 0.1em 0 0 cyan,\n      0.2em -0.1em 0 0 magenta\n    }\n  }\n  .glitch:after {\n    animation: glitch-animate-after 3s infinite;\n  }\n  @keyframes glitch-animate-after {\n    0%,34%,38%,46%,50%,100% { transform: translate(0,1em); box-shadow: none; }\n    36%,48% { transform: translate(0.4em,0em);\n    box-shadow: \n      -1em 0 0 0 cyan,\n      1em 0 0 0 magenta,\n      0.5em 1em 0 -0.8em cyan\n    }\n  }\n  .glitch:before {\n    transform: translate(0em,3em);\n    animation: glitch-animate-before 3s infinite;\n  }\n  @keyframes glitch-animate-before {\n    0%,30%,34%,50%,54%,100% { transform: translate(0,0); box-shadow: none; }\n    32%,52% { transform: translate(-0.4em,1em);\n    box-shadow: \n      -0.3em 0 0 0 red,\n      0.3em 0 0 0 yellow}\n  }\n  \n  /* END GLITCH */\n  \n  /* PERSPECTIVE */\n  .perspec-back {\n    animation: perspec-back 3s linear infinite;\n  }\n  @keyframes perspec-back {\n    0%,100% { transform: translate(4em,0) }\n    25% { transform: translate(3.4em,0) }\n    50% { transform: translate(1em, 0.6em) }\n    75% { transform: translate(3em,0.6em) }\n  }\n  .perspec-middle {\n    animation: perspec-middle 3s linear infinite;\n  }\n  @keyframes perspec-middle {\n    0%,100% { transform: translate(-1em,0.4em) }\n    25% { transform: translate(1em,0.4em) }\n    50% { transform: translate(0em,1.2em) }\n    75% { transform: translate(1em,1.2em) }\n  }\n  .perspec-front {\n    animation: perspec-front 3s linear infinite;\n  }\n  @keyframes perspec-front {\n    0%,100% { transform: translate(6.5em,1em) }\n    25% { transform: translate(7.5em,1em) }\n    50% { transform: translate(7.5em,2em) }\n    75% { transform: translate(6.5em,2em) }\n  }\n  /* END PERSPECTIVE */","@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap');\n\n* {\n    font-family: \"Red Hat Display\", sans-serif;\n}\n\nbody {\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: $text-color;\n    overscroll-behavior: none;\n    width: 100vw;\n    overflow-x: hidden;\n}\n\nul {\n    padding-left: 1rem;\n}\n\n.main-layout-container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n\n    &--interview {\n        min-height: 100vh;\n        overflow: hidden;\n        background: #0a0c12;\n    }\n}\n\n.text-brand {\n    color: $brand-color;\n}\n\n.text-brand2 {\n    color: $brand2-color;\n}\n\n.text-right {\n    text-align: right;\n}\n\n// Placeholder styling is handled per-page in respective SCSS files\n\n.form-check-input:checked {\n    background-color: $brand-color;\n    border-color: $brand-color;\n}\n\n.form-check-input:focus {\n    box-shadow: 0 0 0 0.25rem rgba($brand-color, 0.25);\n}\n\n.header {\n    font-weight: 900;\n    font-size: 2rem;\n    line-height: 2.7rem;\n}\n\n.subheader {\n    font-weight: 600;\n    font-size: 1.6rem;\n}\n\n.title {\n    font-weight: 400;\n    font-size: 1.2rem;\n}\n\n.text-inactive {\n    color: #a0a9b1 !important;\n}\n\n.css-t3ipsp-control {\n    box-shadow: none !important;\n    border-color: $brand-color !important;\n}\n\n.css-t3ipsp-control:hover {\n    border-color: $brand-color !important;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.btn-brand {\n    background-color: $brand-color !important;\n    color: white !important;\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n}\n\n.btn-outline-brand {\n    border-color: $brand-color !important;\n    color: $brand-color !important;\n    padding-left: 25px !important;\n    padding-right: 25px !important;\n}\n\n.btn-scroll-wrap{\n    position: fixed; \n    right: 30px;\n    bottom: 30px;\n    z-index: 2;\n    width: auto;\n    height: auto;\n\n    .btn-scroll{\n        cursor: pointer;\n        width: 50px;\n        height: 50px;\n        background-color: #fff;\n        border-radius: 50%;\n        text-align: center;\n        box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        -webkit-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        -moz-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.40);\n        margin: auto;\n        margin-bottom: 5px;\n        position: relative;\n\n        svg{\n            width: 20px;\n            height: 20px;\n            position: absolute;\n            left: 50%;\n            top: 50%;\n            transform: translate(-50%, -50%);\n            color: $brand-color;\n        }\n    }\n\n    .txt{\n        font-size: .7rem;\n        color: #5C5C5C;\n        text-align: center;\n    }\n}\n\n.outlet-wrapper {\n    padding-top: 106px;\n    flex: 1 1 auto;\n\n    &--interview {\n        padding-top: 0;\n        min-height: 100vh;\n    }\n\n    &--interview-fullscreen {\n        overflow: hidden;\n        background: #0a0c12;\n    }\n}\n\n\n@keyframes logoNav {\n    0% {\n        height: 80px;\n    }\n    100% {\n        height: 40px;\n    }\n}\n\n@keyframes logoNavIddle {\n    0% {\n        height: 40px;\n    }\n    100% {\n        height: 80px;\n    }\n}\n\n.navbar {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(9.7px);\n    -webkit-backdrop-filter: blur(9.7px);\n\n    .logo {\n        height: 80px;\n    }\n\n    .nav-link {\n        font-weight: 600;\n        font-weight: bold;\n        color: #343a40e6;\n\n        &:hover {\n            color: $brand-color;\n        }\n\n        &.active {\n            color: $brand-color;\n        }\n    }\n\n    .btn-login {\n        background-color: $brand-color !important;\n        color: #fff !important;\n        padding: 6px 18px !important;\n        border-radius: 8px;\n        font-weight: 600;\n        margin-left: 10px;\n\n        &:hover {\n            background-color: darken($brand-color, 8%) !important;\n            color: #fff !important;\n        }\n    }\n\n    .navbar-toggler {\n        padding: 10px;\n    }\n}\n\n.naviddle {\n    .navbar {\n        .logo {\n            animation-duration: 0.5s;\n            animation-name: logoNavIddle;\n            animation-timing-function: ease-out;\n            height: 80px;\n        }\n    }\n}\n  \n.navresize {\n    .navbar {\n        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n        border: 1px solid rgba(255, 255, 255, 0.3);\n\n        .logo {\n            animation-duration: 0.5s;\n            animation-name: logoNav;\n            animation-timing-function: ease-out;\n            height: 40px;\n        }\n    }\n}\n\n// Profile Menu Styles\n.profile-menu-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    .profile-picture {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n        border: 2px solid $brand-color;\n        transition: all 0.3s ease;\n\n        &:hover {\n            box-shadow: 0 2px 8px rgba(18, 183, 173, 0.3);\n            transform: scale(1.05);\n        }\n    }\n\n    .profile-dropdown {\n        position: absolute;\n        top: 100%;\n        right: 0;\n        background: white;\n        border-radius: 8px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n        min-width: 150px;\n        margin-top: 8px;\n        z-index: 1000;\n        animation: slideDown 0.3s ease-out;\n\n        @keyframes slideDown {\n            from {\n                opacity: 0;\n                transform: translateY(-10px);\n            }\n            to {\n                opacity: 1;\n                transform: translateY(0);\n            }\n        }\n\n        .profile-dropdown__item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            width: 100%;\n            padding: 12px 16px;\n            border: none;\n            background: none;\n            color: #333;\n            font-weight: 500;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-radius: 8px 8px 0 0;\n\n            &:hover {\n                background-color: #f0fffe;\n                color: $brand-color;\n            }\n\n            svg {\n                width: 18px;\n                height: 18px;\n            }\n        }\n\n        .logout-btn {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            width: 100%;\n            padding: 12px 16px;\n            border: none;\n            background: none;\n            color: #ff6b6b;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            border-radius: 8px;\n\n            &:hover {\n                background-color: #fff5f5;\n                color: #ff5252;\n            }\n\n            svg {\n                width: 18px;\n                height: 18px;\n            }\n        }\n    }\n}\n\n.main-content, .talent-content {\n    width: 100%;\n    height: calc(100vh - 60px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n\n    .main-parallax-1 {\n        position: absolute;\n        bottom: -30px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-1-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: 0;\n    }\n\n    .main-parallax-2 {\n        position: absolute;\n        bottom: 30px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-2-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .main-parallax-3 {\n        position: absolute;\n        bottom: 0px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-3-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .content-wrapper {\n        max-width: 550px;\n        z-index: 2;\n\n        .subtitle {\n            font-weight: 900;\n            color: $brand2-color;\n            font-size: 1.2rem;\n            text-transform: uppercase;\n        }\n    \n        .title {\n            font-weight: 900;\n            color: $brand-color;\n            font-size: 2.6rem;\n            margin-top: 15px;\n            line-height: 2.8rem;\n        }\n    \n        .desc {\n            margin-top: 15px;\n            font-size: 1rem;\n            font-weight: 600;\n        }\n    }\n}\n\n.talent-content {\n    height: calc(70vh);\n\n    .main-parallax-4 {\n        position: absolute;\n        bottom: -100px;\n        right: 0px;\n        width: 550px;\n        height: 550px;\n        z-index: 0;\n        background-image: url('../assets/img/bg-main-4-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .main-parallax-2 {\n        bottom: -100px;\n    }\n}\n\n.bg-brand-opacity {\n    background-color: #f1faf9;\n}\n\n.bg-brand {\n    background-color: $brand-color;\n}\n\n.text-wrap {\n    text-wrap: wrap !important;\n}\n\n.flex-1 {\n    min-width: 0;\n    flex: 1 !important;\n}\n\n.card {\n    border: 1px solid #eee;\n\n    &.no-border {\n        border-width: 0px !important;\n    }\n}\n\n.shadow {\n    box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n    -webkit-box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n    -moz-box-shadow: -3px 3px 28px -4px rgba(148,148,148,0.4) !important;\n}\n\n.slick-track,\n.slick-list {\n    width: 100%;\n    min-width: 100%;\n}\n\n.slick-dots li button {\n\n    &::before{\n        font-size: 18px;\n    }\n}\n\n.slick-dots li.slick-active button {\n\n    &::before{\n        color: $brand-color;\n    }\n}\n\n.about-us {\n    position: relative;\n    z-index: 2;\n\n    &::after{\n        content: \"\";\n        width: 200px;\n        height: 140px;\n        background-image: url(\"../assets/img/img-part-1.png\");\n        background-size: contain;\n        background-repeat: no-repeat;\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n\n    .about-us-image-wrapper {\n        width: 100%;\n        height: 100%;\n        position: relative;\n    }\n\n    .about-us-parallax-1 {\n        position: absolute;\n        top: 0;\n        left: -30px;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-1.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: 0;\n    }\n\n    .about-us-parallax-2 {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-2.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n\n    .about-us-parallax-3 {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 0;\n        background-image: url('../assets/img/about-us-3.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n    }\n}\n\n.talent-list-wrapper {\n    position: relative;\n    z-index: 2;\n    background-color: #f1faf9;\n}\n\n.talent-list {\n    img {\n        width: 30%;\n        height: 30%;\n        border-radius: 10px;\n        object-fit: cover;\n    }\n}\n\ninput, textarea {\n    &:focus {\n        border-color: $brand-color !important;\n        box-shadow: none !important;\n        outline:none !important;\n    }\n}\n\n.daterangepicker td.in-range {\n    background-color: $bg-brand-color !important;\n}\n\n.daterangepicker td.available {\n    color: #0f172a;\n    font-weight: 600;\n    transition: background-color .18s ease, color .18s ease, box-shadow .18s ease;\n}\n\n.daterangepicker td.available:hover {\n    background-color: rgba(46, 196, 182, 0.14) !important;\n    color: $brand-color !important;\n    box-shadow: inset 0 0 0 1px rgba(46, 196, 182, 0.28);\n}\n\n.daterangepicker td.off.disabled,\n.daterangepicker td.disabled,\n.daterangepicker option.disabled {\n    color: #c3cdd8 !important;\n    background-color: #fff !important;\n    text-decoration: none !important;\n    opacity: 1;\n    cursor: not-allowed;\n}\n\n.daterangepicker .drp-buttons .btn-primary{\n    background-color: $brand-color;\n    border-color: $brand-color;\n}\n\n.daterangepicker td.active {\n    background-color: $brand-color !important;\n    color: #fff !important;\n    font-weight: 700;\n    box-shadow: 0 8px 20px rgba(46, 196, 182, 0.24);\n}\n\n.image-uploader-container{\n    width: 100%;\n    position: relative;\n    height: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    \n    .image-uploader-bg{\n        width: 100%;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n        height: 100%;\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n        box-sizing: border-box;\n        background: $bg-brand-color;\n    \n    \n        &.singleback{\n            background-position: center;\n            background-repeat: no-repeat;\n            background-size: cover;\n            filter: blur(34px);\n            background: $bg-brand-color;\n        }   \n    }\n\n    img{\n        position: absolute;\n        height: 100%;\n        width: auto;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n}\n\n.input-tag-wrapper {\n    .ReactTags__tags {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .ReactTags__tagInput {\n        flex: 1;\n\n        input {\n            width: 100%;\n            padding: 0.375rem 0.75rem;\n            display: block;\n            width: 100%;\n            font-size: 1rem;\n            font-weight: 400;\n            line-height: 1.5;\n            color: var(--bs-body-color);\n            appearance: none;\n            background-color: var(--bs-body-bg);\n            background-clip: padding-box;\n            border: var(--bs-border-width) solid var(--bs-border-color);\n            border-radius: var(--bs-border-radius);\n            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n            &:focus {\n                border-color: $brand-color !important;\n                box-shadow: none !important;\n                outline:none !important;\n            }\n        }\n\n    }\n  \n    .ReactTags__selected {\n        display: flex;\n        gap: 5px;\n        flex-wrap: wrap;\n    }\n  \n    .ReactTags__selected span.ReactTags__tag {\n        background: $brand-color;\n        color: white;\n        font-size: 12px;\n        display: flex;\n        padding: 5px;\n        border-radius: 3px;\n    }\n\n    .ReactTags__selected a.ReactTags__remove {\n        color: #aaa;\n        margin-left: 5px;\n        cursor: pointer;\n    }\n    \n    .ReactTags__remove {\n        border: none;\n        cursor: pointer;\n        background: none;\n        color: white;\n        margin-right: -5px;\n\n        svg {\n            width: 9px;\n            height: 9px;\n            margin-top: -3px;\n        }\n    }\n}\n\n.css-1p3m7a8-multiValue {\n    background-color: $brand-color !important;\n    color: #fff !important;\n\n    .css-9jq23d {\n        color: #fff !important;\n    }\n}\n\n.service-list {\n    .list {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 15px;\n        margin-bottom: 10px;\n\n        svg {\n            width: 1.8rem;\n            height: 1.8rem;\n            color: $brand2-color;\n        }\n\n        .desc {\n            font-weight: bold;\n            font-size: 1.3rem;\n        }\n    }\n}\n\n.arrow-service {\n    width: 40px;\n    height: 40px;\n    background-color: $brand-color;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n\n    &.disabled{\n        background-color: #fff;\n        border: 2px solid rgba($brand-color, 0.4);\n        cursor: default;\n\n        svg {\n            color: rgba($brand-color, 0.4);\n        }\n    }\n\n    svg {\n        color: #fff;\n        width: 20px;\n        height: 20px;\n    }\n}\n\n.service {\n    .bg-service {\n        width: 100%;\n        position: relative;\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: -25px;\n            height: 150px;\n            background-color: $brand2-color;\n            z-index: -1;\n            border-radius: 10px;\n        }\n    }\n}\n\n.product {\n    background-color: rgba($brand2-color, .2);\n    border-radius: 20px;\n    position: relative;\n\n    .video-parallax-2 {\n        position: absolute;\n        bottom: 300px;\n        right: -100px;\n        width: 350px;\n        height: 350px;\n        background-image: url('../assets/img/bg-main-2-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: -1;\n    }\n\n    .video-parallax-3 {\n        position: absolute;\n        bottom: 150px;\n        left: -180px;\n        width: 350px;\n        height: 350px;\n        background-image: url('../assets/img/bg-main-3-parallax.png');\n        background-size: contain;\n        background-repeat: no-repeat;\n        z-index: -1;\n    }\n}\n\n.video-wrapper{\n    border-radius: 20px;\n    overflow: hidden;\n    margin: auto;\n    \n    video {\n        width: 80%;\n        border-radius: 20px;\n        height: auto;\n        overflow: hidden;\n    }\n}\n\n.partner-list {\n    img {\n        width: 60%;\n        height: 80px;\n        object-fit: contain;\n        margin: auto;\n    }\n}\n\n.partner-logo-wrapper {\n    height: 80px;\n    display: flex;\n    justify-content: center;\n\n    img{\n        height: 100%;\n        width: 60%;\n        object-fit: contain;\n    }\n}\n\n.bg-call-us {\n    width: 100%;\n    height: 250px;\n    background-image: url(\"../assets/img/bg-image.png\");\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.company-detail {\n    margin-top: -150px;\n}\n\n.form-detail {\n    margin-top: -70px;\n}\n\n.for-talent-wrapper {\n    background-color: $brand-color;\n    color: #fff;\n    overflow: hidden;\n\n    hr {\n        height: 2px;\n        background: #fff !important;\n    }\n}\n\n.img-for-talent {\n    width: 100%;\n    height: 100%;\n    background-image: url(\"../assets/img/image11.png\");\n    background-size: cover;\n    background-position: center;\n}\n\n.footer {\n    background-color: $brand-color;\n    border-top: 1px solid #fff;\n\n    .hr {\n        width: 100%;\n        height: 1px;\n        background-color: #fff;\n    }\n\n    a {\n        color: #fff;\n    }\n}\n\n.thank-container {\n    background-image: url(\"../assets/img/bg-thanks.png\");\n    background-size: cover;\n    background-position: 50% center;\n    background-repeat: no-repeat;\n    min-height: 100vh;\n    height: auto;\n    margin-top: -106px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding: clamp(132px, 16vh, 180px) 0 clamp(42px, 7vh, 72px);\n\n    .container {\n        width: min(100%, clamp(600px, 42vw, 700px));\n        max-width: none;\n    }\n}\n\n.thank-shell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: clamp(16px, 1.8vh, 20px);\n    width: 100%;\n    max-width: min(100%, 680px);\n    margin: 0 auto;\n    transform: translateX(clamp(-20px, -1.15vw, -10px));\n\n    &__eyebrow {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        padding: 8px 14px;\n        border-radius: 999px;\n        background: rgba(18, 184, 134, 0.12);\n        color: $brand-color;\n        font-size: 0.92rem;\n        font-weight: 700;\n\n        svg {\n            width: 16px;\n            height: 16px;\n        }\n    }\n\n    &__heading {\n        font-size: clamp(2.35rem, 3.4vw, 4rem);\n        font-weight: 900;\n        line-height: 1.08;\n        margin: 0;\n        max-width: 100%;\n        text-wrap: balance;\n    }\n\n    &__subtitle {\n        font-size: clamp(1rem, 1.15vw, 1.1rem);\n        line-height: 1.65;\n        color: #495057;\n        max-width: 34rem;\n        margin: 0;\n        text-wrap: balance;\n    }\n\n    &__secondary-cta {\n        margin-top: 4px;\n        min-width: 220px;\n        border-width: 1.5px !important;\n        background: rgba(255, 255, 255, 0.82) !important;\n    }\n}\n\n.thank-next-step-card {\n    width: 100%;\n    margin-top: 8px;\n    padding: clamp(24px, 2.4vw, 30px) clamp(22px, 2.6vw, 30px) clamp(22px, 2.1vw, 26px);\n    border-radius: 24px;\n    background: rgba(255, 255, 255, 0.94);\n    border: 1px solid rgba(18, 184, 134, 0.16);\n    box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n    backdrop-filter: blur(8px);\n    text-align: left;\n\n    &__badge {\n        display: inline-flex;\n        align-items: center;\n        min-height: 32px;\n        padding: 6px 12px;\n        border-radius: 999px;\n        background: rgba(34, 197, 94, 0.12);\n        color: #0f9b6c;\n        font-size: 0.84rem;\n        font-weight: 800;\n        margin-bottom: 18px;\n    }\n\n    &__header {\n        display: flex;\n        align-items: flex-start;\n        gap: clamp(14px, 1.4vw, 18px);\n    }\n\n    &__icon {\n        width: 54px;\n        height: 54px;\n        border-radius: 16px;\n        background: linear-gradient(135deg, rgba(18, 184, 134, 0.16), rgba(255, 196, 62, 0.18));\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        color: $brand-color;\n        flex-shrink: 0;\n\n        svg {\n            width: 24px;\n            height: 24px;\n        }\n    }\n\n    &__copy {\n        flex: 1;\n        min-width: 0;\n    }\n\n    &__title {\n        font-size: clamp(1.34rem, 1.45vw, 1.52rem);\n        font-weight: 800;\n        color: #102a43;\n        margin-bottom: 8px;\n        line-height: 1.22;\n    }\n\n    &__description {\n        font-size: clamp(0.98rem, 1vw, 1.02rem);\n        line-height: 1.65;\n        color: #52606d;\n        margin: 0;\n    }\n\n    &__meta {\n        display: grid;\n        grid-template-columns: repeat(3, minmax(148px, 1fr));\n        gap: 10px;\n        margin-top: 22px;\n        margin-bottom: 22px;\n    }\n\n    &__meta-item {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        min-height: 52px;\n        padding: 12px 14px;\n        border-radius: 16px;\n        background: #f8fbfc;\n        border: 1px solid rgba(148, 163, 184, 0.18);\n        color: #334e68;\n        font-size: 0.92rem;\n        line-height: 1.45;\n\n        svg {\n            width: 18px;\n            height: 18px;\n            flex-shrink: 0;\n            color: $brand-color;\n        }\n    }\n\n    &__cta {\n        width: 100%;\n        min-height: 54px;\n        border-radius: 16px !important;\n        font-size: 1rem !important;\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        gap: 10px;\n        box-shadow: 0 12px 30px rgba(25, 135, 84, 0.2);\n\n        svg {\n            width: 18px;\n            height: 18px;\n        }\n    }\n}\n\n.desktop-only {\n    display: block;\n}\n\n.equal-height-slider .slick-track {\n  display: flex;\n  align-items: stretch;\n}\n\n.equal-height-slider .slick-slide {\n  height: inherit;\n}\n\n\n.problemsolve-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch; /* Key property */\n    border-radius: 15px;\n    overflow: hidden;\n\n    ul {\n        font-size: 1.3rem;\n    }\n\n    .problem {\n        flex: 1;\n        background-color: #f8d7da;\n        color: #721c24;\n        padding: 10px 20px;\n        line-height: 2.5rem;\n    }\n\n    .solve {\n        flex: 1.4;\n        background-color: #d4edda;\n        color: #155724;\n        padding: 10px 20px 10px 70px;\n        line-height: 2.5rem;\n    }\n}\n\n.bot-wa {\n  position: fixed;\n  z-index: 9;\n  bottom: 6px;\n  right: 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n\n  .img-bot {\n    width: 100px;\n  }\n\n  .wa-bubble{\n    position: relative;\n    background-color: #ffffff;\n    padding: 8px 14px;\n    border-radius: 30px;\n    box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    -webkit-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    -moz-box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.60);\n    font-weight: 800;\n    font-size: 15px;\n    max-width: 170px;\n    line-height: 1.4;\n    display: flex;\n    flex-direction: row;\n    margin-top: -10px;\n    align-items: center;\n\n    &::after{\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      right: -5px;\n      width: 12px;\n      height: 12px;\n      background-color: #ffffff;\n      transform: translateY(-50%) rotate(45deg);\n      box-shadow: -1px 12px 25px -5px rgba(153,153,153,0.18);\n    }\n\n    .wa-icon {\n      width: 34px;\n      height: 34px;\n      flex-shrink: 0;\n    }\n  }\n}\n\n@media (max-width: 820px) {\n  body {\n    width: 100%;\n  }\n\n  .headerMain {\n    .navbar {\n      .container {\n        width: 100%;\n        max-width: 100%;\n        padding-left: 16px;\n        padding-right: 16px;\n      }\n\n      .navbar-brand {\n        flex: 0 0 auto;\n        margin-right: 12px;\n      }\n\n      .navbar-toggler {\n        flex: 0 0 auto;\n        margin-left: auto;\n      }\n    }\n  }\n\n  .bot-wa {\n    right: 4px;\n    bottom: 4px;\n\n    .wa-bubble {\n      display: none;\n    }\n\n    .img-bot {\n      width: 58px;\n      height: auto;\n    }\n  }\n}\n\n@media (max-width: 360px) {\n  .headerMain {\n    .navbar {\n      .container {\n        padding-left: 10px;\n        padding-right: 10px;\n      }\n    }\n  }\n}\n\n/* ==== START MEDIA QUERY ====*/\n@media only screen and (min-width: 991px ) and (max-width: 1400px ) {\n    .main-parallax-1 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .main-parallax-2 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .main-parallax-3 {\n        width: 39vw !important;\n        height: 39vw !important;\n    }\n\n    .content-wrapper {\n        max-width: 40vw !important;\n    }\n\n    .app-talent.container {\n        max-width: 100%;\n        margin-left: 3rem;\n    }\n}\n\n@media only screen and (max-width: 991px) {\n    .navbar {\n        .logo {\n            height: 50px !important;\n        }\n    }\n\n    .desktop-only {\n        display: none !important;\n    }\n\n    .main-parallax-1 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .main-parallax-2 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .main-parallax-3 {\n        width: 500px !important;\n        height: 500px !important;\n        right: -220px !important;\n    }\n\n    .content-wrapper {\n        max-width: 50vw !important;\n    }\n\n    .video-wrapper{\n        video {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    .video-parallax-2 {\n        right: -180px !important;\n        width: 300px !important;\n        height: 300px !important;\n    }\n\n    .video-parallax-3 {\n        left: -280px !important;\n        width: 350px !important;\n        height: 350px !important;\n    }\n}\n\n@media (max-height: 860px) and (min-width: 1024px) {\n    .thank-container {\n        padding-top: 116px;\n        padding-bottom: 36px;\n    }\n\n    .thank-shell {\n        gap: 14px;\n\n        &__heading {\n            font-size: clamp(2.15rem, 3vw, 3.2rem);\n        }\n\n        &__subtitle {\n            line-height: 1.58;\n        }\n    }\n\n    .thank-next-step-card {\n        padding: 22px 22px 20px;\n\n        &__meta {\n            margin-top: 18px;\n            margin-bottom: 18px;\n        }\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .thank-container {\n        min-height: 100vh;\n        height: auto;\n        padding: 120px 0 32px;\n        background-position: center top;\n\n        .container {\n            max-width: 100%;\n            padding-left: 20px;\n            padding-right: 20px;\n        }\n    }\n\n    .thank-shell {\n        gap: 14px;\n        transform: none;\n\n        &__heading {\n            font-size: 1.95rem;\n            line-height: 1.18;\n        }\n\n        &__subtitle {\n            font-size: 1rem;\n            line-height: 1.6;\n        }\n\n        &__secondary-cta {\n            width: 100%;\n            min-height: 48px;\n        }\n    }\n\n    .thank-next-step-card {\n        padding: 22px 18px 18px;\n        border-radius: 20px;\n\n        &__header {\n            gap: 14px;\n        }\n\n        &__icon {\n            width: 48px;\n            height: 48px;\n            border-radius: 14px;\n        }\n\n        &__title {\n            font-size: 1.22rem;\n        }\n\n        &__description {\n            font-size: 0.96rem;\n            line-height: 1.62;\n        }\n\n        &__meta {\n            grid-template-columns: 1fr;\n            gap: 8px;\n            margin-top: 18px;\n            margin-bottom: 18px;\n        }\n\n        &__meta-item {\n            min-height: 0;\n        }\n\n        &__cta {\n            min-height: 50px;\n        }\n    }\n\n    .text-center-mobile {\n        text-align: center;\n    }\n\n    .desktop-only {\n        display: none !important;\n    }\n\n    .main-content {\n        .title{\n            font-size: 1.5rem !important;\n            line-height: 1.8rem !important;\n        }\n    }\n    .main-parallax-1{\n        right: -250px !important;\n        -webkit-transform: scaleX(-1) !important;\n        transform: scaleX(-1) !important;\n    }\n    .main-parallax-2, .main-parallax-3 {\n        // display: none;\n        right: -350px !important;\n        -webkit-transform: scaleX(-1) !important;\n        transform: scaleX(-1) !important;\n    }\n\n    .talent-content {\n        .content-wrapper {\n            max-width: 70vw !important;\n        }\n\n        .main-parallax-4{\n            right: -220px !important;\n            -webkit-transform: scaleX(-1) !important;\n            transform: scaleX(-1) !important;\n        }\n    }\n\n    .video-wrapper{\n        video {\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    .for-talent-wrapper {\n        .ms-5 {\n            margin-left: 0px !important;\n        }\n    }\n\n    .form-detail {\n        margin-top: 40px;\n    }\n}\n","$brand-color: #12b7ad !default;\n$brand2-color: #F7C154 !default;\n$bg-brand-color: #cce8e6 !default;\n$text-color: #31353bcf !default;","/* ── Interview Feature Styles ──────────────────────────────── */\n\n/* Shared button utilities */\n.iv-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.2s;\n  font-size: 0.95rem;\n\n  &:disabled { opacity: 0.6; cursor: not-allowed; }\n\n  &--primary  { background: #059669; color: #fff; }\n  &--success  { background: #059669; color: #fff; }\n  &--outline  { background: transparent; color: #059669; border: 2px solid #059669; }\n  &--ghost    { background: transparent; color: #6B7280; }\n  &--sm       { padding: 8px 18px; font-size: 0.85rem; }\n  &--lg       { padding: 14px 32px; font-size: 1.05rem; }\n}\n\n/* ── ProgressBar ── */\n.iv-progress {\n  margin: 12px 0;\n\n  &__labels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.8rem;\n    color: #6B7280;\n    margin-bottom: 4px;\n  }\n\n  &__track {\n    height: 8px;\n    background: #E5E7EB;\n    border-radius: 99px;\n    overflow: hidden;\n  }\n\n  &__fill {\n    height: 100%;\n    background: linear-gradient(90deg, #7C3AED, #5B21B6);\n    border-radius: 99px;\n    transition: width 0.4s ease;\n  }\n}\n\n/* ── QuestionCard ── */\n.iv-question-card {\n  background: #F9FAFB;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 20px;\n\n  &__meta {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    margin-bottom: 12px;\n  }\n\n  &__counter {\n    font-size: 0.8rem;\n    font-weight: 600;\n    background: #EDE9FE;\n    color: #5B21B6;\n    padding: 2px 10px;\n    border-radius: 99px;\n  }\n\n  &__followup-label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    background: #FEF3C7;\n    color: #92400E;\n    padding: 2px 10px;\n    border-radius: 99px;\n  }\n\n  &__category {\n    font-size: 0.8rem;\n    padding: 2px 10px;\n    border-radius: 99px;\n    font-weight: 500;\n\n    &--technical        { background: #DBEAFE; color: #1E40AF; }\n    &--communication    { background: #D1FAE5; color: #065F46; }\n    &--problem_solving  { background: #FCE7F3; color: #9D174D; }\n  }\n\n  &__text {\n    font-size: 1.05rem;\n    font-weight: 500;\n    color: #111827;\n    line-height: 1.6;\n    margin: 0;\n  }\n}\n\n/* ── CameraPlaceholder ── */\n.iv-camera {\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #1a1f2e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n\n  &__video-wrap {\n    position: relative;\n    width: 100%;\n  }\n\n  &__video {\n    width: 100%;\n    display: block;\n    object-fit: cover;\n    border-radius: 12px;\n    transform: scaleX(-1); /* mirror like selfie cam */\n  }\n\n  &__live-badge {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    background: rgba(0,0,0,0.55);\n    color: #fff;\n    font-size: 0.72rem;\n    font-weight: 700;\n    padding: 3px 9px;\n    border-radius: 99px;\n    letter-spacing: 0.05em;\n  }\n\n  &__placeholder {\n    text-align: center;\n    color: #9CA3AF;\n    padding: 24px;\n    p { margin: 0; font-size: 0.9rem; }\n  }\n\n  &__icon {\n    font-size: 2.5rem;\n    margin-bottom: 8px;\n  }\n\n  &__error {\n    padding: 16px;\n    text-align: center;\n    color: #FCA5A5;\n    font-size: 0.85rem;\n  }\n}\n\n/* ── ScoreCard ── */\n.iv-score-card {\n  padding: 18px 18px 16px;\n  border-radius: 20px;\n  border: 1px solid #e5edf5;\n  background: linear-gradient(180deg, #ffffff 0%, #f9fbfe 100%);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 14px;\n    margin-bottom: 12px;\n  }\n\n  &__copy {\n    display: grid;\n    gap: 4px;\n  }\n\n  &__label {\n    font-size: 0.95rem;\n    color: #0f172a;\n    font-weight: 700;\n    line-height: 1.4;\n  }\n\n  &__tone {\n    font-size: 0.8rem;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n\n  &__value {\n    font-size: 1.5rem;\n    font-weight: 800;\n    line-height: 1;\n  }\n\n  &__track {\n    height: 10px;\n    background: #e2e8f0;\n    border-radius: 99px;\n    overflow: hidden;\n    box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.08);\n  }\n\n  &__fill {\n    height: 100%;\n    border-radius: 99px;\n    transition: width 0.5s ease;\n  }\n\n  &--brand {\n    .iv-score-card__tone {\n      color: #0f766e;\n    }\n\n    .iv-score-card__value {\n      color: #0f766e;\n    }\n\n    .iv-score-card__fill {\n      background: $brand-color;\n    }\n\n    &.iv-score-card--average {\n      .iv-score-card__tone {\n        color: #b45309;\n      }\n\n      .iv-score-card__fill {\n        background: $brand2-color;\n      }\n    }\n\n    &.iv-score-card--weak {\n      .iv-score-card__tone,\n      .iv-score-card__value {\n        color: #64748b;\n      }\n\n      .iv-score-card__fill {\n        background: linear-gradient(90deg, rgba($brand-color, 0.42) 0%, rgba($brand-color, 0.72) 100%);\n      }\n    }\n  }\n\n  &__footer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n    color: #94a3b8;\n    font-size: 0.75rem;\n    font-weight: 700;\n  }\n}\n\n/* ── StatusBadge ── */\n.iv-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 99px;\n  font-size: 0.84rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;\n\n  &__icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.95rem;\n  }\n\n  &--strong {\n    background: rgba($brand-color, 0.1);\n    color: #0f766e;\n    border-color: rgba($brand-color, 0.26);\n  }\n\n  &--average {\n    background: rgba($brand2-color, 0.2);\n    color: #9a6a10;\n    border-color: rgba($brand2-color, 0.5);\n  }\n\n  &--weak {\n    background: #fff7ed;\n    color: #9a3412;\n    border-color: #fed7aa;\n  }\n}\n\n/* ── InterviewEntry page ── */\n.iv-entry {\n  min-height: calc(100vh - 96px);\n  padding: 30px 28px 42px;\n  position: relative;\n  overflow: hidden;\n  background: #ffffff;\n  transition: background 360ms ease, padding 360ms ease;\n\n  &::before,\n  &::after {\n    display: none;\n  }\n\n  &::before {\n    width: min(64vw, 940px);\n    height: 300px;\n    top: -110px;\n    left: -14%;\n    border-radius: 0 0 56% 44% / 0 0 78% 64%;\n    background:\n      linear-gradient(180deg, rgba(250, 205, 95, 0.24), rgba(250, 205, 95, 0.06));\n    transform: rotate(-6deg);\n    filter: blur(6px);\n    opacity: 0.95;\n  }\n\n  &::after {\n    width: min(60vw, 860px);\n    height: 320px;\n    right: -18%;\n    bottom: -150px;\n    border-radius: 52% 48% 0 0 / 70% 62% 0 0;\n    background:\n      linear-gradient(180deg, rgba(31, 180, 181, 0.06), rgba(31, 180, 181, 0.22));\n    transform: rotate(7deg);\n    filter: blur(8px);\n    opacity: 0.96;\n  }\n\n  &__shell {\n    position: relative;\n    z-index: 1;\n    width: min(100%, 1680px);\n    min-height: calc(100vh - 168px);\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &::before,\n    &::after {\n      display: none;\n    }\n\n    &::before {\n      inset: 12% 10% auto;\n      height: 220px;\n      border-radius: 999px;\n      background: radial-gradient(circle, rgba(208, 220, 234, 0.22), rgba(208, 220, 234, 0) 72%);\n      filter: blur(26px);\n    }\n\n    &::after {\n      inset: 18% 8% 14%;\n      border-radius: 36px;\n      background: radial-gradient(circle at center, rgba(255, 255, 255, 0.48), rgba(255, 255, 255, 0) 70%);\n      filter: blur(18px);\n      opacity: 0.8;\n    }\n  }\n\n  &__panel {\n    width: 100%;\n    position: relative;\n    border-radius: 0;\n    background: transparent;\n    border: 0;\n    box-shadow: none;\n    backdrop-filter: none;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n\n    &--error {\n      max-width: 520px;\n      margin: 0 auto;\n      min-height: auto;\n      text-align: center;\n      align-items: center;\n      border-radius: 24px;\n      background: #ffffff;\n      border: 1px solid #e5edf4;\n      box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);\n      padding: 32px;\n\n      h2 {\n        margin: 0;\n        color: #0f172a;\n        font-size: 1.75rem;\n        font-weight: 800;\n      }\n\n      p {\n        margin: 0;\n        color: #475569;\n        line-height: 1.6;\n      }\n    }\n  }\n\n  &__brand {\n    display: inline-flex;\n    align-items: center;\n    gap: 12px;\n    width: fit-content;\n    min-width: 0;\n  }\n\n  &__brand-link {\n    appearance: none;\n    border: 0;\n    background: transparent;\n    border-radius: 10px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 160ms ease, box-shadow 160ms ease;\n\n    &:hover {\n      transform: translateY(-1px);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(20, 184, 166, 0.5);\n      outline-offset: 4px;\n    }\n  }\n\n  &__brand-logo {\n    width: 38px;\n    height: 42px;\n    display: block;\n    object-fit: contain;\n  }\n\n  &__brand-copy {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    span {\n      color: #64748b;\n      font-size: 0.72rem;\n      font-weight: 800;\n      letter-spacing: 0.04em;\n      line-height: 1.15;\n      text-transform: uppercase;\n    }\n\n    strong {\n      max-width: min(56vw, 620px);\n      color: #0f172a;\n      display: block;\n      font-size: 1rem;\n      font-weight: 800;\n      line-height: 1.25;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(360px, 430px);\n    align-items: center;\n    gap: clamp(32px, 5vw, 86px);\n  }\n\n  &__preview-card {\n    min-width: 0;\n  }\n\n  &__video-frame {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16 / 9;\n    overflow: hidden;\n    border-radius: 28px;\n    background:\n      linear-gradient(135deg, rgba(15, 23, 42, 0.92), rgba(30, 41, 59, 0.86)),\n      linear-gradient(180deg, #111827, #020617);\n    box-shadow: 0 30px 80px rgba(15, 23, 42, 0.14);\n\n    &--ready {\n      background: #020617;\n    }\n  }\n\n  &__video {\n    width: 100%;\n    height: 100%;\n    display: block;\n    object-fit: cover;\n    transform: scaleX(-1);\n  }\n\n  &__video-placeholder {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n    color: rgba(255, 255, 255, 0.86);\n    font-size: 0.96rem;\n    font-weight: 700;\n\n    svg {\n      font-size: 2.2rem;\n    }\n  }\n\n  &__video-name,\n  &__video-live {\n    position: absolute;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    border-radius: 999px;\n    color: #ffffff;\n    font-size: 0.86rem;\n    font-weight: 700;\n    backdrop-filter: blur(12px);\n  }\n\n  &__video-name {\n    left: 20px;\n    bottom: 18px;\n    padding: 8px 12px;\n    background: rgba(15, 23, 42, 0.46);\n  }\n\n  &__sound-wave {\n    width: 26px;\n    height: 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 3px;\n\n    i {\n      display: block;\n      width: 3px;\n      height: 5px;\n      border-radius: 999px;\n      background: rgba(255, 255, 255, 0.52);\n      transition: background 160ms ease, height 160ms ease;\n    }\n\n    &--active {\n      i {\n        background: #86efac;\n        animation: iv-entry-wave 0.9s ease-in-out infinite;\n\n        &:nth-child(1) { height: 7px; animation-delay: 0s; }\n        &:nth-child(2) { height: 14px; animation-delay: 0.12s; }\n        &:nth-child(3) { height: 10px; animation-delay: 0.24s; }\n        &:nth-child(4) { height: 16px; animation-delay: 0.36s; }\n      }\n    }\n  }\n\n  &__video-live {\n    right: 18px;\n    top: 18px;\n    padding: 7px 12px;\n    background: rgba(15, 23, 42, 0.5);\n\n    &::before {\n      content: \"\";\n      width: 8px;\n      height: 8px;\n      border-radius: 999px;\n      background: #f59e0b;\n    }\n\n    &--on {\n      background: rgba(5, 150, 105, 0.82);\n\n      &::before {\n        background: #ffffff;\n      }\n    }\n  }\n\n  &__device-bar {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    margin-top: 10px;\n  }\n\n  &__device-pill {\n    min-height: 38px;\n    border-radius: 12px;\n    border: 1px solid #d7dee8;\n    background: #ffffff;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 0 11px;\n    color: #475569;\n    font-size: 0.82rem;\n    font-weight: 700;\n    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.035);\n    position: relative;\n\n    select {\n      appearance: none;\n      border: 0;\n      background: transparent;\n      color: inherit;\n      cursor: pointer;\n      flex: 1;\n      font: inherit;\n      min-width: 0;\n      overflow: hidden;\n      padding: 0 18px 0 0;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n\n      &:disabled {\n        cursor: default;\n        opacity: 1;\n      }\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    svg {\n      flex-shrink: 0;\n      color: #64748b;\n      font-size: 0.98rem;\n    }\n\n    &--ready {\n      color: #334155;\n      border-color: #cbd5e1;\n      background: #ffffff;\n    }\n\n    &:focus-within {\n      border-color: rgba(20, 184, 166, 0.52);\n      box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.12);\n    }\n  }\n\n  &__device-chevron {\n    position: absolute;\n    right: 11px;\n    pointer-events: none;\n  }\n\n  &__join-card {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  &__panel-header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 13px;\n  }\n\n  &__eyebrow {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: rgba(12, 148, 136, 0.08);\n    border: 1px solid rgba(12, 148, 136, 0.14);\n    color: #0f766e;\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n\n    &--panel {\n      box-shadow: 0 1px 0 rgba(255, 255, 255, 0.9) inset;\n    }\n  }\n\n  &__title {\n    margin: 0;\n    color: #0f172a;\n    font-size: clamp(2.05rem, 3vw, 3rem);\n    font-weight: 800;\n    line-height: 1.04;\n    letter-spacing: 0;\n  }\n\n  &__subtitle {\n    margin: 0;\n    max-width: 60ch;\n    color: #475569;\n    font-size: 1rem;\n    line-height: 1.72;\n\n    strong {\n      color: #0f172a;\n      font-weight: 700;\n    }\n  }\n\n  &__summary {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 10px;\n  }\n\n  &__summary-item {\n    padding: 12px 13px;\n    border-radius: 14px;\n    background: linear-gradient(180deg, #ffffff 0%, #f8fbfd 100%);\n    border: 1px solid #e5edf5;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    strong {\n      color: #0f172a;\n      font-size: 0.8rem;\n      font-weight: 700;\n      line-height: 1.4;\n    }\n  }\n\n  &__summary-label {\n    color: #64748b;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__tips {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  &__status-list {\n    display: grid;\n    gap: 10px;\n  }\n\n  &__status-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 46px;\n    padding: 0 13px;\n    border-radius: 14px;\n    background: #f8fafc;\n    border: 1px solid #e5edf4;\n    color: #64748b;\n    font-size: 0.93rem;\n    font-weight: 700;\n\n    svg {\n      flex-shrink: 0;\n    }\n\n    &--ready {\n      color: #047857;\n      background: #f0fdf4;\n      border-color: #bbf7d0;\n    }\n  }\n\n  &__tip {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 15px 16px;\n    border-radius: 18px;\n    background: linear-gradient(180deg, #fbfcfe 0%, #f8fbfd 100%);\n    border: 1px solid #e6edf5;\n    color: #334155;\n    font-size: 0.96rem;\n    line-height: 1.5;\n  }\n\n  &__tip-icon {\n    width: 44px;\n    height: 44px;\n    border-radius: 15px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: linear-gradient(135deg, rgba(124, 58, 237, 0.1), rgba(31, 180, 181, 0.12));\n    color: #6d28d9;\n    font-size: 1.1rem;\n  }\n\n  &__module {\n    border-radius: 16px;\n    padding: 18px;\n    border: 1px solid #e5edf4;\n    background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.035);\n\n    &--info {\n      background: linear-gradient(180deg, rgba(237, 251, 250, 0.78), #ffffff 62%);\n    }\n\n    &--checking {\n      background: linear-gradient(180deg, rgba(241, 245, 249, 0.94), #ffffff 76%);\n    }\n\n    &--error {\n      border-color: #fecaca;\n      background: linear-gradient(180deg, rgba(254, 242, 242, 0.92), #ffffff 70%);\n    }\n\n    &--ready {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n  }\n\n  &__module-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n  }\n\n  &__module-icon {\n    width: 46px;\n    height: 46px;\n    border-radius: 16px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: rgba(31, 180, 181, 0.1);\n    color: #0f766e;\n    font-size: 1.2rem;\n\n    &--error {\n      background: rgba(239, 68, 68, 0.12);\n      color: #b91c1c;\n    }\n  }\n\n  &__module-title {\n    color: #0f172a;\n    font-size: 1rem;\n    font-weight: 700;\n    margin-bottom: 6px;\n  }\n\n  &__module-copy {\n    margin: 0;\n    color: #475569;\n    font-size: 0.95rem;\n    line-height: 1.6;\n  }\n\n  &__checking {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    color: #475569;\n    font-size: 0.96rem;\n    font-weight: 600;\n  }\n\n  &__ready {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  &__ready-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    width: fit-content;\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: #d1fae5;\n    color: #065f46;\n    font-size: 0.88rem;\n    font-weight: 700;\n  }\n\n  &__mic-precheck {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 16px;\n    border-radius: 18px;\n    background: #f8fbfd;\n    border: 1px solid #e5edf4;\n  }\n\n  &__mic-precheck-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    color: #0f172a;\n    font-size: 0.96rem;\n\n    strong {\n      font-weight: 700;\n    }\n  }\n\n  &__mic-precheck-running {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #64748b;\n    font-size: 0.84rem;\n    font-weight: 600;\n  }\n\n  &__mic-precheck-status {\n    display: inline-flex;\n    width: fit-content;\n    padding: 6px 12px;\n    border-radius: 999px;\n    font-size: 0.82rem;\n    font-weight: 700;\n\n    &--good {\n      background: #d1fae5;\n      color: #065f46;\n    }\n\n    &--warning {\n      background: #fef3c7;\n      color: #92400e;\n    }\n\n    &--critical {\n      background: #fee2e2;\n      color: #991b1b;\n    }\n  }\n\n  &__mic-precheck-tip,\n  &__mic-precheck-error,\n  &__start-error {\n    margin: 0;\n    line-height: 1.55;\n  }\n\n  &__mic-precheck-tip {\n    color: #475569;\n    font-size: 0.9rem;\n  }\n\n  &__mic-precheck-details {\n    summary {\n      cursor: pointer;\n      color: #475569;\n      font-size: 0.86rem;\n      font-weight: 600;\n    }\n  }\n\n  &__mic-precheck-metrics {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n    color: #64748b;\n    font-size: 0.78rem;\n\n    span {\n      background: #ffffff;\n      border: 1px solid #dde7f0;\n      border-radius: 999px;\n      padding: 5px 9px;\n    }\n  }\n\n  &__mic-precheck-error {\n    color: #92400e;\n    font-size: 0.88rem;\n  }\n\n  &__consent-box {\n    background: #f8fafc;\n    border: 1px solid #e5edf4;\n    border-radius: 18px;\n    padding: 16px;\n  }\n\n  &__consent-label {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin: 0;\n    cursor: pointer;\n  }\n\n  &__consent-input {\n    margin-top: 4px;\n    accent-color: #059669;\n    flex-shrink: 0;\n  }\n\n  &__consent-text {\n    color: #334155;\n    font-size: 0.93rem;\n    line-height: 1.6;\n  }\n\n  &__start-error {\n    color: #b91c1c;\n    font-size: 0.9rem;\n  }\n\n  &__cta {\n    width: 100%;\n    justify-content: center;\n    gap: 10px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.58;\n      filter: grayscale(0.14);\n    }\n  }\n\n  .iv-btn {\n    box-shadow: none;\n  }\n\n  .iv-btn--primary,\n  .iv-btn--success {\n    box-shadow: 0 16px 28px rgba(91, 33, 182, 0.16);\n  }\n\n  .iv-btn--outline {\n    background: #ffffff;\n  }\n}\n\n@keyframes iv-entry-wave {\n  0%,\n  100% {\n    transform: scaleY(0.55);\n  }\n\n  50% {\n    transform: scaleY(1);\n  }\n}\n\n@media (max-width: 840px) {\n  .iv-entry {\n    padding: 24px 18px 38px;\n\n    &__shell {\n      min-height: auto;\n    }\n\n    &__panel {\n      padding: 0;\n      border-radius: 0;\n      gap: 22px;\n    }\n\n    &__layout {\n      grid-template-columns: 1fr;\n      gap: 28px;\n    }\n\n    &__join-card {\n      max-width: 640px;\n      margin: 0 auto;\n    }\n\n    &__video-frame {\n      border-radius: 24px;\n    }\n\n    &__summary {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .iv-entry {\n    min-height: auto;\n    padding: 16px 14px 30px;\n\n    &__panel {\n      padding: 0;\n      border-radius: 0;\n      gap: 18px;\n    }\n\n    &__brand {\n      line-height: 1;\n    }\n\n    &__brand-logo {\n      width: 34px;\n      height: 38px;\n    }\n\n    &__brand-copy {\n      strong {\n        max-width: calc(100vw - 96px);\n        font-size: 0.92rem;\n      }\n    }\n\n    &__video-frame {\n      border-radius: 18px;\n    }\n\n    &__video-name,\n    &__video-live {\n      font-size: 0.78rem;\n    }\n\n    &__video-name {\n      left: 12px;\n      bottom: 12px;\n    }\n\n    &__video-live {\n      right: 12px;\n      top: 12px;\n    }\n\n    &__device-bar {\n      grid-template-columns: 1fr;\n    }\n\n    &__device-pill {\n      min-height: 38px;\n    }\n\n    &__title {\n      font-size: 1.95rem;\n    }\n\n    &__subtitle,\n    &__module-copy,\n    &__consent-text {\n      font-size: 0.92rem;\n    }\n\n    &__tip,\n    &__summary-item,\n    &__module,\n    &__consent-box,\n    &__mic-precheck {\n      border-radius: 16px;\n    }\n\n    &__summary {\n      grid-template-columns: 1fr;\n    }\n\n    &__tip {\n      padding: 13px 14px;\n    }\n\n    &__tip-icon,\n    &__module-icon {\n      width: 40px;\n      height: 40px;\n      border-radius: 14px;\n    }\n\n    &__mic-precheck-head {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    &__checking {\n      font-size: 0.9rem;\n    }\n\n    &__shell {\n      min-height: auto;\n    }\n  }\n}\n\n/* ── InterviewSession — Full-screen video call layout ── */\n.iv-fullscreen {\n  position: relative;\n  --iv-edge: 20px;\n  --iv-panel-width: clamp(318px, 24vw, 380px);\n  --iv-panel-gap: 12px;\n  --iv-bottom-clearance: 72px;\n  width: 100%;\n  min-height: 100vh;\n  background: #3f3f3f;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  &--loading {\n    gap: 16px;\n    color: #9CA3AF;\n    p { margin: 0; font-size: 0.95rem; }\n  }\n\n  &--done {\n    .iv-fullscreen__temi-stage {\n      box-sizing: border-box;\n      padding: 0;\n    }\n\n    .avatar-controller {\n      width: 104%;\n      height: 104%;\n    }\n\n    .iv-fullscreen__temi-status {\n      bottom: clamp(270px, 34vh, 360px);\n    }\n\n    .iv-fullscreen__done-panel {\n      position: absolute;\n      left: 50%;\n      bottom: clamp(34px, 7vh, 74px);\n      transform: translateX(-50%);\n    }\n  }\n\n  /* Mirrored camera as full background */\n  &__video {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transform: scaleX(-1);\n    z-index: 0;\n  }\n\n  &__temi-stage {\n    position: absolute;\n    right: calc(var(--iv-edge) + var(--iv-panel-width) + var(--iv-panel-gap) + 30px);\n    bottom: 92px;\n    width: clamp(160px, 8.2vw, 128px);\n    height: clamp(160px, 8.2vw, 128px);\n    z-index: 13;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    border-radius: 20px;\n    background: rgba(36, 40, 48, 0.86);\n    border: 1px solid rgba(248, 137, 137, 0.18);\n    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.34);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: linear-gradient(180deg, rgba(255, 255, 255, 0.1), transparent 58%);\n      pointer-events: none;\n    }\n\n    .avatar-controller,\n    .iv-temi {\n      width: 80%;\n      height: 80%;\n      transform: translateY(-6px);\n    }\n  }\n\n  &__temi-grid {\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(rgba(255,255,255,0.055) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(255,255,255,0.055) 1px, transparent 1px);\n    background-size: 56px 56px;\n    mask-image: radial-gradient(circle at center, #000 0%, transparent 70%);\n    opacity: 0;\n  }\n\n  &__temi-orbit {\n    position: absolute;\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    border-radius: 50%;\n    animation: iv-temi-orbit 18s linear infinite;\n    opacity: 0;\n\n    &--outer {\n      width: min(64vw, 680px);\n      height: min(64vw, 680px);\n    }\n\n    &--inner {\n      width: min(42vw, 450px);\n      height: min(42vw, 450px);\n      animation-duration: 12s;\n      animation-direction: reverse;\n      border-color: rgba(45, 212, 191, 0.18);\n    }\n  }\n\n  &__temi-status {\n    position: absolute;\n    left: 50%;\n    bottom: 118px;\n    transform: translateX(-50%);\n    display: inline-flex;\n    align-items: center;\n    gap: 9px;\n    padding: 10px 16px;\n    border-radius: 999px;\n    background: rgba(4, 13, 22, 0.58);\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    color: rgba(255, 255, 255, 0.82);\n    font-size: 0.86rem;\n    font-weight: 650;\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.28);\n  }\n\n  &__temi-dot {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    background: #2dd4bf;\n    box-shadow: 0 0 0 6px rgba(45, 212, 191, 0.14);\n    animation: iv-temi-pulse 1.6s ease-in-out infinite;\n  }\n\n  &__candidate-pip {\n    position: absolute;\n    top: var(--iv-edge);\n    left: var(--iv-edge);\n    right: calc(var(--iv-edge) + var(--iv-panel-width) + var(--iv-panel-gap));\n    bottom: var(--iv-bottom-clearance);\n    z-index: 1;\n    width: auto;\n    aspect-ratio: auto;\n    border-radius: 16px;\n    overflow: hidden;\n    background: #111827;\n    border: 4px solid rgba(255, 255, 255, 0.88);\n    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4);\n    transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;\n\n    &--recording {\n      border-color: rgba(255, 255, 255, 0.96);\n      box-shadow: 0 0 0 5px rgba(45, 212, 191, 0.18), 0 24px 70px rgba(0, 0, 0, 0.42);\n    }\n\n    &--speaking {\n      border-color: rgba(110, 231, 183, 0.96);\n      box-shadow: 0 0 0 6px rgba(34, 197, 94, 0.2), 0 24px 70px rgba(0, 0, 0, 0.42);\n    }\n\n    &--error {\n      border-color: rgba(252, 165, 165, 0.8);\n    }\n  }\n\n  &__conversation-panel {\n    position: absolute;\n    top: var(--iv-edge);\n    right: var(--iv-edge);\n    bottom: var(--iv-bottom-clearance);\n    z-index: 13;\n    width: var(--iv-panel-width);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    border-radius: 16px;\n    background: #f8fafc;\n    border: 1px solid rgba(15, 23, 42, 0.12);\n    box-shadow: 0 24px 70px rgba(0, 0, 0, 0.34);\n  }\n\n  &__conversation-head {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 13px 14px 12px;\n    border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n    background: #ffffff;\n\n    > div {\n      min-width: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 3px;\n    }\n\n    strong {\n      color: #0f172a;\n      font-size: 0.98rem;\n      line-height: 1.25;\n    }\n\n    span {\n      color: #64748b;\n      font-size: 0.78rem;\n      line-height: 1.35;\n    }\n  }\n\n  &__conversation-close {\n    flex: 0 0 auto;\n    width: 32px;\n    height: 32px;\n    border: 1px solid rgba(100, 116, 139, 0.18);\n    border-radius: 10px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #ffffff;\n    color: #475569;\n    cursor: pointer;\n    transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    &:hover {\n      background: #f8fafc;\n      border-color: rgba(100, 116, 139, 0.32);\n      color: #0f172a;\n    }\n  }\n\n  &__conversation-count {\n    flex: 0 0 auto;\n    align-self: flex-start;\n    padding: 5px 9px;\n    border-radius: 999px;\n    background: #e0f2fe;\n    border: 1px solid #bae6fd;\n    color: #0369a1 !important;\n    font-size: 0.74rem !important;\n    font-weight: 750;\n    white-space: nowrap;\n  }\n\n  &__conversation-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(100, 116, 139, 0.4) transparent;\n  }\n\n  &__conversation-empty {\n    margin: auto 0;\n    padding: 18px 14px;\n    border-radius: 14px;\n    border: 1px dashed rgba(100, 116, 139, 0.28);\n    color: #64748b;\n    font-size: 0.84rem;\n    line-height: 1.55;\n    text-align: center;\n  }\n\n  &__conversation-turn {\n    max-width: 92%;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 10px 12px;\n    border-radius: 14px;\n    border: 1px solid rgba(15, 23, 42, 0.06);\n    color: #0f172a;\n    background: #eef2f7;\n\n    p {\n      margin: 0;\n      color: #1e293b;\n      font-size: 0.86rem;\n      line-height: 1.52;\n      overflow-wrap: anywhere;\n    }\n\n    &--temi {\n      align-self: flex-start;\n      border-color: rgba(148, 163, 184, 0.2);\n      background: #f1f5f9;\n    }\n\n    &--candidate {\n      align-self: flex-end;\n      border-color: rgba(18, 183, 173, 0.34);\n      background: #12b7ad;\n      color: #ffffff;\n\n      p,\n      .iv-fullscreen__conversation-speaker span,\n      .iv-fullscreen__conversation-speaker small {\n        color: rgba(255, 255, 255, 0.94);\n      }\n    }\n\n    &--system {\n      align-self: center;\n      max-width: 100%;\n      border-color: rgba(124, 58, 237, 0.14);\n      background: #f5f3ff;\n    }\n\n    &--processing,\n    &--live {\n      border-style: dashed;\n    }\n\n    &--error {\n      border-color: rgba(248, 113, 113, 0.38);\n      background: #fee2e2;\n    }\n  }\n\n  &__conversation-speaker {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    span {\n      color: #64748b;\n      font-size: 0.72rem;\n      font-weight: 800;\n      letter-spacing: 0.02em;\n      text-transform: uppercase;\n    }\n\n    small {\n      color: #64748b;\n      font-size: 0.7rem;\n      font-weight: 700;\n      white-space: nowrap;\n    }\n  }\n\n  .iv-typing-dots {\n    min-width: 34px;\n    min-height: 20px;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n\n    i {\n      width: 6px;\n      height: 6px;\n      border-radius: 999px;\n      background: currentColor;\n      opacity: 0.34;\n      animation: iv-typing-dot 1s ease-in-out infinite;\n\n      &:nth-child(2) {\n        animation-delay: 0.14s;\n      }\n\n      &:nth-child(3) {\n        animation-delay: 0.28s;\n      }\n    }\n  }\n\n  &__self-video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transform: scaleX(-1);\n    display: block;\n  }\n\n  &__candidate-label {\n    position: absolute;\n    left: 22px;\n    bottom: 22px;\n    min-height: 34px;\n    padding: 7px 12px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    background: rgba(15, 23, 42, 0.58);\n    color: #fff;\n    font-size: 0.84rem;\n    font-weight: 750;\n    letter-spacing: 0.01em;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.24);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n  }\n\n  &__job-caption {\n    position: absolute;\n    left: var(--iv-edge);\n    bottom: 30px;\n    z-index: 32;\n    max-width: min(46vw, 620px);\n    display: inline-flex;\n    align-items: center;\n    color: #ffffff;\n    font-size: 0.92rem;\n    font-weight: 800;\n    line-height: 1.25;\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.58);\n    overflow: hidden;\n\n    span {\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &__temi-card-label {\n    position: absolute;\n    left: 14px;\n    right: 14px;\n    bottom: 12px;\n    z-index: 3;\n    min-height: 34px;\n    padding: 7px 10px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    background: rgba(15, 23, 42, 0.66);\n    color: #ffffff;\n    font-size: 0.84rem;\n    font-weight: 800;\n    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.24);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n  }\n\n  /* Camera status badge */\n  &__cam-status {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #9CA3AF;\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    z-index: 2;\n\n    &--error { color: #FCA5A5; }\n  }\n\n  &--media-blocked {\n    .iv-fullscreen__question-wrap,\n    .iv-fullscreen__bottom-bar,\n    .iv-fullscreen__candidate-pip,\n    .iv-fullscreen__conversation-panel,\n    .iv-fullscreen__temi-status,\n    .iv-fullscreen__top-bar {\n      opacity: 0.22;\n      filter: saturate(0.72);\n      transition: opacity 0.2s ease, filter 0.2s ease;\n    }\n  }\n\n  &--transcript-closed {\n    .iv-fullscreen__candidate-pip {\n      right: var(--iv-edge);\n    }\n\n    .iv-fullscreen__temi-stage {\n      right: calc(var(--iv-edge) + 8px);\n    }\n\n    .iv-fullscreen__job-caption {\n      max-width: min(62vw, 720px);\n    }\n  }\n\n  &__media-recovery {\n    position: absolute;\n    inset: 0;\n    z-index: 24;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    background:\n      radial-gradient(circle at center, rgba(15, 23, 42, 0.24), rgba(2, 6, 23, 0.72) 72%),\n      linear-gradient(180deg, rgba(8, 13, 24, 0.18), rgba(8, 13, 24, 0.54));\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    font-size: 0;\n    line-height: 0;\n    color: transparent;\n  }\n\n  &__media-card {\n    width: min(92vw, 560px);\n    padding: 28px 26px;\n    border-radius: 24px;\n    background: rgba(8, 13, 24, 0.9);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    box-shadow:\n      0 30px 80px rgba(0, 0, 0, 0.42),\n      0 0 0 1px rgba(45, 212, 191, 0.06);\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    color: #f8fafc;\n    font-size: 1rem;\n    line-height: 1.6;\n    pointer-events: auto;\n  }\n\n  &__media-badge {\n    align-self: flex-start;\n    padding: 7px 12px;\n    border-radius: 999px;\n    background: rgba(45, 212, 191, 0.14);\n    border: 1px solid rgba(45, 212, 191, 0.24);\n    color: #ccfbf1;\n    font-size: 0.8rem;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__media-title {\n    margin: 0;\n    color: #ffffff;\n    font-size: clamp(1.5rem, 2.8vw, 2rem);\n    font-weight: 750;\n    line-height: 1.18;\n  }\n\n  &__media-copy {\n    margin: 0;\n    color: rgba(226, 232, 240, 0.86);\n    font-size: 0.98rem;\n    line-height: 1.7;\n  }\n\n  &__media-steps {\n    display: grid;\n    gap: 12px;\n  }\n\n  &__media-step {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 14px;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: rgba(241, 245, 249, 0.92);\n    font-size: 0.94rem;\n    line-height: 1.6;\n  }\n\n  &__media-step-index {\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(124, 58, 237, 0.18);\n    border: 1px solid rgba(167, 139, 250, 0.24);\n    color: #ddd6fe;\n    font-size: 0.82rem;\n    font-weight: 700;\n    line-height: 1;\n  }\n\n  &__media-error {\n    margin: 0;\n    padding: 12px 14px;\n    border-radius: 14px;\n    background: rgba(127, 29, 29, 0.32);\n    border: 1px solid rgba(248, 113, 113, 0.22);\n    color: #fecaca;\n    font-size: 0.92rem;\n    line-height: 1.6;\n  }\n\n  /* ── Top progress bar ── */\n  &__top-bar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 0 0 6px;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, transparent 100%);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 20px 20px;\n  }\n\n  &__progress-track {\n    flex: 1;\n    height: 4px;\n    background: rgba(255,255,255,0.2);\n    border-radius: 99px;\n    overflow: hidden;\n  }\n\n  &__progress-fill {\n    height: 100%;\n    background: #7C3AED;\n    border-radius: 99px;\n    transition: width 0.5s ease;\n  }\n\n  &__progress-label {\n    color: rgba(255,255,255,0.8);\n    font-size: 0.8rem;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  /* ── Question card (glassmorphism) ── */\n  &__question-wrap {\n    position: absolute;\n    top: clamp(46px, 7vh, 60px);\n    left: 50%;\n    transform: translateX(-50%);\n    width: min(92vw, clamp(560px, 47vw, 680px));\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n  }\n\n  @media (min-width: 1080px) {\n    &__temi-stage {\n      box-sizing: border-box;\n      padding: 0;\n    }\n\n    &__temi-status {\n      left: calc(50% - clamp(175px, 14vw, 225px));\n    }\n\n    &__question-wrap {\n      left: calc(50% - clamp(175px, 14vw, 225px));\n      width: min(58vw, 690px);\n    }\n\n    &__top-bar,\n    &__bottom-bar {\n      right: calc(var(--iv-panel-width) + var(--iv-edge) + var(--iv-panel-gap));\n    }\n\n    &--transcript-closed {\n      .iv-fullscreen__top-bar,\n      .iv-fullscreen__bottom-bar {\n        right: 0;\n      }\n    }\n  }\n\n  &__resume-notice {\n    width: 100%;\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: rgba(8, 13, 24, 0.64);\n    border: 1px solid rgba(45, 212, 191, 0.28);\n    color: #ccfbf1;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-align: center;\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    box-shadow: 0 10px 22px rgba(8, 13, 24, 0.18);\n  }\n\n  &__question-card {\n    width: 100%;\n    background: rgba(15, 15, 25, 0.72);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: clamp(16px, 1.4vw, 18px);\n    padding: clamp(16px, 1.8vw, 22px) clamp(18px, 2.2vw, 28px);\n    color: #fff;\n\n    &--compact {\n      width: auto;\n      align-self: center;\n      padding: 10px 13px;\n      border-radius: 999px;\n      background: rgba(8, 13, 24, 0.58);\n      box-shadow: 0 14px 34px rgba(0, 0, 0, 0.22);\n\n      .iv-fullscreen__question-meta {\n        margin-bottom: 0;\n      }\n\n      .iv-fullscreen__ai-speaking {\n        margin-top: 8px;\n        padding-top: 8px;\n      }\n    }\n  }\n\n  &__question-meta {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: clamp(10px, 1vw, 12px);\n  }\n\n  &__q-index {\n    font-size: 0.78rem;\n    font-weight: 700;\n    background: rgba(124,58,237,0.35);\n    border: 1px solid rgba(124,58,237,0.5);\n    color: #DDD6FE;\n    padding: 3px 11px;\n    border-radius: 99px;\n  }\n\n  &__q-cat {\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 3px 11px;\n    border-radius: 99px;\n\n    &--technical       { background: rgba(30,64,175,0.4); color: #BFDBFE; border: 1px solid rgba(147,197,253,0.3); }\n    &--communication   { background: rgba(6,78,59,0.4);  color: #A7F3D0; border: 1px solid rgba(110,231,183,0.3); }\n    &--problem_solving { background: rgba(157,23,77,0.4); color: #FBCFE8; border: 1px solid rgba(249,168,212,0.3); }\n  }\n\n  &__question-text {\n    max-width: 62ch;\n    font-size: clamp(1rem, 1.08vw, 1.1rem);\n    font-weight: 500;\n    line-height: 1.58;\n    color: #F9FAFB;\n    margin: 0;\n  }\n\n  /* AI speaking wave */\n  &__ai-speaking {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    margin-top: clamp(10px, 1vw, 14px);\n    padding-top: clamp(10px, 0.9vw, 12px);\n    border-top: 1px solid rgba(255,255,255,0.1);\n    color: #A78BFA;\n    font-size: 0.82rem;\n    font-weight: 600;\n  }\n\n  &__wave {\n    display: inline-block;\n    width: 3px;\n    border-radius: 99px;\n    background: #A78BFA;\n    animation: iv-wave 1.2s ease-in-out infinite;\n\n    &:nth-child(1) { height: 8px;  animation-delay: 0s; }\n    &:nth-child(2) { height: 14px; animation-delay: 0.15s; }\n    &:nth-child(3) { height: 10px; animation-delay: 0.3s; }\n    &:nth-child(4) { height: 6px;  animation-delay: 0.45s; }\n  }\n\n  /* ── Bottom controls ── */\n  &__bottom-bar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 32px 24px 28px;\n    // background: linear-gradient(to top, rgba(229, 231, 235, 0.96) 0%, rgba(229, 231, 235, 0.74) 58%, transparent 100%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n\n  /* Transcript preview bubble */\n  &__transcript {\n    max-width: 660px;\n    width: 100%;\n    background: rgba(0,0,0,0.55);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 14px;\n    padding: 12px 18px;\n    color: rgba(255,255,255,0.9);\n    font-size: 0.95rem;\n    line-height: 1.55;\n    text-align: center;\n    font-style: italic;\n\n    &--live {\n      border-color: rgba(239,68,68,0.5);\n      background: rgba(127,29,29,0.4);\n      color: #FEE2E2;\n    }\n  }\n\n  /* Text fallback input */\n  &__text-input {\n    max-width: 660px;\n    width: 100%;\n    background: rgba(255,255,255,0.1);\n    border: 1.5px solid rgba(255,255,255,0.25);\n    border-radius: 12px;\n    padding: 12px 16px;\n    color: #fff;\n    font-size: 0.95rem;\n    resize: none;\n\n    &::placeholder { color: rgba(255,255,255,0.4); }\n    &:focus { outline: none; border-color: #7C3AED; }\n  }\n\n  /* Status hint */\n  &__hint {\n    color: #475569;\n    font-size: 0.85rem;\n    margin: 0;\n    text-align: center;\n  }\n\n  &__error {\n    color: #b91c1c;\n    font-size: 0.85rem;\n    margin: 0;\n    text-align: center;\n  }\n\n  /* Controls row */\n  &__controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n  }\n\n  /* ── Done panel ── */\n  &--ending {\n    .iv-fullscreen__candidate-pip {\n      border-color: rgba(255, 255, 255, 0.28);\n      filter: grayscale(0.9) brightness(0.42);\n      transform: scale(0.985);\n      transition: filter 420ms ease, transform 420ms ease, border-color 420ms ease;\n    }\n\n    .iv-fullscreen__conversation-panel,\n    .iv-fullscreen__temi-stage {\n      opacity: 0.42;\n      filter: saturate(0.7);\n      transition: opacity 420ms ease, filter 420ms ease;\n    }\n  }\n\n  &__ending-overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 40;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n    background:\n      radial-gradient(circle at center, rgba(15, 23, 42, 0.18), rgba(2, 6, 23, 0.68) 68%),\n      rgba(2, 6, 23, 0.46);\n    color: #ffffff;\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n    animation: iv-meeting-end 420ms ease both;\n  }\n\n  &__ending-status {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    text-align: center;\n    text-shadow: 0 10px 34px rgba(0, 0, 0, 0.42);\n\n    strong {\n      font-size: clamp(1.45rem, 2.6vw, 2rem);\n      font-weight: 850;\n      line-height: 1.2;\n    }\n\n    span {\n      color: rgba(226, 232, 240, 0.84);\n      font-size: 0.96rem;\n      font-weight: 650;\n    }\n\n    small {\n      max-width: 42ch;\n      color: #fecaca;\n      font-size: 0.82rem;\n      line-height: 1.45;\n    }\n  }\n\n  &__ending-dot {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #22c55e;\n    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0.14);\n    animation: iv-temi-pulse 1.2s ease-in-out infinite;\n  }\n\n  &__done-panel {\n    position: relative;\n    z-index: 10;\n    text-align: center;\n    background: rgba(15,15,25,0.78);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 20px;\n    padding: 30px 38px;\n    max-width: 500px;\n    width: 90vw;\n    color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 28px 80px rgba(0, 0, 0, 0.34);\n\n    h2 { font-size: 1.4rem; font-weight: 700; margin: 0; }\n    p  { color: rgba(255,255,255,0.65); font-size: 0.95rem; margin: 0; }\n  }\n\n  &__done-icon { font-size: 2.75rem; }\n\n  &--review {\n    .iv-fullscreen__temi-stage {\n      box-sizing: border-box;\n      padding: 0;\n    }\n\n    .avatar-controller {\n      transform: translateY(-8px);\n    }\n\n    .iv-fullscreen__temi-status {\n      bottom: clamp(156px, 19vh, 214px);\n    }\n\n    .iv-fullscreen__candidate-pip {\n      bottom: var(--iv-bottom-clearance);\n    }\n\n    .iv-fullscreen__bottom-bar {\n      padding: 18px 20px 16px;\n      gap: 8px;\n      background: linear-gradient(to top, rgba(229, 231, 235, 0.98) 0%, rgba(229, 231, 235, 0.78) 52%, transparent 100%);\n    }\n  }\n\n  &__quick-actions {\n    position: absolute;\n    right: var(--iv-edge);\n    bottom: 20px;\n    z-index: 32;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__quick-btn {\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    border: 1px solid rgba(100, 116, 139, 0.24);\n    background: rgba(255, 255, 255, 0.94);\n    color: #334155;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 14px 32px rgba(15, 23, 42, 0.16);\n    transition: transform 0.18s ease, border-color 0.18s ease, color 0.18s ease, background 0.18s ease;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n\n    &:hover {\n      transform: translateY(-1px);\n      border-color: rgba(18, 183, 173, 0.42);\n      color: #0f766e;\n      background: #ffffff;\n    }\n\n    &--active {\n      border-color: rgba(18, 183, 173, 0.48);\n      color: #0f766e;\n      background: #ecfdf5;\n    }\n  }\n\n  &__info-modal {\n    position: absolute;\n    inset: 0;\n    z-index: 60;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background: rgba(15, 23, 42, 0.42);\n    backdrop-filter: blur(6px);\n    -webkit-backdrop-filter: blur(6px);\n  }\n\n  &__info-card {\n    width: min(92vw, 520px);\n    max-height: min(78vh, 620px);\n    overflow-y: auto;\n    border-radius: 16px;\n    background: #ffffff;\n    border: 1px solid rgba(100, 116, 139, 0.18);\n    box-shadow: 0 30px 80px rgba(15, 23, 42, 0.28);\n  }\n\n  &__info-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 20px 20px 14px;\n    border-bottom: 1px solid rgba(100, 116, 139, 0.14);\n\n    span {\n      display: block;\n      margin-bottom: 4px;\n      color: #0f766e;\n      font-size: 0.76rem;\n      font-weight: 800;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n\n    h2 {\n      margin: 0;\n      color: #0f172a;\n      font-size: 1.25rem;\n      font-weight: 850;\n      line-height: 1.25;\n    }\n  }\n\n  &__info-close {\n    flex: 0 0 auto;\n    width: 34px;\n    height: 34px;\n    border: 1px solid rgba(100, 116, 139, 0.18);\n    border-radius: 10px;\n    background: #f8fafc;\n    color: #475569;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    &:hover {\n      color: #0f172a;\n      background: #ffffff;\n    }\n  }\n\n  &__info-body {\n    padding: 16px 20px 20px;\n    display: grid;\n    gap: 10px;\n\n    p {\n      margin: 0;\n      padding: 12px 14px;\n      border-radius: 12px;\n      background: #f8fafc;\n      border: 1px solid rgba(100, 116, 139, 0.12);\n      color: #334155;\n      font-size: 0.92rem;\n      line-height: 1.55;\n    }\n  }\n\n  &__exit-modal {\n    position: absolute;\n    inset: 0;\n    z-index: 72;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    background:\n      radial-gradient(circle at center, rgba(15, 23, 42, 0.18), rgba(15, 23, 42, 0.52) 70%),\n      rgba(15, 23, 42, 0.34);\n    backdrop-filter: blur(7px);\n    -webkit-backdrop-filter: blur(7px);\n  }\n\n  &__exit-card {\n    width: min(92vw, 540px);\n    border-radius: 16px;\n    background: #ffffff;\n    border: 1px solid rgba(148, 163, 184, 0.22);\n    box-shadow: 0 32px 90px rgba(15, 23, 42, 0.34);\n    padding: 22px;\n    display: grid;\n    grid-template-columns: 52px 1fr;\n    gap: 16px;\n    animation: iv-exit-modal-in 180ms ease both;\n  }\n\n  &__exit-icon {\n    width: 52px;\n    height: 52px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff7ed;\n    border: 1px solid #fed7aa;\n    color: #c2410c;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  &__exit-content {\n    min-width: 0;\n\n    h2 {\n      margin: 3px 0 8px;\n      color: #0f172a;\n      font-size: clamp(1.2rem, 2.4vw, 1.5rem);\n      font-weight: 850;\n      line-height: 1.2;\n    }\n\n    p {\n      margin: 0;\n      color: #475569;\n      font-size: 0.94rem;\n      line-height: 1.6;\n    }\n  }\n\n  &__exit-eyebrow {\n    color: #0f766e;\n    font-size: 0.75rem;\n    font-weight: 850;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n  }\n\n  &__exit-note {\n    margin-top: 12px;\n    padding: 10px 12px;\n    border-radius: 12px;\n    background: #f8fafc;\n    border: 1px solid rgba(100, 116, 139, 0.14);\n    color: #334155;\n    font-size: 0.84rem;\n    line-height: 1.5;\n  }\n\n  &__exit-actions {\n    grid-column: 1 / -1;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding-top: 4px;\n  }\n\n  &__exit-btn {\n    min-height: 42px;\n    border-radius: 11px;\n    padding: 10px 15px;\n    border: 1px solid transparent;\n    font-size: 0.9rem;\n    font-weight: 800;\n    cursor: pointer;\n    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;\n\n    &:hover {\n      transform: translateY(-1px);\n    }\n\n    &--stay {\n      background: #12b7ad;\n      color: #ffffff;\n      box-shadow: 0 14px 28px rgba(18, 183, 173, 0.22);\n    }\n\n    &--leave {\n      background: #ffffff;\n      color: #b91c1c;\n      border-color: rgba(185, 28, 28, 0.22);\n\n      &:hover {\n        background: #fef2f2;\n        border-color: rgba(185, 28, 28, 0.34);\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    --iv-edge: 12px;\n    --iv-panel-width: calc(100vw - 24px);\n    --iv-bottom-clearance: 44vh;\n\n    &--done {\n      .iv-fullscreen__temi-stage {\n        padding-bottom: 230px;\n      }\n\n      .iv-fullscreen__temi-status {\n        bottom: 265px;\n      }\n\n      .iv-fullscreen__done-panel {\n        bottom: 24px;\n      }\n    }\n\n    &__done-panel {\n      padding: 24px 22px;\n      width: min(92vw, 420px);\n    }\n\n    &__media-recovery {\n      padding: 18px;\n      align-items: flex-end;\n    }\n\n    &__media-card {\n      width: 100%;\n      padding: 22px 18px;\n      border-radius: 20px;\n      gap: 14px;\n    }\n\n  }\n}\n\n.iv-temi {\n  position: relative;\n  z-index: 2;\n  width: clamp(260px, 31vw, 430px);\n  height: clamp(320px, 39vw, 500px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: iv-temi-float 4.4s ease-in-out infinite;\n\n  &__halo {\n    position: absolute;\n    width: 94%;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background:\n      radial-gradient(circle, rgba(45, 212, 191, 0.2), transparent 58%),\n      radial-gradient(circle, rgba(250, 204, 21, 0.12), transparent 72%);\n    filter: blur(6px);\n    animation: iv-temi-breathe 2.8s ease-in-out infinite;\n  }\n\n  &__focus-ring {\n    position: absolute;\n    width: 82%;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    border: 1px solid rgba(250, 204, 21, 0.22);\n    box-shadow: inset 0 0 44px rgba(45, 212, 191, 0.12);\n    animation: iv-temi-orbit 18s linear infinite;\n  }\n\n  &__rig {\n    position: relative;\n    z-index: 2;\n    width: min(100%, 420px);\n    height: min(100%, 420px);\n    filter: drop-shadow(0 28px 44px rgba(0, 0, 0, 0.34));\n    transform-style: preserve-3d;\n  }\n\n  &__fallback,\n  &__layer {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n    user-select: none;\n    pointer-events: none;\n  }\n\n  &__fallback {\n    opacity: 0;\n  }\n\n  &__layer {\n    will-change: transform;\n  }\n\n  &__layer--left-arm { z-index: 1; }\n  &__layer--body { z-index: 2; }\n  &__layer--right-arm { z-index: 3; }\n  &__layer--head { z-index: 4; }\n\n  &__mouth-pulse {\n    position: absolute;\n    z-index: 6;\n    left: 45%;\n    top: 47%;\n    width: 17%;\n    height: 10%;\n    border-radius: 999px;\n    background: radial-gradient(ellipse at center, rgba(250, 204, 21, 0.78), rgba(250, 204, 21, 0.16) 60%, transparent 72%);\n    filter: blur(4px);\n    mix-blend-mode: screen;\n  }\n\n  &__sound-bars {\n    position: absolute;\n    z-index: 7;\n    right: 17%;\n    top: 30%;\n    display: flex;\n    align-items: flex-end;\n    gap: 5px;\n    padding: 7px 8px;\n    border-radius: 999px;\n    background: rgba(8, 13, 24, 0.46);\n    border: 1px solid rgba(255,255,255,0.12);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n\n    span {\n      width: 5px;\n      height: 12px;\n      border-radius: 999px;\n      background: #facc15;\n      transform-origin: bottom;\n\n      &:nth-child(2) { height: 20px; }\n      &:nth-child(3) { height: 15px; }\n    }\n  }\n\n  &__screen-scan {\n    position: absolute;\n    z-index: 7;\n    left: 31%;\n    top: 29%;\n    width: 38%;\n    height: 8px;\n    border-radius: 999px;\n    background: linear-gradient(90deg, transparent, rgba(167, 139, 250, 0.75), transparent);\n    box-shadow: 0 0 16px rgba(167, 139, 250, 0.35);\n    mix-blend-mode: screen;\n  }\n\n  &__sparkles {\n    position: absolute;\n    inset: 0;\n    z-index: 8;\n    pointer-events: none;\n\n    span {\n      position: absolute;\n      width: 18px;\n      height: 18px;\n\n      &::before,\n      &::after {\n        content: '';\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        width: 18px;\n        height: 3px;\n        border-radius: 999px;\n        background: #34d399;\n        transform: translate(-50%, -50%);\n      }\n\n      &::after {\n        transform: translate(-50%, -50%) rotate(90deg);\n      }\n\n      &:nth-child(1) { left: 22%; top: 24%; }\n      &:nth-child(2) { right: 20%; top: 22%; }\n      &:nth-child(3) { right: 16%; top: 50%; }\n    }\n  }\n\n  &__warning-mark {\n    position: absolute;\n    z-index: 8;\n    right: 18%;\n    top: 27%;\n    width: 36px;\n    height: 42px;\n    border-radius: 16px;\n    background: rgba(245, 158, 11, 0.95);\n    color: #111827;\n    font-size: 1.6rem;\n    font-weight: 900;\n    line-height: 42px;\n    text-align: center;\n    box-shadow: 0 0 24px rgba(245, 158, 11, 0.38);\n  }\n\n  &__shadow {\n    position: absolute;\n    z-index: 1;\n    bottom: 13%;\n    width: 52%;\n    height: 34px;\n    border-radius: 50%;\n    background: radial-gradient(ellipse at center, rgba(0,0,0,0.36), transparent 70%);\n    filter: blur(8px);\n  }\n\n  &--speaking {\n    .iv-temi__halo {\n      background:\n        radial-gradient(circle, rgba(250, 204, 21, 0.2), transparent 58%),\n        radial-gradient(circle, rgba(45, 212, 191, 0.14), transparent 72%);\n    }\n  }\n\n  &--recording {\n    .iv-temi__halo {\n      background: radial-gradient(circle, rgba(239, 68, 68, 0.2), transparent 62%);\n    }\n\n    .iv-temi__focus-ring {\n      border-color: rgba(239, 68, 68, 0.34);\n      box-shadow: inset 0 0 44px rgba(239, 68, 68, 0.14);\n    }\n  }\n\n  &--thinking {\n    .iv-temi__halo {\n      background: radial-gradient(circle, rgba(124, 58, 237, 0.2), transparent 62%);\n    }\n  }\n\n  &--success {\n    .iv-temi__halo {\n      background: radial-gradient(circle, rgba(52, 211, 153, 0.22), transparent 62%);\n    }\n  }\n\n  &--warning {\n    .iv-temi__halo {\n      background: radial-gradient(circle, rgba(245, 158, 11, 0.24), transparent 62%);\n    }\n  }\n}\n\n/* ── Conversational turn status ── */\n.iv-conversation-turn {\n  min-width: 230px;\n  min-height: 58px;\n  padding: 12px 18px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #0f172a;\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(100, 116, 139, 0.2);\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.14);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.iv-conversation-turn__pulse {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #2dd4bf;\n  box-shadow: 0 0 0 7px rgba(45, 212, 191, 0.16);\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: -9px;\n    border-radius: inherit;\n    border: 1px solid rgba(45, 212, 191, 0.42);\n    animation: iv-rec-ring 1.45s ease-out infinite;\n  }\n}\n\n.iv-conversation-turn__label {\n  font-size: 0.9rem;\n  font-weight: 750;\n  letter-spacing: 0.01em;\n}\n\n.iv-conversation-turn--asking {\n  border-color: rgba(125, 211, 252, 0.3);\n\n  .iv-conversation-turn__pulse {\n    background: #38bdf8;\n    box-shadow: 0 0 0 7px rgba(56, 189, 248, 0.16);\n  }\n}\n\n.iv-conversation-turn--speaking {\n  border-color: rgba(52, 211, 153, 0.4);\n  background: rgba(236, 253, 245, 0.94);\n\n  .iv-conversation-turn__pulse {\n    background: #22c55e;\n    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.18);\n  }\n}\n\n.iv-conversation-turn--ready {\n  opacity: 0.78;\n}\n\n.iv-soundwave {\n  width: 26px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n\n  i {\n    display: block;\n    width: 3px;\n    height: 5px;\n    border-radius: 999px;\n    background: #86efac;\n  }\n\n  &--idle {\n    opacity: 0.58;\n    gap: 4px;\n\n    i {\n      width: 5px;\n      height: 5px;\n      animation: none;\n      background: rgba(134, 239, 172, 0.72);\n    }\n  }\n\n  &--active {\n    opacity: 1;\n\n    i {\n      animation: iv-entry-wave 0.9s ease-in-out infinite;\n\n      &:nth-child(1) { height: 7px; animation-delay: 0s; }\n      &:nth-child(2) { height: 14px; animation-delay: 0.12s; }\n      &:nth-child(3) { height: 10px; animation-delay: 0.24s; }\n      &:nth-child(4) { height: 16px; animation-delay: 0.36s; }\n    }\n  }\n\n  &--candidate {\n    i {\n      background: #67e8f9;\n    }\n\n    &.iv-soundwave--idle i {\n      background: rgba(103, 232, 249, 0.68);\n    }\n  }\n}\n\n/* ── Big mic button ── */\n.iv-mic-big {\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  background: #7C3AED;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  transition: transform 0.15s, background 0.2s;\n\n  &:hover:not(:disabled) { transform: scale(1.08); }\n\n  &__icon { font-size: 1.9rem; line-height: 1; }\n\n  &--recording {\n    background: #DC2626;\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: -8px;\n      border-radius: 50%;\n      border: 2.5px solid rgba(220,38,38,0.55);\n      animation: iv-rec-ring 1.5s ease-out infinite;\n    }\n  }\n\n  &__ring {\n    position: absolute;\n    inset: -12px;\n    border-radius: 50%;\n    border: 2px solid rgba(220,38,38,0.4);\n    animation: iv-rec-ring 1.5s ease-out infinite 0.4s;\n  }\n\n  &--submitting { background: #374151; cursor: not-allowed; }\n\n  &--disabled {\n    background: #374151;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n\n  &:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }\n}\n\n/* ── Transcript review helpers ── */\n.iv-fullscreen__transcript-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: min(620px, 100%);\n}\n\n.iv-fullscreen__review-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(15, 23, 42, 0.82);\n  box-shadow: 0 18px 36px rgba(2, 6, 23, 0.22);\n\n  &--ready {\n    border-color: rgba(45, 212, 191, 0.28);\n    background: linear-gradient(180deg, rgba(11, 31, 42, 0.88) 0%, rgba(15, 23, 42, 0.78) 100%);\n  }\n\n  &--review {\n    border-color: rgba(245, 158, 11, 0.38);\n    background: linear-gradient(180deg, rgba(88, 52, 16, 0.34) 0%, rgba(15, 23, 42, 0.82) 100%);\n  }\n\n  &--upload {\n    border-color: rgba(96, 165, 250, 0.35);\n    background: linear-gradient(180deg, rgba(24, 55, 112, 0.34) 0%, rgba(15, 23, 42, 0.82) 100%);\n  }\n\n  &--critical {\n    border-color: rgba(248, 113, 113, 0.4);\n    background: linear-gradient(180deg, rgba(111, 29, 29, 0.36) 0%, rgba(15, 23, 42, 0.82) 100%);\n  }\n}\n\n.iv-fullscreen__review-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  strong {\n    color: #fff;\n    font-size: 0.92rem;\n    line-height: 1.35;\n  }\n\n  span {\n    color: rgba(255, 255, 255, 0.82);\n    font-size: 0.8rem;\n    line-height: 1.45;\n  }\n}\n\n.iv-fullscreen__review-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 9px;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.14);\n  border: 1px solid rgba(16, 185, 129, 0.32);\n  color: #BBF7D0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.iv-fullscreen__review-details {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 8px;\n\n  summary {\n    cursor: pointer;\n    color: rgba(255, 255, 255, 0.72);\n    font-size: 0.75rem;\n    font-weight: 600;\n    list-style: none;\n  }\n\n  summary::-webkit-details-marker {\n    display: none;\n  }\n}\n\n.iv-fullscreen__review-details-body {\n  margin-top: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  p {\n    margin: 0;\n    color: rgba(255, 255, 255, 0.78);\n    font-size: 0.74rem;\n    line-height: 1.45;\n  }\n}\n\n.iv-fullscreen__transcript-warning {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: rgba(245, 158, 11, 0.16);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  color: #FDE68A;\n  border-radius: 14px;\n  padding: 12px 14px;\n  line-height: 1.45;\n\n  strong { color: #FFF7ED; font-size: 0.92rem; }\n  span { color: rgba(255, 255, 255, 0.92); font-size: 0.86rem; }\n  small { color: rgba(255, 255, 255, 0.78); font-size: 0.75rem; }\n}\n\n.iv-fullscreen__transcript-edit {\n  width: min(620px, 100%);\n  min-height: 88px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(15, 23, 42, 0.88);\n  color: #fff;\n  padding: 12px 14px;\n  font-size: 0.93rem;\n  line-height: 1.55;\n  resize: vertical;\n  outline: none;\n  box-shadow: 0 12px 26px rgba(2, 6, 23, 0.18);\n\n  &::placeholder { color: rgba(255, 255, 255, 0.45); }\n  &:focus { border-color: rgba(99, 102, 241, 0.7); box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.18); }\n}\n\n.iv-fullscreen__transcript-confirm {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: min(620px, 100%);\n  padding: 9px 11px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(15, 23, 42, 0.52);\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.81rem;\n  line-height: 1.5;\n\n  input {\n    margin-top: 3px;\n    accent-color: #7C3AED;\n  }\n\n  span {\n    flex: 1;\n  }\n}\n\n.iv-fullscreen__review-helper {\n  width: min(620px, 100%);\n  margin: -2px 0 0;\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 0.76rem;\n  line-height: 1.45;\n  text-align: left;\n}\n\n.iv-fullscreen__video-upload-status {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: min(620px, 100%);\n  padding: 10px 12px;\n  border: 1px solid rgba(96, 165, 250, 0.3);\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.78);\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 0.78rem;\n  line-height: 1.45;\n}\n\n/* ── Animations ── */\n@keyframes iv-wave {\n  0%, 100% { transform: scaleY(0.5); opacity: 0.6; }\n  50%       { transform: scaleY(1.4); opacity: 1; }\n}\n\n@keyframes iv-rec-ring {\n  0%   { transform: scale(1);    opacity: 0.7; }\n  100% { transform: scale(1.5);  opacity: 0; }\n}\n\n@keyframes iv-typing-dot {\n  0%, 80%, 100% { opacity: 0.34; transform: translateY(0); }\n  40% { opacity: 0.9; transform: translateY(-3px); }\n}\n\n@keyframes iv-temi-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-10px); }\n}\n\n@keyframes iv-temi-breathe {\n  0%, 100% { transform: scale(0.98); opacity: 0.72; }\n  50% { transform: scale(1.05); opacity: 1; }\n}\n\n@keyframes iv-temi-pulse {\n  0%, 100% { transform: scale(1); opacity: 0.75; }\n  50% { transform: scale(1.22); opacity: 1; }\n}\n\n@keyframes iv-temi-orbit {\n  from { transform: rotate(0deg) scale(1); }\n  to { transform: rotate(360deg) scale(1); }\n}\n\n@keyframes iv-meeting-end {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes iv-exit-modal-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ── InterviewResult page ── */\n.iv-result {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 48px 24px 64px;\n  background:\n    radial-gradient(circle at 12% 12%, rgba(250, 204, 21, 0.12), transparent 24%),\n    radial-gradient(circle at 88% 10%, rgba(45, 212, 191, 0.12), transparent 28%),\n    linear-gradient(180deg, #f8fbff 0%, #f2f7fb 100%);\n\n  &--state {\n    align-items: center;\n    padding: clamp(24px, 6vw, 56px) clamp(14px, 4vw, 24px);\n    background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);\n  }\n\n  &__shell,\n  &__state-shell {\n    width: 100%;\n    max-width: 1120px;\n    position: relative;\n    z-index: 1;\n    background: rgba(255, 255, 255, 0.92);\n    border: 1px solid rgba(226, 232, 240, 0.92);\n    border-radius: 24px;\n    box-shadow:\n      0 18px 45px rgba(15, 23, 42, 0.08),\n      0 2px 0 rgba(255, 255, 255, 0.9) inset;\n    backdrop-filter: blur(14px);\n    overflow: hidden;\n  }\n\n  &__shell {\n    padding: 34px 34px 30px;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      inset: 0 auto auto 0;\n      width: 100%;\n      height: 4px;\n      background: linear-gradient(90deg, $brand-color 0%, $brand2-color 100%);\n    }\n  }\n\n  &__state-shell {\n    min-height: 320px;\n    padding: clamp(28px, 4vw, 42px);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 18px;\n    text-align: center;\n    color: #64748b;\n\n    p {\n      margin: 0;\n      max-width: 42ch;\n      line-height: 1.65;\n    }\n  }\n\n  &--state &__state-shell {\n    max-width: 680px;\n  }\n\n  &__state-shell--loading {\n    .spinner-border {\n      width: 2.75rem;\n      height: 2.75rem;\n      color: $brand-color;\n      border-width: 0.22rem;\n    }\n  }\n\n  &__state-shell--processing {\n    max-width: 720px;\n    min-height: auto;\n    align-items: stretch;\n    text-align: left;\n    padding: clamp(28px, 5vw, 48px);\n    gap: 22px;\n    border-color: rgba($brand-color, 0.16);\n    border-radius: 24px;\n    box-shadow:\n      0 22px 58px rgba(15, 23, 42, 0.08),\n      0 1px 0 rgba(255, 255, 255, 0.9) inset;\n  }\n\n  &__processing-icon {\n    position: relative;\n    width: 72px;\n    height: 72px;\n    border-radius: 22px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: $brand-color;\n    background: linear-gradient(135deg, rgba($brand-color, 0.12), rgba($brand2-color, 0.16));\n    box-shadow: 0 14px 30px rgba($brand-color, 0.16);\n\n    svg {\n      width: 30px;\n      height: 30px;\n    }\n\n    span {\n      position: absolute;\n      inset: -7px;\n      border-radius: 26px;\n      border: 2px solid rgba($brand-color, 0.14);\n      border-top-color: $brand-color;\n      animation: iv-result-processing-spin 0.9s linear infinite;\n    }\n  }\n\n  &__processing-copy {\n    display: grid;\n    gap: 10px;\n\n    h1 {\n      margin: 0;\n      color: #102a43;\n      font-size: clamp(1.55rem, 2.4vw, 2.05rem);\n      font-weight: 800;\n      line-height: 1.18;\n    }\n\n    p {\n      max-width: 58ch;\n      color: #52606d;\n      font-size: clamp(0.98rem, 1.2vw, 1.05rem);\n      line-height: 1.65;\n    }\n  }\n\n  &__processing-progress {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    color: #0f172a;\n  }\n\n  &__processing-meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    color: #334e68;\n    font-size: 0.98rem;\n    font-weight: 800;\n    line-height: 1.35;\n\n    strong {\n      min-width: 44px;\n      text-align: right;\n      color: $brand-color;\n      font-size: 1.12rem;\n      font-weight: 900;\n    }\n  }\n\n  &__processing-track {\n    height: 14px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: #e8eef4;\n    box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.06);\n  }\n\n  &__processing-fill {\n    display: block;\n    height: 100%;\n    border-radius: inherit;\n    background: $brand-color;\n    transition: width 260ms ease;\n  }\n\n  &__processing-status {\n    width: 100%;\n    max-width: none;\n    padding: 14px 16px;\n    border-radius: 16px;\n    border: 1px solid rgba($brand-color, 0.14);\n    background: rgba($brand-color, 0.06);\n    color: #334e68;\n    font-size: 0.96rem;\n    font-weight: 700;\n  }\n\n  &__state-shell &__processing-status {\n    max-width: none;\n  }\n\n  &__processing-retry {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    width: fit-content;\n    min-height: 42px;\n    padding: 0 20px;\n    border-radius: 12px;\n    border: 1px solid rgba($brand-color, 0.38);\n    background: #ffffff;\n    color: $brand-color;\n    font-weight: 800;\n    cursor: pointer;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n    transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n\n    svg {\n      width: 18px;\n      height: 18px;\n      flex-shrink: 0;\n    }\n\n    &:hover:not(:disabled) {\n      background: rgba($brand-color, 0.06);\n      border-color: $brand-color;\n      box-shadow: 0 14px 30px rgba($brand-color, 0.16);\n      transform: translateY(-1px);\n    }\n\n    &:active:not(:disabled) {\n      transform: translateY(0);\n      box-shadow: 0 8px 18px rgba($brand-color, 0.12);\n    }\n\n    &:focus-visible {\n      outline: 3px solid rgba($brand-color, 0.22);\n      outline-offset: 3px;\n    }\n\n    &:disabled {\n      opacity: 0.62;\n      cursor: not-allowed;\n      box-shadow: none;\n      transform: none;\n    }\n  }\n\n  &__header {\n    margin-bottom: 24px;\n  }\n\n  &__header-copy {\n    display: grid;\n    gap: 12px;\n  }\n\n  &__eyebrow {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    padding: 8px 14px;\n    border-radius: 999px;\n    background: rgba(13, 148, 136, 0.08);\n    border: 1px solid rgba(13, 148, 136, 0.14);\n    color: #0f766e;\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n  }\n\n  &__header-main {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__title {\n    font-size: clamp(2rem, 3vw, 2.7rem);\n    font-weight: 800;\n    letter-spacing: -0.03em;\n    color: #0f172a;\n    margin: 0;\n    line-height: 1.02;\n  }\n\n  &__meta {\n    margin-top: 8px;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: #64748b;\n    font-size: 0.92rem;\n    line-height: 1.5;\n\n    strong {\n      color: #0f172a;\n    }\n  }\n\n  &__notice {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    padding: 18px 20px;\n    border-radius: 22px;\n    margin-bottom: 22px;\n    border: 1px solid #fed7aa;\n    background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);\n\n    h3 {\n      margin: 0 0 6px;\n      font-size: 1rem;\n      font-weight: 700;\n      color: #9a3412;\n    }\n\n    p {\n      margin: 0;\n      color: #7c2d12;\n      line-height: 1.6;\n      font-size: 0.92rem;\n    }\n  }\n\n  &__notice-icon {\n    flex: 0 0 42px;\n    width: 42px;\n    height: 42px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(249, 115, 22, 0.12);\n    color: #c2410c;\n    font-size: 1.15rem;\n  }\n\n  &__hero {\n    display: grid;\n    grid-template-columns: minmax(230px, 280px) minmax(0, 1fr);\n    gap: 24px;\n    align-items: stretch;\n    padding: 26px;\n    border-radius: 24px;\n    background:\n      linear-gradient(135deg, rgba($brand-color, 0.06) 0%, rgba($brand2-color, 0.08) 100%),\n      #ffffff;\n    border: 1px solid rgba($brand-color, 0.14);\n    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);\n    margin-bottom: 24px;\n  }\n\n  &__score-panel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 0;\n  }\n\n  &__score-orb {\n    width: 100%;\n    min-height: 192px;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background:\n      linear-gradient(180deg, rgba($brand-color, 0.1) 0%, rgba($brand-color, 0.03) 100%),\n      #ffffff;\n    border: 1px solid rgba($brand-color, 0.16);\n    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);\n  }\n\n  &__score-number {\n    font-size: clamp(3.15rem, 5.4vw, 4.15rem);\n    font-weight: 850;\n    color: #0f766e;\n    line-height: 1;\n    letter-spacing: -0.05em;\n  }\n\n  &__score-label {\n    margin-top: 8px;\n    font-size: 0.82rem;\n    color: #52606d;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    font-weight: 800;\n  }\n\n  &__hero-copy {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    justify-content: center;\n  }\n\n  &__hero-kicker {\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: #0f766e;\n  }\n\n  &__hero-title {\n    font-size: clamp(1.4rem, 2.5vw, 2rem);\n    line-height: 1.2;\n    letter-spacing: -0.03em;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0;\n  }\n\n  &__hero-description {\n    font-size: 0.98rem;\n    color: #475569;\n    line-height: 1.7;\n    margin: 0;\n    max-width: 64ch;\n  }\n\n  &__hero-meta {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  &__hero-meta-card {\n    padding: 14px 16px;\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.86);\n    border: 1px solid rgba($brand-color, 0.12);\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    min-height: 108px;\n  }\n\n  &__hero-meta-icon {\n    flex: 0 0 38px;\n    width: 38px;\n    height: 38px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba($brand-color, 0.1);\n    color: #0f766e;\n    font-size: 1rem;\n  }\n\n  &__hero-meta-label {\n    display: block;\n    color: #64748b;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n  }\n\n  &__hero-meta-card strong {\n    display: block;\n    color: #0f172a;\n    font-size: 0.96rem;\n    line-height: 1.45;\n    margin-top: 2px;\n    max-width: 16ch;\n  }\n\n  &__band {\n    padding: 24px 0 0;\n    margin-bottom: 26px;\n  }\n\n  &__band-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 16px;\n    margin-bottom: 18px;\n\n    h3 {\n      margin: 0 0 6px;\n      color: #0f172a;\n      font-size: 1.1rem;\n      font-weight: 750;\n    }\n\n    p {\n      margin: 0;\n      color: #64748b;\n      font-size: 0.94rem;\n      line-height: 1.6;\n    }\n  }\n\n  &__breakdown {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 14px;\n    margin-bottom: 8px;\n  }\n\n  &__section {\n    padding: 24px 24px 22px;\n    border-radius: 20px;\n    border: 1px solid #e5edf5;\n    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n    box-shadow: 0 10px 26px rgba(15, 23, 42, 0.04);\n    margin-bottom: 22px;\n  }\n\n  &__section-head {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    margin-bottom: 12px;\n\n    h3 {\n      margin: 0 0 4px;\n      font-size: 1.05rem;\n      font-weight: 750;\n      color: #0f172a;\n    }\n\n    p {\n      margin: 0;\n      color: #64748b;\n      font-size: 0.9rem;\n      line-height: 1.5;\n    }\n  }\n\n  &__section-icon {\n    flex: 0 0 40px;\n    width: 40px;\n    height: 40px;\n    border-radius: 14px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba($brand-color, 0.1);\n    color: #0f766e;\n    font-size: 1rem;\n  }\n\n  &__section-body {\n    font-size: 0.96rem;\n    color: #334155;\n    line-height: 1.75;\n    margin: 0;\n  }\n\n  &__section--strength {\n    background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);\n    border-color: #bbf7d0;\n  }\n\n  &__section--strength .iv-result__section-icon {\n    background: rgba(34, 197, 94, 0.1);\n    color: #15803d;\n  }\n\n  &__section--weakness {\n    background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);\n    border-color: #fed7aa;\n  }\n\n  &__section--weakness .iv-result__section-icon {\n    background: rgba(249, 115, 22, 0.12);\n    color: #c2410c;\n  }\n\n  &__insight-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 16px;\n    margin-bottom: 2px;\n\n    > *:only-child {\n      grid-column: 1 / -1;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    margin-top: 26px;\n    padding-top: 24px;\n    border-top: 1px solid #e5edf5;\n\n    .iv-btn {\n      min-height: 44px;\n      border-radius: 12px;\n      transition: background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-1px);\n      }\n\n      &:focus-visible {\n        outline: 3px solid rgba($brand-color, 0.18);\n        outline-offset: 3px;\n      }\n    }\n\n    .iv-btn--primary {\n      background: $brand-color;\n      color: #ffffff;\n      box-shadow: 0 10px 24px rgba($brand-color, 0.18);\n\n      &:hover:not(:disabled) {\n        background: #0f766e;\n        box-shadow: 0 14px 30px rgba($brand-color, 0.2);\n      }\n    }\n\n    .iv-btn--outline {\n      background: #ffffff;\n      color: #0f766e;\n      border-color: rgba($brand-color, 0.42);\n\n      &:hover:not(:disabled) {\n        background: rgba($brand-color, 0.06);\n        border-color: $brand-color;\n      }\n    }\n  }\n\n  @media (max-width: 960px) {\n    padding: 32px 16px 40px;\n\n    &--state {\n      padding: 28px 16px;\n    }\n\n    &__shell,\n    &__state-shell {\n      max-width: 100%;\n    }\n\n    &__shell {\n      padding: 28px 22px 24px;\n    }\n\n    &__hero {\n      grid-template-columns: 1fr;\n      gap: 22px;\n      padding: 22px;\n    }\n\n    &__hero-meta,\n    &__breakdown,\n    &__insight-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  @media (max-width: 640px) {\n    padding: 18px 12px 28px;\n\n    &__shell {\n      padding: 22px 16px 18px;\n      border-radius: 22px;\n    }\n\n    &__state-shell {\n      min-height: 220px;\n      padding: 22px 18px;\n      border-radius: 22px;\n    }\n\n    &__state-shell--processing {\n      padding: 24px 18px;\n      gap: 18px;\n      text-align: center;\n      align-items: center;\n    }\n\n    &__processing-icon {\n      width: 64px;\n      height: 64px;\n      border-radius: 20px;\n\n      svg {\n        width: 27px;\n        height: 27px;\n      }\n\n      span {\n        border-radius: 24px;\n      }\n    }\n\n    &__processing-copy,\n    &__processing-progress,\n    &__processing-status {\n      width: 100%;\n    }\n\n    &__processing-copy p {\n      max-width: none;\n    }\n\n    &__processing-meta {\n      align-items: flex-start;\n      flex-wrap: wrap;\n      gap: 6px 12px;\n\n      strong {\n        margin-left: auto;\n      }\n    }\n\n    &__processing-retry {\n      width: 100%;\n      min-height: 46px;\n    }\n\n    &__header-main,\n    &__actions {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__hero {\n      padding: 18px;\n      border-radius: 22px;\n    }\n\n    &__score-orb {\n      min-height: 160px;\n    }\n\n    &__score-number {\n      font-size: 2.85rem;\n    }\n\n    &__section,\n    .nsc {\n      border-radius: 20px;\n    }\n\n    &__section {\n      padding: 18px 16px;\n    }\n\n    &__hero-meta-card {\n      padding: 12px 14px;\n      min-height: 0;\n    }\n\n    &__actions .iv-btn {\n      width: 100%;\n    }\n  }\n}\n\n@keyframes iv-result-processing-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── InterviewDetail page ── */\n.iv-detail {\n  width: 100%;\n  min-height: 100vh;\n  padding: 40px 24px 56px;\n  background: linear-gradient(180deg, #f7fbff 0%, #f4f7fb 100%);\n  overflow-x: clip;\n\n  &--loading, &--error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 40vh;\n    gap: 16px;\n    color: #6B7280;\n    text-align: center;\n\n    .spinner-border {\n      color: $brand-color;\n    }\n  }\n\n  &__page {\n    max-width: 1180px;\n    margin: 0 auto;\n  }\n\n  &__header {\n    display: flex;\n    align-items: stretch;\n    flex-direction: column;\n    gap: 18px;\n    margin-bottom: 28px;\n  }\n\n  &__headline {\n    display: grid;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__title-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n    flex-wrap: wrap;\n  }\n\n  &__title {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n    line-height: 1.18;\n  }\n\n  &__job-badge {\n    display: inline-flex;\n    align-items: center;\n    min-width: 0;\n    max-width: min(100%, 420px);\n    padding: 7px 12px;\n    border-radius: 999px;\n    background: #eaf9f7;\n    border: 1px solid rgba($brand-color, 0.24);\n    color: darken($brand-color, 18%);\n    font-size: 0.84rem;\n    font-weight: 800;\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__timestamp {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    min-width: 0;\n    font-size: 0.84rem;\n    color: #64748b;\n\n    svg {\n      flex: 0 0 auto;\n      color: $brand-color;\n    }\n\n    span {\n      min-width: 0;\n      overflow-wrap: anywhere;\n    }\n\n    strong {\n      color: #0f172a;\n      font-weight: 700;\n    }\n  }\n\n  &__back-btn,\n  &__state-btn {\n    align-self: flex-start;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    min-height: 42px;\n    padding: 0 16px;\n    border-radius: 14px;\n    border: 1px solid rgba($brand-color, 0.28);\n    background: #ffffff;\n    color: darken($brand-color, 14%);\n    font-size: 0.94rem;\n    font-weight: 800;\n    line-height: 1;\n    cursor: pointer;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n\n    svg {\n      flex: 0 0 auto;\n      font-size: 1rem;\n    }\n\n    &:hover {\n      transform: translateY(-1px);\n      border-color: rgba($brand-color, 0.44);\n      color: darken($brand-color, 20%);\n      box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-color: $brand-color;\n      box-shadow: 0 0 0 4px rgba($brand-color, 0.14);\n    }\n\n    &:active {\n      transform: translateY(0);\n    }\n  }\n\n  &__state-btn {\n    min-height: 44px;\n  }\n\n  &--error .iv-btn--outline {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 44px;\n    padding: 0 18px;\n    border-radius: 14px;\n    border: 1px solid rgba($brand-color, 0.32);\n    background: #ffffff;\n    color: darken($brand-color, 14%);\n    font-weight: 800;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);\n    transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n\n    &:hover {\n      transform: translateY(-1px);\n      border-color: rgba($brand-color, 0.44);\n      color: darken($brand-color, 20%);\n      box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-color: $brand-color;\n      box-shadow: 0 0 0 4px rgba($brand-color, 0.14);\n    }\n  }\n\n  &__layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 340px) minmax(0, 1fr);\n    gap: 28px;\n    align-items: start;\n  }\n\n  &__layout--single {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  &__summary-rail {\n    position: sticky;\n    top: 28px;\n    align-self: start;\n  }\n\n  &__summary-card {\n    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n    border-radius: 18px;\n    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n    border: 1px solid #dce7ef;\n    padding: 24px;\n  }\n\n  &__summary-eyebrow {\n    display: inline-flex;\n    align-items: center;\n    padding: 7px 12px;\n    border-radius: 999px;\n    background: rgba($brand-color, 0.1);\n    border: 1px solid rgba($brand-color, 0.22);\n    color: darken($brand-color, 16%);\n    font-size: 0.76rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin-bottom: 18px;\n  }\n\n  &__summary-top {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  &__summary-score-block {\n    display: grid;\n    gap: 8px;\n  }\n\n  &__final-score-label {\n    font-size: 0.84rem;\n    font-weight: 700;\n    color: #64748b;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  &__final-score {\n    font-size: 3.5rem;\n    font-weight: 800;\n    color: darken($brand-color, 10%);\n    line-height: 1;\n  }\n\n  &__score-breakdown {\n    display: grid;\n    gap: 14px;\n    padding-top: 18px;\n    margin-bottom: 18px;\n    border-top: 1px solid #e5e7eb;\n\n    .iv-score-card {\n      padding: 14px 14px 12px;\n      border-radius: 14px;\n      box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);\n    }\n\n    .iv-score-card__header {\n      margin-bottom: 10px;\n    }\n\n    .iv-score-card__label {\n      font-size: 0.88rem;\n    }\n\n    .iv-score-card__tone {\n      font-size: 0.76rem;\n    }\n\n    .iv-score-card__value {\n      font-size: 1.3rem;\n    }\n\n    .iv-score-card__track {\n      height: 8px;\n    }\n\n    .iv-score-card__footer {\n      margin-top: 10px;\n      font-size: 0.72rem;\n    }\n  }\n\n  &__summary-text {\n    font-size: 0.9rem;\n    color: #475569;\n    line-height: 1.7;\n    margin: 0;\n  }\n\n  .iv-badge {\n    background: #eaf9f7;\n    color: darken($brand-color, 18%);\n    border-color: rgba($brand-color, 0.24);\n    box-shadow: none;\n  }\n\n  .iv-badge--average {\n    background: rgba($brand-color, 0.08);\n    color: darken($brand-color, 12%);\n    border-color: rgba($brand-color, 0.18);\n  }\n\n  .iv-badge--weak {\n    background: #f8fafc;\n    color: #475569;\n    border-color: #d9e2ec;\n  }\n\n  &__content {\n    min-width: 0;\n  }\n\n  &__qa-list {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  &__qa-item {\n    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n    border-radius: 18px;\n    border: 1px solid #dce7ef;\n    padding: 22px;\n    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.05);\n    transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n  }\n\n  &__qa-item--open {\n    border-color: rgba($brand-color, 0.32);\n    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);\n  }\n\n  &__qa-meta {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 14px;\n  }\n\n  &__qa-type {\n    font-size: 0.76rem;\n    font-weight: 600;\n    padding: 5px 10px;\n    border-radius: 99px;\n    background: #eef2f7;\n    color: #475569;\n\n    &--main     { background: #dff8f5; color: #0f766e; }\n    &--followup { background: #fff4d6; color: #b45309; }\n  }\n\n  &__qa-category {\n    font-size: 0.76rem;\n    color: darken($brand-color, 16%);\n    background: #eaf9f7;\n    border: 1px solid rgba($brand-color, 0.16);\n    padding: 5px 10px;\n    border-radius: 99px;\n    font-weight: 700;\n  }\n\n  &__qa-score {\n    display: inline-flex;\n    align-items: center;\n    font-size: 0.95rem;\n    font-weight: 700;\n    margin-left: auto;\n    padding: 5px 10px;\n    border-radius: 999px;\n    border: 1px solid #d9e2ec;\n    background: #f8fafc;\n    color: #475569;\n\n    &--strong {\n      background: rgba($brand-color, 0.12);\n      border-color: rgba($brand-color, 0.28);\n      color: darken($brand-color, 18%);\n    }\n\n    &--average {\n      background: rgba($brand-color, 0.08);\n      border-color: rgba($brand-color, 0.2);\n      color: darken($brand-color, 10%);\n    }\n\n    &--weak,\n    &--neutral {\n      background: #f8fafc;\n      border-color: #d9e2ec;\n      color: #64748b;\n    }\n  }\n\n  &__question-text {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #0f172a;\n    line-height: 1.5;\n    margin: 0 0 14px;\n  }\n\n  &__answer-wrap {\n    background: #f8fafc;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    padding: 16px;\n  }\n\n  &__answer-preview {\n    overflow: hidden;\n\n    &:not(.is-open) .iv-detail__answer-text {\n      display: -webkit-box;\n      -webkit-line-clamp: 5;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n\n  &__answer-text {\n    font-size: 0.95rem;\n    color: #374151;\n    line-height: 1.75;\n    margin: 0;\n    white-space: pre-line;\n  }\n\n  &__expand-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 14px;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: darken($brand-color, 14%);\n    font-size: 0.88rem;\n    font-weight: 700;\n    cursor: pointer;\n\n    &:hover {\n      color: darken($brand-color, 20%);\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-radius: 8px;\n      box-shadow: 0 0 0 4px rgba($brand-color, 0.14);\n    }\n  }\n\n  &__expand-icon {\n    width: 16px;\n    height: 16px;\n    transform: rotate(0deg);\n    transition: transform 180ms ease;\n    flex: 0 0 auto;\n\n    &.is-open {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__feedback {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid #dde7f1;\n    color: #475569;\n\n    strong {\n      display: block;\n      font-size: 0.82rem;\n      font-weight: 800;\n      color: #0f172a;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      margin-bottom: 8px;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.88rem;\n      line-height: 1.7;\n    }\n  }\n\n  &__no-answer {\n    font-size: 0.9rem;\n    color: #94a3b8;\n    font-style: italic;\n    margin: 0;\n  }\n\n  @media (max-width: 1024px) {\n    padding: 32px 18px 48px;\n\n    &__layout {\n      grid-template-columns: minmax(0, 1fr);\n    }\n\n    &__summary-rail {\n      position: static;\n    }\n  }\n\n  @media (max-width: 640px) {\n    padding: 24px 14px 40px;\n\n    &__header {\n      gap: 16px;\n      margin-bottom: 22px;\n    }\n\n    &__back-btn {\n      min-height: 46px;\n      padding: 0 18px;\n    }\n\n    &__title-row {\n      align-items: flex-start;\n      gap: 10px;\n    }\n\n    &__title {\n      font-size: 1.5rem;\n    }\n\n    &__job-badge {\n      max-width: 100%;\n      white-space: normal;\n      overflow-wrap: anywhere;\n      text-overflow: clip;\n    }\n\n    &__summary-card,\n    &__qa-item {\n      padding: 18px;\n      border-radius: 18px;\n    }\n\n    &__summary-top {\n      gap: 16px;\n    }\n\n    &__final-score {\n      font-size: 3rem;\n    }\n\n    &__qa-score {\n      margin-left: 0;\n    }\n\n    &__expand-btn {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n}\n\n/* ── ThankYou interview banner ── */\n.thank-interview-banner {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  background: #F5F3FF;\n  border: 1.5px solid #C4B5FD;\n  border-radius: 12px;\n  padding: 16px 20px;\n  text-align: left;\n  max-width: 460px;\n  margin: 0 auto;\n\n  &__icon { font-size: 2rem; }\n\n  strong { display: block; color: #5B21B6; margin-bottom: 4px; }\n}\n\n/* ── NextStepsCard ──────────────────────────────────────────────── */\n.nsc {\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  border: 1px solid #e5edf5;\n  border-radius: 24px;\n  padding: 26px 24px;\n  margin-top: 24px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.04);\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 18px;\n  }\n\n  &__eyebrow {\n    display: inline-flex;\n    align-items: center;\n    padding: 7px 12px;\n    border-radius: 999px;\n    background: rgba($brand-color, 0.08);\n    border: 1px solid rgba($brand-color, 0.16);\n    color: #0f766e;\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    margin-bottom: 10px;\n  }\n\n  &__heading {\n    font-size: 1.18rem;\n    font-weight: 760;\n    color: #0f172a;\n    margin: 0;\n    letter-spacing: -0.02em;\n  }\n\n  &__panel {\n    border-radius: 18px;\n    padding: 20px 20px 18px;\n    margin-bottom: 16px;\n\n    &--weak {\n      background: linear-gradient(180deg, #fff7ed 0%, #ffffff 100%);\n      border: 1px solid #fed7aa;\n    }\n\n    &--strong {\n      background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);\n      border: 1px solid #bbf7d0;\n    }\n  }\n\n  &__panel-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n  }\n\n  &__badge {\n    font-size: 0.74rem;\n    font-weight: 700;\n    padding: 5px 11px;\n    border-radius: 999px;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n\n    &--weak   { background: #FED7AA; color: #9A3412; }\n    &--strong { background: #BBF7D0; color: #14532D; }\n  }\n\n  &__category {\n    font-size: 0.94rem;\n    font-weight: 700;\n    color: #334155;\n    flex: 1;\n  }\n\n  &__score {\n    font-size: 1.2rem;\n    font-weight: 800;\n    color: #0f172a;\n  }\n\n  &__bar-wrap {\n    height: 8px;\n    background: #e2e8f0;\n    border-radius: 999px;\n    overflow: hidden;\n    margin-bottom: 14px;\n  }\n\n  &__bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: $brand-color;\n    transition: width 0.6s ease;\n  }\n\n  &__ai-text {\n    font-size: 0.93rem;\n    color: #475569;\n    line-height: 1.7;\n    margin-bottom: 14px;\n  }\n\n  &__tips {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__tip {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    font-size: 0.9rem;\n    color: #334155;\n    line-height: 1.6;\n    padding: 10px 12px;\n    border-radius: 14px;\n    background: rgba(255, 255, 255, 0.7);\n    border: 1px solid rgba(226, 232, 240, 0.9);\n  }\n\n  &__tip-icon {\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    border-radius: 999px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba($brand2-color, 0.22);\n    color: #9a6a10;\n    margin-top: 1px;\n  }\n\n  &__recommendation {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 18px;\n    border-radius: 18px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    margin-bottom: 18px;\n\n    p {\n      margin: 0;\n      color: #475569;\n      font-size: 0.92rem;\n      line-height: 1.65;\n    }\n  }\n\n  &__recommendation-icon {\n    flex: 0 0 36px;\n    width: 36px;\n    height: 36px;\n    border-radius: 12px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(34, 197, 94, 0.1);\n    color: #15803d;\n    font-size: 1rem;\n    align-self: center;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-start;\n    margin-top: 8px;\n  }\n\n  &__btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    min-width: 220px;\n    padding: 12px 18px;\n    border-radius: 14px;\n    font-size: 0.92rem;\n    font-weight: 700;\n    cursor: pointer;\n    border: none;\n    transition: opacity 0.2s, transform 0.1s, border-color 0.2s, background 0.2s;\n\n    &:hover   { opacity: 0.85; transform: translateY(-1px); }\n    &:active  { transform: translateY(0); }\n    &:focus-visible {\n      outline: 3px solid rgba($brand-color, 0.18);\n      outline-offset: 3px;\n    }\n\n    &--retry  { background: $brand-color; color: #fff; }\n    &--browse {\n      background: #ffffff;\n      color: #0f766e;\n      border: 1px solid rgba($brand-color, 0.32);\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .nsc {\n    padding: 20px 16px;\n\n    &__panel {\n      padding: 18px 16px;\n    }\n\n    &__header,\n    &__actions {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__btn {\n      width: 100%;\n      min-width: 0;\n    }\n  }\n}\n\n/* ── JobList AI Interview column ── */\n.jl-status__th:last-child,\n.jl-status__td:last-child {\n  min-width: 140px;\n}\n\n.jl-iv-btn {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: opacity 0.2s;\n\n  &--start  { background: #EDE9FE; color: #5B21B6; }\n  &--resume { background: #FEF3C7; color: #92400E; }\n  &--detail { background: #F3F4F6; color: #374151; margin-top: 4px; }\n\n  &:hover { opacity: 0.8; }\n}\n\n.jl-iv-result {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n\n  &__score {\n    font-size: 1rem;\n    font-weight: 800;\n    line-height: 1;\n  }\n\n  &__badge {\n    font-size: 0.78rem;\n    font-weight: 600;\n  }\n}\n\n.jl-iv-na {\n  color: #9CA3AF;\n  font-size: 0.9rem;\n}\n\n/* ── AI TEMI Greeting Overlay ─────────────────────────────────────── */\n.iv-fullscreen {\n  &__greeting {\n    position: absolute;\n    inset: 0;\n    z-index: 20;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(10, 12, 18, 0.85);\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n  }\n\n  &__greeting-card {\n    background: rgba(15, 15, 28, 0.92);\n    border: 1px solid rgba(124, 58, 237, 0.35);\n    border-radius: 24px;\n    padding: 44px 52px;\n    width: min(480px, 90vw);\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 0 60px rgba(124, 58, 237, 0.2);\n    animation: greeting-fade-in 0.5s ease;\n  }\n\n  @keyframes greeting-fade-in {\n    from { opacity: 0; transform: translateY(20px); }\n    to   { opacity: 1; transform: translateY(0); }\n  }\n\n  &__greeting-logo {\n    font-size: 3.5rem;\n    line-height: 1;\n    margin-bottom: 4px;\n    filter: drop-shadow(0 0 12px rgba(124, 58, 237, 0.6));\n  }\n\n  &__greeting-temi-avatar {\n    width: 170px;\n    height: 200px;\n    position: relative;\n    margin: -12px 0 0;\n\n    .avatar-controller {\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  &__greeting-title {\n    font-size: 2rem;\n    font-weight: 800;\n    color: #fff;\n    margin: 0;\n    letter-spacing: -0.02em;\n  }\n\n  &__greeting-temi {\n    color: #A78BFA;\n    font-style: italic;\n  }\n\n  &__greeting-sub {\n    font-size: 0.9rem;\n    color: #9CA3AF;\n    margin: 0 0 8px;\n  }\n\n  &__ai-speaking--center {\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    color: #A78BFA;\n    font-size: 0.85rem;\n    display: flex;\n    margin: 4px 0;\n  }\n\n  /* small modifier for iv-btn */\n  .iv-btn--sm {\n    padding: 8px 18px;\n    font-size: 0.85rem;\n  }\n\n  &__transcribing {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #A78BFA;\n    font-size: 0.88rem;\n    font-weight: 500;\n    padding: 8px 0;\n    animation: pulse 1.5s ease infinite;\n  }\n\n  @keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.55; }\n  }\n}\n\n@media (max-width: 768px) {\n  .iv-fullscreen {\n    &--review {\n      .iv-fullscreen__temi-stage {\n        padding: 0;\n      }\n\n      .iv-fullscreen__temi-status {\n        bottom: 134px;\n      }\n\n      .iv-fullscreen__candidate-pip {\n        left: 12px;\n        right: 12px;\n        top: 12px;\n        bottom: 44vh;\n      }\n\n      .iv-fullscreen__bottom-bar {\n        padding: 16px 12px 14px;\n        gap: 8px;\n      }\n    }\n\n    &__temi-stage {\n      right: 18px;\n      bottom: calc(44vh + 12px);\n      width: 104px;\n      height: 108px;\n      padding: 0;\n      border-radius: 16px;\n\n      .avatar-controller,\n      .iv-temi {\n        width: 74%;\n        height: 74%;\n        transform: translateY(-14px);\n      }\n    }\n\n    &__temi-status {\n      bottom: 152px;\n      max-width: calc(100vw - 32px);\n      font-size: 0.78rem;\n    }\n\n    &__candidate-pip {\n      left: 12px;\n      right: 12px;\n      top: 12px;\n      bottom: 44vh;\n      width: auto;\n      border-radius: 14px;\n      border-width: 3px;\n    }\n\n    &__candidate-label {\n      left: 16px;\n      bottom: 10px;\n      max-width: calc(100% - 146px);\n      min-height: 32px;\n      padding: 6px 10px;\n      gap: 8px;\n      font-size: 0.78rem;\n\n      > span:first-child {\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .iv-soundwave {\n        flex: 0 0 auto;\n        transform: scale(0.86);\n        transform-origin: right center;\n      }\n    }\n\n    &__temi-card-label {\n      left: 8px;\n      right: 8px;\n      bottom: 8px;\n      min-height: 28px;\n      padding: 5px 8px;\n      gap: 6px;\n      font-size: 0.74rem;\n\n      > span:first-child {\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .iv-soundwave {\n        flex: 0 0 auto;\n        transform: scale(0.78);\n        transform-origin: right center;\n      }\n    }\n\n    &__job-caption {\n      left: 12px;\n      bottom: 28px;\n      max-width: calc(100vw - 116px);\n      font-size: 0.82rem;\n    }\n\n    &__conversation-panel {\n      left: 12px;\n      right: 12px;\n      top: auto;\n      bottom: 92px;\n      width: auto;\n      height: 34vh;\n      max-height: none;\n      border-radius: 14px;\n    }\n\n    &--transcript-closed {\n      .iv-fullscreen__candidate-pip {\n        right: 12px;\n      }\n\n      .iv-fullscreen__temi-stage {\n        right: 18px;\n      }\n    }\n\n    &__conversation-head {\n      padding: 12px 13px 10px;\n    }\n\n    &__conversation-body {\n      padding: 10px;\n      gap: 9px;\n    }\n\n    &__conversation-turn {\n      padding: 9px 10px;\n\n      p {\n        font-size: 0.8rem;\n        line-height: 1.48;\n      }\n    }\n\n    &__question-wrap {\n      top: 50px;\n      width: calc(100vw - 24px);\n    }\n\n    &__question-card {\n      padding: 16px 18px;\n      border-radius: 16px;\n    }\n\n    &__question-text {\n      font-size: 0.98rem;\n      line-height: 1.55;\n    }\n\n    &__bottom-bar {\n      padding: 24px 14px 20px;\n    }\n\n    &__quick-actions {\n      right: 12px;\n      bottom: 18px;\n      gap: 8px;\n    }\n\n    &__quick-btn {\n      width: 40px;\n      height: 40px;\n      border-radius: 11px;\n    }\n\n    &__exit-card {\n      grid-template-columns: 1fr;\n      gap: 12px;\n      padding: 18px;\n    }\n\n    &__exit-icon {\n      width: 46px;\n      height: 46px;\n      border-radius: 13px;\n    }\n\n    &__exit-actions {\n      flex-direction: column;\n    }\n\n    &__exit-btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n\n  .avatar-controller {\n    width: min(72vw, 300px);\n    height: min(92vw, 390px);\n  }\n\n  .iv-fullscreen__transcript-wrap,\n  .iv-fullscreen__transcript-edit,\n  .iv-fullscreen__transcript-confirm,\n  .iv-fullscreen__review-helper {\n    width: 100%;\n  }\n}\n\n@media (max-height: 860px) and (min-width: 769px) {\n  .iv-fullscreen {\n    &__question-wrap {\n      top: 42px;\n      width: min(90vw, 620px);\n    }\n\n    &__question-card {\n      padding: 16px 20px;\n    }\n\n    &__question-text {\n      max-width: 58ch;\n      font-size: 1rem;\n      line-height: 1.52;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
